(window.theme = window.theme || {}),
  (window.Shopify = window.Shopify || {}),
  (theme.config = {
    bpSmall: !1,
    hasSessionStorage: !0,
    hasLocalStorage: !0,
    mediaQuerySmall: "screen and (max-width: 769px)",
    youTubeReady: !1,
    vimeoReady: !1,
    vimeoLoading: !1,
    isTouch:
      !!(
        "ontouchstart" in window ||
        (window.DocumentTouch && window.document instanceof DocumentTouch)
      ) ||
      !!window.navigator.maxTouchPoints ||
      !!window.navigator.msMaxTouchPoints,
    stickyHeader: !1,
    rtl: "rtl" == document.documentElement.getAttribute("dir"),
  }),
  theme.config.isTouch &&
    (document.documentElement.className += " supports-touch"),
  console &&
    console.log &&
    console.log(
      "Impulse theme (" +
        theme.settings.themeVersion +
        ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
    ),
  (theme.recentlyViewed = { recent: {}, productInfo: {} }),
  (function () {
    "use strict";
    var e, t, s, n, a, o, r, c;
    (theme.delegate = {
      on: function (e, t, s) {
        return (
          this.namespaces || (this.namespaces = {}),
          (this.namespaces[e] = t),
          (s = s || !1),
          this.addEventListener(e.split(".")[0], t, s),
          this
        );
      },
      off: function (e) {
        if (this.namespaces)
          return (
            this.removeEventListener(e.split(".")[0], this.namespaces[e]),
            delete this.namespaces[e],
            this
          );
      },
    }),
      (window.on = Element.prototype.on = theme.delegate.on),
      (window.off = Element.prototype.off = theme.delegate.off),
      (theme.utils = {
        defaultTo: function (e, t) {
          return null == e || e != e ? t : e;
        },
        wrap: function (e, t) {
          e.parentNode.insertBefore(t, e), t.appendChild(e);
        },
        debounce: function (e, t, s) {
          var n;
          return function () {
            var a = this,
              o = arguments,
              r = function () {
                (n = null), s || t.apply(a, o);
              },
              c = s && !n;
            clearTimeout(n), (n = setTimeout(r, e)), c && t.apply(a, o);
          };
        },
        throttle: function (e, t) {
          var s = !1;
          return function () {
            s ||
              (t.apply(this, arguments),
              (s = !0),
              setTimeout(function () {
                s = !1;
              }, e));
          };
        },
        prepareTransition: function (e, t) {
          function s(t) {
            e.classList.remove("is-transitioning"),
              e.removeEventListener("transitionend", s);
          }
          e.addEventListener("transitionend", s),
            e.classList.add("is-transitioning"),
            e.offsetWidth,
            "function" == typeof t && t();
        },
        compact: function (e) {
          for (
            var t = -1, s = null == e ? 0 : e.length, n = 0, a = [];
            ++t < s;      

          ) {
            var o = e[t];
            o && (a[n++] = o);
          }
          return a;
        },
        serialize: function (e) {
          var t = [];
          return (
            Array.prototype.slice.call(e.elements).forEach(function (e) {
              if (
                !(
                  !e.name ||
                  e.disabled ||
                  ["file", "reset", "submit", "button"].indexOf(e.type) > -1
                )
              ) {
                if ("select-multiple" === e.type) {
                  Array.prototype.slice.call(e.options).forEach(function (s) {
                    s.selected &&
                      t.push(
                        encodeURIComponent(e.name) +
                          "=" +
                          encodeURIComponent(s.value)
                      );
                  });
                  return;
                }
                (!(["checkbox", "radio"].indexOf(e.type) > -1) || e.checked) &&
                  t.push(
                    encodeURIComponent(e.name) +
                      "=" +
                      encodeURIComponent(e.value)
                  );
              }
            }),
            t.join("&")
          );
        },
      }),
      (theme.a11y = {
        trapFocus: function (e) {
          var t = {
              focusin: e.namespace ? "focusin." + e.namespace : "focusin",
              focusout: e.namespace ? "focusout." + e.namespace : "focusout",
              keydown: e.namespace
                ? "keydown." + e.namespace
                : "keydown.handleFocus",
            },
            s = e.container.querySelectorAll(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
            ),
            n = [].slice.call(s).filter((e) => null !== e.offsetParent),
            a = n[0],
            o = n[n.length - 1];
          e.elementToFocus || (e.elementToFocus = e.container),
            e.container.setAttribute("tabindex", "-1"),
            e.elementToFocus.focus(),
            document.documentElement.off("focusin"),
            document.documentElement.on(t.focusout, function () {
              document.documentElement.off(t.keydown);
            }),
            document.documentElement.on(t.focusin, function (e) {
              (e.target === o || e.target === a) &&
                document.documentElement.on(t.keydown, function (e) {
                  var t;
                  (t = e),
                    9 === t.keyCode &&
                      t.target === a &&
                      t.shiftKey &&
                      (t.preventDefault(), o.focus());
                });
            });
        },
        removeTrapFocus: function (e) {
          var t = e.namespace ? "focusin." + e.namespace : "focusin";
          e.container && e.container.removeAttribute("tabindex"),
            document.documentElement.off(t);
        },
        lockMobileScrolling: function (e, t) {
          var s = t || document.documentElement;
          document.documentElement.classList.add("lock-scroll"),
            s.on("touchmove" + e, function () {
              return !0;
            });
        },
        unlockMobileScrolling: function (e, t) {
          document.documentElement.classList.remove("lock-scroll"),
            (t || document.documentElement).off("touchmove" + e);
        },
      }),
      document.documentElement.on("keyup.tab", function (e) {
        9 === e.keyCode &&
          (document.documentElement.classList.add("tab-outline"),
          document.documentElement.off("keyup.tab"));
      }),
      (theme.Currency =
        ((e = theme && theme.settings && theme.settings.superScriptPrice),
        {
          formatMoney: function t(s, n) {
            n || (n = theme.settings.moneyFormat),
              "string" == typeof s && (s = s.replace(".", ""));
            var a = "",
              o = /\{\{\s*(\w+)\s*\}\}/,
              r = n || "${{amount}}";
            function c(e, t, s, n) {
              if (
                ((t = theme.utils.defaultTo(t, 2)),
                (s = theme.utils.defaultTo(s, ",")),
                (n = theme.utils.defaultTo(n, ".")),
                isNaN(e) || null == e)
              )
                return 0;
              var a,
                o = (e = (e / 100).toFixed(t)).split(".");
              return (
                o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s) +
                (o[1] ? n + o[1] : "")
              );
            }
            switch (r.match(o)[1]) {
              case "amount":
                (a = c(s, 2)),
                  e &&
                    a &&
                    a.includes(".") &&
                    (a = a.replace(".", "<sup>") + "</sup>");
                break;
              case "amount_no_decimals":
                a = c(s, 0);
                break;
              case "amount_with_comma_separator":
                (a = c(s, 2, ".", ",")),
                  e &&
                    a &&
                    a.includes(",") &&
                    (a = a.replace(",", "<sup>") + "</sup>");
                break;
              case "amount_no_decimals_with_comma_separator":
                a = c(s, 0, ".", ",");
                break;
              case "amount_no_decimals_with_space_separator":
                a = c(s, 0, " ");
            }
            return r.replace(o, a);
          },
          getBaseUnit: function e(t) {
            if (
              t &&
              t.unit_price_measurement &&
              t.unit_price_measurement.reference_value
            )
              return 1 === t.unit_price_measurement.reference_value
                ? t.unit_price_measurement.reference_unit
                : t.unit_price_measurement.reference_value +
                    t.unit_price_measurement.reference_unit;
          },
        })),
      (theme.Images = {
        imageSize: function e(t) {
          if (!t) return "620x";
          var s = t.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
          );
          return null !== s ? s[1] : null;
        },
        getSizedImageUrl: function e(t, s) {
          if (!t || null == s) return t;
          if ("master" === s) return this.removeProtocol(t);
          var n = t.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
          );
          if (null != n) {
            var a = t.split(n[0]),
              o = n[0];
            return this.removeProtocol(a[0] + "_" + s + o);
          }
          return null;
        },
        removeProtocol: function e(t) {
          return t.replace(/http(s)?:/, "");
        },
        buildImagePath: function e(t, s) {
          if (null == t) return [];
          if (!s) return [t];
          {
            let n = [];
            return (
              s.forEach((e) => {
                let a = `${t}?width=${e}`;
                e === s[s.length - 1] ? (a += ` ${e}w`) : (a += ` ${e}w,`),
                  n.push(a);
              }),
              n
            );
          }
        },
      }),
      (theme.initWhenVisible = function (e) {
        var t = e.threshold ? e.threshold : 0;
        new IntersectionObserver(
          (t, s) => {
            t.forEach((t) => {
              t.isIntersecting &&
                "function" == typeof e.callback &&
                (e.callback(), s.unobserve(t.target));
            });
          },
          { rootMargin: "0px 0px " + t + "px 0px" }
        ).observe(e.element);
      }),
      (theme.LibraryLoader =
        ((s = { requested: "requested", loaded: "loaded" }),
        (n = "https://cdn.shopify.com/shopifycloud/"),
        (a = {
          youtubeSdk: {
            tagId: "youtube-sdk",
            src: "https://www.youtube.com/iframe_api",
            type: (t = { link: "link", script: "script" }).script,
          },
          vimeo: {
            tagId: "vimeo-api",
            src: "https://player.vimeo.com/api/player.js",
            type: t.script,
          },
          shopifyXr: {
            tagId: "shopify-model-viewer-xr",
            src: n + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
            type: t.script,
          },
          modelViewerUi: {
            tagId: "shopify-model-viewer-ui",
            src: n + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
            type: t.script,
          },
          modelViewerUiStyles: {
            tagId: "shopify-model-viewer-ui-styles",
            src: n + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
            type: t.link,
          },
        }),
        {
          load: function e(n, o) {
            var r,
              c = a[n];
            if (c && c.status !== s.requested) {
              if (((o = o || function () {}), c.status === s.loaded)) {
                o();
                return;
              }
              switch (((c.status = s.requested), c.type)) {
                case t.script:
                  r =
                    ((l = c),
                    (d = o),
                    (h = document.createElement("script")),
                    (h.src = l.src),
                    h.addEventListener("load", function () {
                      (l.status = s.loaded), d();
                    }),
                    h);
                  break;
                case t.link:
                  r =
                    ((u = c),
                    (p = o),
                    (m = document.createElement("link")),
                    (m.href = u.src),
                    (m.rel = "stylesheet"),
                    (m.type = "text/css"),
                    m.addEventListener("load", function () {
                      (u.status = s.loaded), p();
                    }),
                    m);
              }
              (r.id = c.tagId), (c.element = r);
              var l,
                d,
                h,
                u,
                p,
                m,
                f = document.getElementsByTagName(c.type)[0];
              f.parentNode.insertBefore(r, f);
            }
          },
        })),
      (theme.rteInit = function () {
        function e(e) {
          e.src = e.src;
          var t = document.createElement("div");
          t.classList.add("video-wrapper"), theme.utils.wrap(e, t);
        }
        document.querySelectorAll(".rte table").forEach((e) => {
          var t = document.createElement("div");
          t.classList.add("table-wrapper"), theme.utils.wrap(e, t);
        }),
          document
            .querySelectorAll('.rte iframe[src*="youtube.com/embed"]')
            .forEach((t) => {
              e(t);
            }),
          document
            .querySelectorAll('.rte iframe[src*="player.vimeo"]')
            .forEach((t) => {
              e(t);
            }),
          document.querySelectorAll(".rte a img").forEach((e) => {
            e.parentNode.classList.add("rte__image");
          });
      }),
      (theme.Sections = function e() {
        (this.constructors = {}),
          (this.instances = []),
          document.addEventListener(
            "shopify:section:load",
            this._onSectionLoad.bind(this)
          ),
          document.addEventListener(
            "shopify:section:unload",
            this._onSectionUnload.bind(this)
          ),
          document.addEventListener(
            "shopify:section:select",
            this._onSelect.bind(this)
          ),
          document.addEventListener(
            "shopify:section:deselect",
            this._onDeselect.bind(this)
          ),
          document.addEventListener(
            "shopify:block:select",
            this._onBlockSelect.bind(this)
          ),
          document.addEventListener(
            "shopify:block:deselect",
            this._onBlockDeselect.bind(this)
          );
      }),
      (theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
        _createInstance: function (e, t, s) {
          var n = e.getAttribute("data-section-id"),
            a = e.getAttribute("data-section-type");
          if (void 0 !== (t = t || this.constructors[a])) {
            s && this._findInstance(n) && this._removeInstance(n);
            try {
              var o = Object.assign(new t(e), { id: n, type: a, container: e });
              this.instances.push(o);
            } catch (r) {
              console.error(r);
            }
          }
        },
        _findInstance: function (e) {
          for (var t = 0; t < this.instances.length; t++)
            if (this.instances[t].id === e) return this.instances[t];
        },
        _removeInstance: function (e) {
          for (var t, s = this.instances.length; s--; )
            if (this.instances[s].id === e) {
              (t = this.instances[s]), this.instances.splice(s, 1);
              break;
            }
          return t;
        },
        _onSectionLoad: function (e, t, s) {
          window.AOS && AOS.refreshHard(),
            theme && theme.initGlobals && theme.initGlobals();
          var n = t || e.target,
            a = t || e.target.querySelector("[data-section-id]");
          if (a) {
            this._createInstance(a);
            var o = t ? s : this._findInstance(e.detail.sectionId);
            n.querySelectorAll("[data-subsection]").length &&
              this.loadSubSections(n),
              o && "function" == typeof o.onLoad && o.onLoad(e),
              setTimeout(function () {
                window.dispatchEvent(new Event("scroll"));
              }, 200);
          }
        },
        _onSectionUnload: function (e) {
          this.instances = this.instances.filter(function (t) {
            var s = t.id === e.detail.sectionId;
            return s && "function" == typeof t.onUnload && t.onUnload(e), !s;
          });
        },
        loadSubSections: function (e) {
          e &&
            e.querySelectorAll("[data-section-id]").forEach((e) => {
              this._onSectionLoad(null, e, e.dataset.sectionId);
            });
        },
        _onSelect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          void 0 !== t && "function" == typeof t.onSelect && t.onSelect(e);
        },
        _onDeselect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          void 0 !== t && "function" == typeof t.onDeselect && t.onDeselect(e);
        },
        _onBlockSelect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          void 0 !== t &&
            "function" == typeof t.onBlockSelect &&
            t.onBlockSelect(e);
        },
        _onBlockDeselect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          void 0 !== t &&
            "function" == typeof t.onBlockDeselect &&
            t.onBlockDeselect(e);
        },
        register: function (e, t, s) {
          this.constructors[e] = t;
          var n = document.querySelectorAll('[data-section-type="' + e + '"]');
          s && (n = s.querySelectorAll('[data-section-type="' + e + '"]')),
            n.forEach(
              function (e) {
                this._createInstance(e, t, s);
              }.bind(this)
            );
        },
        reinit: function (e) {
          for (var t = 0; t < this.instances.length; t++) {
            var s = this.instances[t];
            s.type === e &&
              "function" == typeof s.forceReload &&
              s.forceReload();
          }
        },
      })),
      (theme.Variants = (function () {
        function e(e) {
          (this.container = e.container),
            (this.variants = e.variants),
            (this.singleOptionSelector = e.singleOptionSelector),
            (this.originalSelectorId = e.originalSelectorId),
            (this.enableHistoryState = e.enableHistoryState),
            (this.dynamicVariantsEnabled = e.dynamicVariantsEnabled),
            (this.currentlySelectedValues = this._getCurrentOptions()),
            (this.currentVariant = this._getVariantFromOptions()),
            this.container
              .querySelectorAll(this.singleOptionSelector)
              .forEach((e) => {
                e.addEventListener("change", this._onSelectChange.bind(this));
              });
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            _getCurrentOptions: function () {
              var e = [];
              return (
                this.container
                  .querySelectorAll(this.singleOptionSelector)
                  .forEach((t) => {
                    var s = t.getAttribute("type");
                    "radio" === s || "checkbox" === s
                      ? t.checked &&
                        e.push({ value: t.value, index: t.dataset.index })
                      : e.push({ value: t.value, index: t.dataset.index });
                  }),
                (e = theme.utils.compact(e))
              );
            },
            _numberFromOptionKey: function (e) {
              return parseInt(e.substr(-1));
            },
            _getWeightedOptionMatchCount: function (e) {
              return this._getCurrentOptions().reduce(
                (t, { value: s, index: n }) => {
                  let a = this._numberFromOptionKey(n);
                  return e[n] === s ? t + (4 - a) : t;
                },
                0
              );
            },
            _getFullMatch(e) {
              let t = this._getCurrentOptions(),
                s = this.variants;
              return s.find((s) => {
                let n = t.every(({ value: e, index: t }) => s[t] === e);
                return e ? n && s.available : n;
              });
            },
            _getClosestAvailableMatch: function (e) {
              if (!e) return null;
              let t = this._getCurrentOptions(),
                s = this.variants,
                n =
                  e &&
                  s.filter(
                    (s) =>
                      t
                        .filter(
                          ({ value: t, index: s }) =>
                            this._numberFromOptionKey(s) <=
                            this._numberFromOptionKey(e.index)
                        )
                        .every(({ value: e, index: t }) => s[t] === e) &&
                      s.available
                  );
              return n.reduce((t, s) => {
                if (null === t) return s;
                let n = this._getWeightedOptionMatchCount(t, e),
                  a = this._getWeightedOptionMatchCount(s, e);
                return a > n ? s : t;
              }, null);
            },
            _getVariantFromOptions: function (e) {
              let t = this._getFullMatch(!0),
                s = this._getClosestAvailableMatch(e),
                n = this._getFullMatch(!1);
              return this.dynamicVariantsEnabled
                ? t || s || n || null
                : n || null;
            },
            _updateInputState: function (e, t) {
              return (t) => {
                if (null === e) return;
                let s = t.dataset.index,
                  n = t.value,
                  a = t.getAttribute("type");
                "radio" === a || "checkbox" === a
                  ? (t.checked = e[s] === n)
                  : (t.value = e[s]);
              };
            },
            _onSelectChange: function ({ srcElement: e }) {
              window._this_ = this;
              window._this_e = e;
              let t = this.container.querySelectorAll(
                  this.singleOptionSelector
                ),
                s = this._getVariantFromOptions({
                  index: e.dataset.index,
                  value: e.value,
                });
              t.forEach(this._updateInputState(s, e));
              let n = (this.currentlySelectedValues =
                  this._getCurrentOptions()),
                a = {
                  variant: s,
                  currentlySelectedValues: n,
                  value: e.value,
                  index: e.parentElement.dataset.index,
                };
              console.log('sss', s);
              console.log('aaa', a);
              this.container.dispatchEvent(
                new CustomEvent("variantChange", { detail: a })
              ),
                document.dispatchEvent(
                  new CustomEvent("variant:change", { detail: a })
                ),
                s &&
                  (this._updateMasterSelect(s),
                  this._updateImages(s),
                  this._updatePrice(s),
                  this._updateUnitPrice(s),
                  this._updateSKU(s),
                  (this.currentVariant = s),
                  this.enableHistoryState && this._updateHistoryState(s));
            },
            _updateImages: function (e) {
              var t = e.featured_image || {},
                s =
                  (this.currentVariant && this.currentVariant.featured_image) ||
                  {};
              e.featured_image &&
                t.src !== s.src &&
                this.container.dispatchEvent(
                  new CustomEvent("variantImageChange", {
                    detail: { variant: e },
                  })
                );
            },
            _updatePrice: function (e) {
             // $('.muurverfpage_quantity .js-qty__num').val(1);
              if (
                !this.currentVariant ||
                e.price !== this.currentVariant.price ||
                e.compare_at_price !== this.currentVariant.compare_at_price
              ) {
                this.container.dispatchEvent(
                  new CustomEvent("variantPriceChange", {
                    detail: { variant: e },
                  })
                );
                var t = theme.Currency.formatMoney(
                    e.price,
                    theme.settings.moneyFormat
                  ),
                  s = e.title.split(" / ");
                "Essential" == s[1]
                  ? ($(
                      ".img_with_txts + .faq_img .left-side-faq[data-tag='Essential']"
                    ).attr("style", "display:block"),
                    $(
                      ".img_with_txts + .faq_img .left-side-faq[data-tag='Classic']"
                    ).attr("style", "display:none"),
                    $(
                      ".img_with_txts + .faq_img .left-side-faq[data-tag='Superior']"
                    ).attr("style", "display:none"))
                  : "Classic" == s[1]
                  ? ($(
                      ".img_with_txts + .faq_img .left-side-faq[data-tag='Essential']"
                    ).attr("style", "display:none"),
                    $(
                      ".img_with_txts + .faq_img .left-side-faq[data-tag='Classic']"
                    ).attr("style", "display:block"),
                    $(
                      ".img_with_txts + .faq_img .left-side-faq[data-tag='Superior']"
                    ).attr("style", "display:none"))
                  : "Superior" == s[1] &&
                    ($(
                      ".img_with_txts + .faq_img .left-side-faq[data-tag='Essential']"
                    ).attr("style", "display:none"),
                    $(
                      ".img_with_txts + .faq_img .left-side-faq[data-tag='Classic']"
                    ).attr("style", "display:none"),
                    $(
                      ".img_with_txts + .faq_img .left-side-faq[data-tag='Superior']"
                    ).attr("style", "display:block"));
                var o = e.id,
                  r = $(
                    '.product-single__variants .preorder[value="' + o + '"]'
                  ).attr("deliver_time");
                $(
                  '.product-single__variants .preorder[value="' + o + '"]'
                ).attr("preorder") && $("span.button-texter").text("pre-order"),
                  r
                    ? ($(".delivery-times").show(),
                      $(".delivery-times #countdowns").text(r))
                    : $(".delivery-times").hide();
              }
            },
            _updateUnitPrice: function (e) {
              (!this.currentVariant ||
                e.unit_price !== this.currentVariant.unit_price) &&
                this.container.dispatchEvent(
                  new CustomEvent("variantUnitPriceChange", {
                    detail: { variant: e },
                  })
                );
            },
            _updateSKU: function (e) {
              (!this.currentVariant || e.sku !== this.currentVariant.sku) &&
                this.container.dispatchEvent(
                  new CustomEvent("variantSKUChange", {
                    detail: { variant: e },
                  })
                );
            },
            _updateHistoryState: function (e) {
              if (history.replaceState && e) {
                if($('body').hasClass('ctm-new')){
               
                const dattaprice = $('.ctm-new .product-block .variant-wrapper .variant-input-wrap:not([name=Kleur]) input:checked+label').attr("data-original-price") || 0;
                const discount = $('.ctm-new .product-block .variant-wrapper .variant-input-wrap:not([name=Kleur]) input:checked+label').attr("data-discount") || 0;
                const dataDiscprice = $('.ctm-new .product-block .variant-wrapper .variant-input-wrap:not([name=Kleur]) input:checked+label').attr("data-final-price") || 0; 
                const datacompareprice = $('.ctm-new .product-block .variant-wrapper .variant-input-wrap:not([name=Kleur]) input:checked+label').attr("data-compare-price") || 0;
                var dattapriceNum = parseFloat(dattaprice.replace(/[^0-9.]/g, ''));

                var dataDiscpriceNum = parseFloat(dataDiscprice.replace(/[^0-9.]/g, ''));
                function cleanPrice(price) {
                if (!price) return 0;
                let clean = price.toString().replace(/[€\s\-]/g, '');
                clean = clean.replace(',', '.');
                clean = clean.replace(/[^0-9.]/g, '');
                return parseFloat(clean);
                }

            var dattapriceNum = cleanPrice(dattaprice);
            var dataDiscpriceNum = cleanPrice(dataDiscprice);
            var datacomparepriceNum = cleanPrice(datacompareprice);

            console.log('Prices:', dattaprice, dataDiscprice);
            console.log('dataDiscpriceNum', dataDiscpriceNum);
            console.log('datacompareprice', datacomparepriceNum);

            const qty_val = $("input.js-qty__num").val();
            // if (dattapriceNum !== dataDiscpriceNum && dataDiscpriceNum != 'NaN') {
            if (!isNaN(dattapriceNum) && !isNaN(dataDiscpriceNum) && dattapriceNum !== dataDiscpriceNum) {
              console.log('if case');
              $('.totaal-prices .product__price').text(dattaprice);
              $('.pdp-total-price .act-price').addClass('line_thorugh');
              let dattaprice1 = '€' + parseFloat(dattaprice.replace(/[^0-9.]/g, '')).toFixed(0) + ',-';
              $('.pdp-total-price .act-price').text(dattaprice1);
              $('.pdp-total .act-price').attr('data-cmpare-price',dattaprice.replace('€', '').trim());
              var dattapriceQty = dattaprice.replace('€', '').trim();
              var totalDiscDataPrice = parseFloat(dattapriceQty) * parseInt(qty_val);
            // console.log('totalQty  ',totalDiscDataPrice);
              $('.pdp-total-price .act-price').text('€'+totalDiscDataPrice+',-');
              let formattedPrice = '€' + parseFloat(dataDiscprice.replace(/[^0-9.]/g, '')).toFixed(0) + ',-';
              $('.pdp-total-price .disc-price').text(formattedPrice);
              $('.pdp-total .disc-price').attr('data-disc-price',dataDiscprice.replace('€', '').trim());
              var cleanPriceQty = dataDiscprice.replace('€', '').trim();
              var totalDisc = parseFloat(cleanPriceQty) * parseInt(qty_val);
            // console.log('totalQty  ',totalQty);
              $('.pdp-total-price .disc-price').text('€'+totalDisc+',-');
            } else {
              console.log('price')
              $('.pdp-total .act-price').attr('data-cmpare-price',dataDiscpriceNum);
              $('.pdp-total .disc-price').attr('data-disc-price',datacomparepriceNum);
              $('.totaal-prices .product__price').text(dattaprice);
              $('.pdp-total-price .act-price').removeClass('line_thorugh');
              let formattedPrice = '€' + parseFloat(dattaprice.replace(/[^0-9.]/g, '')).toFixed(0) + ',-';
              // let formattedcomparePrice = '€' + parseFloat(datacompareprice.replace(/[^0-9.]/g, '')).toFixed(0) + ',-';
              $('.pdp-total-price .act-price').text('€' + dattapriceNum + ',-');
              // $('.pdp-total-price .disc-price').text(formattedcomparePrice);
            }
            }
               
                  $('.description_for_pro .variants-metafield[varidd="' + e.id + '"]')
                    .siblings()
                    .removeClass("variant-title-show"),
                   $('.description_for_pro .variants-metafield').hide(),
                  $('.description_for_pro .variants-metafield[varidd="' + e.id + '"]').addClass(
                    "variant-title-show"
                  ),
                  $('.variants-imges[variantid="' + e.id + '"]')
                    .siblings()
                    .removeClass("variant-show-img"),
                  $('.variants-imges[variantid="' + e.id + '"]').addClass(
                    "variant-show-img"
                  ); 
               
                
                var t =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  window.location.pathname +
                  "?variant=" +
                  e.id;
                window.history.replaceState({ path: t }, "", t),
                  console.log(e.option2);
                var s = e.id,
                  n = $(
                    '.product-single__variants .preorder[value="' + s + '"]'
                  ).attr("deliver_time");
                $(
                  '.product-single__variants .preorder[value="' + s + '"]'
                ).attr("preorder") && $("span.button-texter").text("pre-order"),
                  n
                    ? ($(".delivery-times").show(),
                      $(".delivery-times #countdowns").text(n))
                    : $(".delivery-times").hide();
              }
               if($('body').hasClass('lakverf')){ 
                 var sel1= $('body.lakverf fieldset[name="Afwerking"] .variant-input input:checked').val();
              $('body.lakverf fieldset[name="Inhoud"] .variant__button-label img').hide();
              $('body.lakverf fieldset[name="Inhoud"] .variant__button-label img[varissecond="'+sel1+'"]').show();
               }
              if($('body').hasClass('muurverf-page')){
                   document.querySelector('.product-block.product-block--price').classList.remove('hided-price');
                   $('body.muurverf-page .pro_thumb[match="true"]').removeClass('display');
                   $('body.muurverf-page .pro_thumb[match="true"][data-product="'+e.id+'"]').addClass('display');
                  var t = theme.Currency.formatMoney(
                    e.price,
                    theme.settings.moneyFormat
                  );
                   a = t.replace(",00", ",-");
                 $(".totaal-prices").attr("pro_price", e.price / 100);
                  $(".totaal-prices span.product__price").text(a);
              }
            },
            _updateMasterSelect: function (e) {
              let t = this.container.querySelector(this.originalSelectorId);
              t &&
                ((t.value = e.id),
                t.dispatchEvent(new Event("change", { bubbles: !0 })));
            },
          })),
          e
        );
      })()),
      (window.vimeoApiReady = function () {
        var e, t;
        (theme.config.vimeoLoading = !0),
          new Promise((s, n) => {
            (e = setInterval(function () {
              Vimeo && (clearInterval(e), clearTimeout(t), s());
            }, 500)),
              (t = setTimeout(function () {
                clearInterval(e), n();
              }, 4e3));
          }).then(function () {
            (theme.config.vimeoReady = !0),
              (theme.config.vimeoLoading = !1),
              document.dispatchEvent(new CustomEvent("vimeoReady"));
          });
      }),
      (theme.VimeoPlayer = (function () {
        var e = {
            loading: "loading",
            loaded: "loaded",
            interactable: "video-interactable",
          },
          t = {
            byline: !1,
            loop: !0,
            muted: !0,
            playsinline: !0,
            portrait: !1,
            title: !1,
          };
        function s(e, t, s) {
          (this.divId = e),
            (this.el = document.getElementById(e)),
            (this.videoId = t),
            (this.iframe = null),
            (this.options = s),
            this.options &&
              this.options.videoParent &&
              (this.parent = this.el.closest(this.options.videoParent)),
            this.setAsLoading(),
            theme.config.vimeoReady
              ? this.init()
              : (theme.LibraryLoader.load("vimeo", window.vimeoApiReady),
                document.addEventListener("vimeoReady", this.init.bind(this)));
        }
        return (
          (s.prototype = Object.assign({}, s.prototype, {
            init: function () {
              var e = t;
              (e.id = this.videoId),
                (this.videoPlayer = new Vimeo.Player(this.el, e)),
                this.videoPlayer.ready().then(this.playerReady.bind(this));
            },
            playerReady: function () {
              (this.iframe = this.el.querySelector("iframe")),
                this.iframe.setAttribute("tabindex", "-1"),
                "false" === this.options.loop && this.videoPlayer.setLoop(!1),
                "sound" === this.options.style
                  ? this.videoPlayer.setVolume(1)
                  : this.videoPlayer.setVolume(0),
                this.setAsLoaded(),
                new IntersectionObserver(
                  (e, t) => {
                    e.forEach((e) => {
                      e.isIntersecting ? this.play() : this.pause();
                    });
                  },
                  { rootMargin: "0px 0px 50px 0px" }
                ).observe(this.iframe);
            },
            setAsLoading: function () {
              this.parent && this.parent.classList.add(e.loading);
            },
            setAsLoaded: function () {
              this.parent &&
                (this.parent.classList.remove(e.loading),
                this.parent.classList.add(e.loaded),
                this.parent.classList.add(e.interactable),
                Shopify &&
                  Shopify.designMode &&
                  window.AOS &&
                  AOS.refreshHard());
            },
            enableInteraction: function () {
              this.parent && this.parent.classList.add(e.interactable);
            },
            play: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.play &&
                this.videoPlayer.play();
            },
            pause: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.pause &&
                this.videoPlayer.pause();
            },
            destroy: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.destroy &&
                this.videoPlayer.destroy();
            },
          })),
          s
        );
      })()),
      (window.onYouTubeIframeAPIReady = function () {
        (theme.config.youTubeReady = !0),
          document.dispatchEvent(new CustomEvent("youTubeReady"));
      }),
      (theme.YouTube = (function () {
        var e = {
            loading: "loading",
            loaded: "loaded",
            interactable: "video-interactable",
          },
          t = {
            width: 1280,
            height: 720,
            playerVars: {
              autohide: 0,
              autoplay: 1,
              cc_load_policy: 0,
              controls: 0,
              fs: 0,
              iv_load_policy: 3,
              modestbranding: 1,
              playsinline: 1,
              rel: 0,
            },
          };
        function s(e, s) {
          (this.divId = e),
            (this.iframe = null),
            (this.attemptedToPlay = !1),
            (t.events = {
              onReady: this.onVideoPlayerReady.bind(this),
              onStateChange: this.onVideoStateChange.bind(this),
            }),
            (this.options = Object.assign({}, t, s)),
            this.options &&
              (this.options.videoParent &&
                (this.parent = document
                  .getElementById(this.divId)
                  .closest(this.options.videoParent)),
              this.options.autoplay ||
                (this.options.playerVars.autoplay = this.options.autoplay),
              "sound" === this.options.style &&
                ((this.options.playerVars.controls = 1),
                (this.options.playerVars.autoplay = 0))),
            this.setAsLoading(),
            theme.config.youTubeReady
              ? this.init()
              : (theme.LibraryLoader.load("youtubeSdk"),
                document.addEventListener(
                  "youTubeReady",
                  this.init.bind(this)
                ));
        }
        return (
          (s.prototype = Object.assign({}, s.prototype, {
            init: function () {
              this.videoPlayer = new YT.Player(this.divId, this.options);
            },
            onVideoPlayerReady: function (e) {
              (this.iframe = document.getElementById(this.divId)),
                this.iframe.setAttribute("tabindex", "-1"),
                "sound" !== this.options.style && e.target.mute(),
                new IntersectionObserver(
                  (e, t) => {
                    e.forEach((e) => {
                      e.isIntersecting ? this.play() : this.pause();
                    });
                  },
                  { rootMargin: "0px 0px 50px 0px" }
                ).observe(this.iframe);
            },
            onVideoStateChange: function (e) {
              switch (e.data) {
                case -1:
                  this.attemptedToPlay &&
                    (this.setAsLoaded(), this.enableInteraction());
                  break;
                case 0:
                  this.play(e);
                  break;
                case 1:
                  this.setAsLoaded();
                  break;
                case 3:
                  this.attemptedToPlay = !0;
              }
            },
            setAsLoading: function () {
              this.parent && this.parent.classList.add(e.loading);
            },
            setAsLoaded: function () {
              this.parent &&
                (this.parent.classList.remove(e.loading),
                this.parent.classList.add(e.loaded),
                Shopify &&
                  Shopify.designMode &&
                  window.AOS &&
                  AOS.refreshHard());
            },
            enableInteraction: function () {
              this.parent && this.parent.classList.add(e.interactable);
            },
            play: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.playVideo &&
                this.videoPlayer.playVideo();
            },
            pause: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.pauseVideo &&
                this.videoPlayer.pauseVideo();
            },
            destroy: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.destroy &&
                this.videoPlayer.destroy();
            },
          })),
          s
        );
      })()),
      (r = !1),
      document.body.addEventListener("touchstart", function (e) {
        if (!e.target.closest(".flickity-slider")) return (r = !1);
        (r = !0), (o = { x: e.touches[0].pageX, y: e.touches[0].pageY });
      }),
      document.body.addEventListener(
        "touchmove",
        function (e) {
          r &&
            e.cancelable &&
            Math.abs(
              { x: e.touches[0].pageX - o.x, y: e.touches[0].pageY - o.y }.x
            ) > Flickity.defaults.dragThreshold &&
            e.preventDefault();
        },
        { passive: !1 }
      ),
      (theme.AjaxRenderer = (function () {
        function e({ sections: e, onReplace: t, debug: s } = {}) {
          (this.sections = e || []),
            (this.cachedSections = []),
            (this.onReplace = t),
            (this.debug = Boolean(s));
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            renderPage: function (e, t, s = !0) {
              let n = new URLSearchParams(window.location.search),
                a = this.getUpdatedParams(n, t),
                o = this.sections.map((t) => {
                  let s = `${e}?section_id=${t.sectionId}&${a.toString()}`,
                    n = (e) => e.url === s;
                  return this.cachedSections.some(n)
                    ? this.renderSectionFromCache(n, t)
                    : this.renderSectionFromFetch(s, t);
                });
              return s && this.updateURLHash(a), Promise.all(o);
            },
            renderSectionFromCache: function (e, t) {
              let s = this.cachedSections.find(e);
              return (
                this.log(`[AjaxRenderer] rendering from cache: url=${s.url}`),
                this.renderSection(s.html, t),
                Promise.resolve(t)
              );
            },
            renderSectionFromFetch: function (e, t) {
              return (
                this.log(`[AjaxRenderer] redering from fetch: url=${e}`),
                new Promise((s, n) => {
                  fetch(e)
                    .then((e) => e.text())
                    .then((n) => {
                      let a = n;
                      (this.cachedSections = [
                        ...this.cachedSections,
                        { html: a, url: e },
                      ]),
                        this.renderSection(a, t),
                        s(t);
                    })
                    .catch((e) => n(e));
                })
              );
            },
            renderSection: function (e, t) {
              this.log(
                `[AjaxRenderer] rendering section: section=${JSON.stringify(t)}`
              );
              let s = new DOMParser().parseFromString(e, "text/html");
              if (this.onReplace) this.onReplace(s, t);
              else if ("string" == typeof t.nodeId) {
                var n = s.getElementById(t.nodeId);
                if (!n) return;
                document.getElementById(t.nodeId).innerHTML = n.innerHTML;
              } else
                t.nodeId.forEach((e) => {
                  document.getElementById(e).innerHTML =
                    s.getElementById(e).innerHTML;
                });
              return t;
            },
            getUpdatedParams: function (e, t) {
              let s = new URLSearchParams(e),
                n = ["sort_by", "q", "options[prefix]", "type"];
              for (let [a, o] of s.entries())
                t.getAll(a).includes(o) || n.includes(a) || s.delete(a);
              for (let [r, c] of t.entries())
                s.getAll(r).includes(c) || "" === c || s.append(r, c);
              return s;
            },
            updateURLHash: function (e) {
              history.pushState(
                {},
                "",
                `${window.location.pathname}${e && "?".concat(e)}`
              );
            },
            log: function (...e) {
              this.debug && console.log(...e);
            },
          })),
          e
        );
      })()),
      window.Shopify &&
        window.Shopify.theme &&
        navigator &&
        navigator.sendBeacon &&
        window.Shopify.designMode &&
        navigator.sendBeacon(
          "https://api.archetypethemes.co/api/beacon",
          new URLSearchParams({
            shop: window.Shopify.shop,
            themeName:
              window.theme &&
              window.theme.settings &&
              `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
            role: window.Shopify.theme.role,
            route: window.location.pathname,
            themeId: window.Shopify.theme.id,
            themeStoreId: window.Shopify.theme.theme_store_id || 0,
            isThemeEditor: !!window.Shopify.designMode,
          })
        ),
      (theme.cart = {
        getCart: function () {
          return fetch("".concat(theme.routes.cart, "?t=").concat(Date.now()), {
            credentials: "same-origin",
            method: "GET",
          }).then((e) => e.json());
        },
        getCartProductMarkup: function () {
          var e = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());
          return fetch(
            (e = -1 === e.indexOf("?") ? e + "?view=ajax" : e + "&view=ajax"),
            { credentials: "same-origin", method: "GET" }
          ).then(function (e) {
            return e.text();
          });
        },
        changeItem: function (e, t) {
          return this._updateCart({
            url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
            data: JSON.stringify({ id: e, quantity: t }),
          });
        },
        _updateCart: function (e) {
          return fetch(e.url, {
            method: "POST",
            body: e.data,
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          })
            .then((e) => e.json())
            .then(function (e) {
              return e;
            });
        },
        updateAttribute: function (e, t) {
          return this._updateCart({
            url: "/cart/update.js",
            data: JSON.stringify({
              attributes: { [e]: theme.cart.attributeToString(t) },
            }),
          });
        },
        updateNote: function (e) {
          return this._updateCart({
            url: "/cart/update.js",
            data: JSON.stringify({ note: theme.cart.attributeToString(e) }),
          });
        },
        attributeToString: function (e) {
          return (
            "string" != typeof e && "undefined" == (e += "") && (e = ""),
            e.trim()
          );
        },
      }),
      (theme.CartForm = (function () {
        var e = {
            products: "[data-products]",
            qtySelector: ".js-qty__wrapper",
            discounts: "[data-discounts]",
            savings: "[data-savings]",
            subTotal: "[data-subtotal]",
            cartBubble: ".cart-link__bubble",
            cartNote: '[name="note"]',
            termsCheckbox: ".cart__terms-checkbox",
            checkoutBtn: ".cart__checkout",
          },
          t = { btnLoading: "btn--loading" },
          s = { requiresTerms: !1 };
        function n(t) {
          t &&
            ((this.form = t),
            (this.wrapper = t.parentNode),
            (this.location = t.dataset.location),
            (this.namespace = ".cart-" + this.location),
            (this.products = t.querySelector(e.products)),
            (this.submitBtn = t.querySelector(e.checkoutBtn)),
            (this.discounts = t.querySelector(e.discounts)),
            (this.savings = t.querySelector(e.savings)),
            (this.subtotal = t.querySelector(e.subTotal)),
            (this.termsCheckbox = t.querySelector(e.termsCheckbox)),
            (this.noteInput = t.querySelector(e.cartNote)),
            (this.cartItemsUpdated = !1),
            this.termsCheckbox && (s.requiresTerms = !0),
            this.init());
        }
        return (
          (n.prototype = Object.assign({}, n.prototype, {
            init: function () {
              this.initQtySelectors(),
                document.addEventListener(
                  "cart:quantity" + this.namespace,
                  this.quantityChanged.bind(this)
                ),
                this.form.on(
                  "submit" + this.namespace,
                  this.onSubmit.bind(this)
                ),
                this.noteInput &&
                  this.noteInput.addEventListener("change", function () {
                    var e = this.value;
                    theme.cart.updateNote(e);
                  }),
                document.addEventListener(
                  "cart:build",
                  function () {
                    this.buildCart();
                  }.bind(this)
                );
            },
            reInit: function () {
              this.initQtySelectors();
            },
            onSubmit: function (e) {
              return (this.submitBtn.classList.add(t.btnLoading),
              "submit" === e.type && (this.cartItemsUpdated = !1),
              (document.documentElement.classList.contains("js-drawer-open") &&
                this.cartItemsUpdated) ||
                (document.documentElement.classList.contains("cart-open") &&
                  this.cartItemsUpdated))
                ? (this.submitBtn.classList.remove(t.btnLoading),
                  e.preventDefault(),
                  !1)
                : s.requiresTerms && !this.termsCheckbox.checked
                ? (alert(theme.strings.cartTermsConfirmation),
                  this.submitBtn.classList.remove(t.btnLoading),
                  e.preventDefault(),
                  !1)
                : void 0;
            },
            _parseProductHTML: function (e) {
              var t = new DOMParser().parseFromString(e, "text/html");
              return {
                items: t.querySelector(".cart__items"),
                discounts: t.querySelector(".cart__discounts"),
              };
            },
            buildCart: function () {
              theme.cart
                .getCartProductMarkup()
                .then(this.cartMarkup.bind(this));
            },
            cartMarkup: function (e) {
              var t = this._parseProductHTML(e),
                s = t.items,
                n = parseInt(s.dataset.count),
                a = s.dataset.cartSubtotal,
                o = s.dataset.cartSavings;
              this.updateCartDiscounts(t.discounts),
                this.updateSavings(o),
                n > 0
                  ? this.wrapper.classList.remove("is-empty")
                  : this.wrapper.classList.add("is-empty"),
                this.updateCount(n),
                (this.products.innerHTML = ""),
                this.products.append(s);
              let r =
                this.products.querySelector(".cart__image img") ||
                this.products.querySelector(".cart__image svg");
              r &&
                0 === r.naturalWidth &&
                0 === r.naturalHeight &&
                this.products
                  .querySelectorAll("img")
                  .forEach((e) => (e.outerHTML = e.outerHTML));
              var c = theme.Currency.formatMoney(
                a,
                theme.settings.moneyFormat
              ).replace(",00", ",-");
              $(".subtotals").text(c),
                this.reInit(),
                window.AOS && AOS.refreshHard(),
                Shopify &&
                  Shopify.StorefrontExpressButtons &&
                  Shopify.StorefrontExpressButtons.initialize();
            },
            updateCartDiscounts: function (e) {
              this.discounts &&
                ((this.discounts.innerHTML = ""), this.discounts.append(e));
            },
            initQtySelectors: function () {
              this.form.querySelectorAll(e.qtySelector).forEach((e) => {
                console.log("here2");
             
                new theme.QtySelector(e, {
                  namespace: this.namespace,
                  isCart: !0,
                });
              });
            },
            quantityChanged: function (e) {
              var t = e.detail[0],
                s = e.detail[1],
                n = e.detail[2];
              t &&
                s &&
                (n && n.classList.add("is-loading"),
                ("cart:quantity.cart-cart-drawer" === e.type ||
                  "cart:quantity.cart-header" === e.type) &&
                  (console.log("evt", e), (this.cartItemsUpdated = !0)),
                theme.cart
                  .changeItem(t, s)
                  .then(
                    function (n) {
                      let a = n.items.find((e) => e.key === t);
                      ((a && "cart:quantity.cart-cart-drawer" === e.type) ||
                        (a && "cart:quantity.cart-header" === e.type)) &&
                        (a.quantity !== s &&
                          alert(
                            theme.strings.maxQuantity
                              .replace("[quantity]", a.quantity)
                              .replace("[title]", a.title)
                          ),
                        (this.cartItemsUpdated = !1)),
                        n.item_count > 0
                          ? this.wrapper.classList.remove("is-empty")
                          : this.wrapper.classList.add("is-empty"),
                        this.buildCart(),
                        document.dispatchEvent(
                          new CustomEvent("cart:updated", {
                            detail: { cart: n },
                          })
                        );
                    }.bind(this)
                  )
                  .catch(function (e) {}));
            },
            updateSubtotal: function (t) {
              this.form.querySelector(e.subTotal).innerHTML =
                theme.Currency.formatMoney(t, theme.settings.moneyFormat);
            },
            updateSavings: function (e) {
              if (this.savings) {
                if (e > 0) {
                  var t = theme.Currency.formatMoney(
                    e,
                    theme.settings.moneyFormat
                  );
                  this.savings.classList.remove("hide"),
                    (this.savings.innerHTML = theme.strings.cartSavings.replace(
                      "[savings]",
                      t
                    ));
                } else this.savings.classList.add("hide");
              }
            },
            updateCount: function (t) {
              var s = document.querySelectorAll(".cart-link__bubble-num");
              s.length &&
                s.forEach((e) => {
                  e.innerText = t;
                });
              var n = document.querySelectorAll(e.cartBubble);
              n.length &&
                (t > 0
                  ? n.forEach((e) => {
                      e.classList.add("cart-link__bubble--visible");
                    })
                  : n.forEach((e) => {
                      e.classList.remove("cart-link__bubble--visible");
                    }));
            },
          })),
          n
        );
      })()),
      (theme.collapsibles = (function () {
        var e = {
            trigger: ".collapsible-trigger",
            module: ".collapsible-content",
            moduleInner: ".collapsible-content__inner",
            tabs: ".collapsible-trigger--tab",
          },
          t = {
            hide: "hide",
            open: "is-open",
            autoHeight: "collapsible--auto-height",
            tabs: "collapsible-trigger--tab",
          },
          s = ".collapsible",
          n = !1;
        function a(a) {
          if (!n) {
            n = !0;
            var r,
              c = a.currentTarget,
              l = c.classList.contains(t.open),
              d = c.classList.contains(t.tabs),
              h = c.getAttribute("aria-controls"),
              u = document.getElementById(h);
            if ((h || (h = c.dataset.controls), h)) {
              if (
                (!u &&
                  document.querySelectorAll('[data-id="' + h + '"]').length >
                    0 &&
                  (u = c.parentNode.querySelector('[data-id="' + h + '"]')),
                !u)
              ) {
                n = !1;
                return;
              }
              var p = u.querySelector(e.moduleInner).offsetHeight,
                m = u.classList.contains(t.autoHeight),
                f = u.parentNode.closest(e.module),
                g = p;
              if (d) {
                if (l) {
                  n = !1;
                  return;
                }
                document
                  .querySelectorAll(e.tabs + '[data-id="' + c.dataset.id + '"]')
                  .forEach((e) => {
                    e.classList.remove(t.open),
                      o(
                        (r = document.querySelector(
                          "#" + e.getAttribute("aria-controls")
                        )),
                        0,
                        !0
                      );
                  });
              }
              if (
                (l &&
                  m &&
                  setTimeout(function () {
                    o(u, (p = 0), l, m);
                  }, 0),
                l && !m && (p = 0),
                c.setAttribute("aria-expanded", !l),
                l ? c.classList.remove(t.open) : c.classList.add(t.open),
                o(u, p, l, m),
                f)
              ) {
                var v = f.style.height;
                l && "auto" === v && (g = 0);
                var y = l ? f.offsetHeight - g : p + f.offsetHeight;
                o(f, y, !1, !1);
              }
              if (window.SPR) {
                var b = u.querySelector(".spr-summary-actions-newreview");
                if (!b) return;
                b.off("click" + s),
                  b.on("click" + s, function () {
                    (p = u.querySelector(e.moduleInner).offsetHeight),
                      o(u, p, l, m);
                  });
              }
            }
          }
        }
        function o(e, s, a, o) {
          if (
            (e.classList.remove(t.hide),
            theme.utils.prepareTransition(e, function () {
              (e.style.height = s + "px"),
                a ? e.classList.remove(t.open) : e.classList.add(t.open);
            }),
            !a && o)
          ) {
            var r = e;
            window.setTimeout(function () {
              r.css("height", "auto"), (n = !1);
            }, 500);
          } else n = !1;
        }
        return {
          init: function n(o) {
            (o || document).querySelectorAll(e.trigger).forEach((e) => {
              var n = e.classList.contains(t.open);
              e.setAttribute("aria-expanded", n),
                e.off("click" + s),
                e.on("click" + s, a);
            });
          },
        };
      })()),
      (theme.Disclosure = (function () {
        var e = {
            disclosureForm: "[data-disclosure-form]",
            disclosureList: "[data-disclosure-list]",
            disclosureToggle: "[data-disclosure-toggle]",
            disclosureInput: "[data-disclosure-input]",
            disclosureOptions: "[data-disclosure-option]",
          },
          t = { listVisible: "disclosure-list--visible" };
        function s(e) {
          (this.container = e), this._cacheSelectors(), this._setupListeners();
        }
        return (
          (s.prototype = Object.assign({}, s.prototype, {
            _cacheSelectors: function () {
              this.cache = {
                disclosureForm: this.container.closest(e.disclosureForm),
                disclosureList: this.container.querySelector(e.disclosureList),
                disclosureToggle: this.container.querySelector(
                  e.disclosureToggle
                ),
                disclosureInput: this.container.querySelector(
                  e.disclosureInput
                ),
                disclosureOptions: this.container.querySelectorAll(
                  e.disclosureOptions
                ),
              };
            },
            _setupListeners: function () {
              (this.eventHandlers = this._setupEventHandlers()),
                this.cache.disclosureToggle.addEventListener(
                  "click",
                  this.eventHandlers.toggleList
                ),
                this.cache.disclosureOptions.forEach(function (e) {
                  e.addEventListener(
                    "click",
                    this.eventHandlers.connectOptions
                  );
                }, this),
                this.container.addEventListener(
                  "keyup",
                  this.eventHandlers.onDisclosureKeyUp
                ),
                this.cache.disclosureList.addEventListener(
                  "focusout",
                  this.eventHandlers.onDisclosureListFocusOut
                ),
                this.cache.disclosureToggle.addEventListener(
                  "focusout",
                  this.eventHandlers.onDisclosureToggleFocusOut
                ),
                document.body.addEventListener(
                  "click",
                  this.eventHandlers.onBodyClick
                );
            },
            _setupEventHandlers: function () {
              return {
                connectOptions: this._connectOptions.bind(this),
                toggleList: this._toggleList.bind(this),
                onBodyClick: this._onBodyClick.bind(this),
                onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
                onDisclosureListFocusOut:
                  this._onDisclosureListFocusOut.bind(this),
                onDisclosureToggleFocusOut:
                  this._onDisclosureToggleFocusOut.bind(this),
              };
            },
            _connectOptions: function (e) {
              e.preventDefault(),
                this._submitForm(e.currentTarget.dataset.value);
            },
            _onDisclosureToggleFocusOut: function (e) {
              !1 === this.container.contains(e.relatedTarget) &&
                this._hideList();
            },
            _onDisclosureListFocusOut: function (e) {
              var s = e.currentTarget.contains(e.relatedTarget);
              this.cache.disclosureList.classList.contains(t.listVisible) &&
                !s &&
                this._hideList();
            },
            _onDisclosureKeyUp: function (e) {
              27 === e.which &&
                (this._hideList(), this.cache.disclosureToggle.focus());
            },
            _onBodyClick: function (e) {
              var s = this.container.contains(e.target);
              this.cache.disclosureList.classList.contains(t.listVisible) &&
                !s &&
                this._hideList();
            },
            _submitForm: function (e) {
              (this.cache.disclosureInput.value = e),
                this.cache.disclosureForm.submit();
            },
            _hideList: function () {
              this.cache.disclosureList.classList.remove(t.listVisible),
                this.cache.disclosureToggle.setAttribute("aria-expanded", !1);
            },
            _toggleList: function () {
              var e =
                "true" ===
                this.cache.disclosureToggle.getAttribute("aria-expanded");
              this.cache.disclosureList.classList.toggle(t.listVisible),
                this.cache.disclosureToggle.setAttribute("aria-expanded", !e);
            },
            destroy: function () {
              this.cache.disclosureToggle.removeEventListener(
                "click",
                this.eventHandlers.toggleList
              ),
                this.cache.disclosureOptions.forEach(function (e) {
                  e.removeEventListener(
                    "click",
                    this.eventHandlers.connectOptions
                  );
                }, this),
                this.container.removeEventListener(
                  "keyup",
                  this.eventHandlers.onDisclosureKeyUp
                ),
                this.cache.disclosureList.removeEventListener(
                  "focusout",
                  this.eventHandlers.onDisclosureListFocusOut
                ),
                this.cache.disclosureToggle.removeEventListener(
                  "focusout",
                  this.eventHandlers.onDisclosureToggleFocusOut
                ),
                document.body.removeEventListener(
                  "click",
                  this.eventHandlers.onBodyClick
                );
            },
          })),
          s
        );
      })()),
      (theme.Drawers = (function () {
        function e(e, t) {
          (this.config = {
            id: e,
            close: ".js-drawer-close",
            open: ".js-drawer-open-" + t,
            openClass: "js-drawer-open",
            closingClass: "js-drawer-closing",
            activeDrawer: "drawer--is-open",
            namespace: ".drawer-" + t,
          }),
            (this.nodes = { page: document.querySelector("#MainContent") }),
            (this.drawer = document.querySelector("#" + e)),
            (this.isOpen = !1),
            this.drawer && this.init();
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            init: function () {
              document.querySelectorAll(this.config.open).forEach((e) => {
                e.setAttribute("aria-expanded", "false"),
                  e.addEventListener("click", this.open.bind(this));
              }),
                this.drawer
                  .querySelector(this.config.close)
                  .addEventListener("click", this.close.bind(this)),
                document.addEventListener(
                  "modalOpen",
                  function () {
                    this.close();
                  }.bind(this)
                );
            },
            open: function (e, t) {
              e && e.preventDefault(),
                !this.isOpen &&
                  (e && e.stopPropagation
                    ? (e.stopPropagation(),
                      e.currentTarget.setAttribute("aria-expanded", "true"),
                      (this.activeSource = e.currentTarget))
                    : t &&
                      (t.setAttribute("aria-expanded", "true"),
                      (this.activeSource = t)),
                  theme.utils.prepareTransition(
                    this.drawer,
                    function () {
                      this.drawer.classList.add(this.config.activeDrawer);
                    }.bind(this)
                  ),
                  document.documentElement.classList.add(this.config.openClass),
                  (this.isOpen = !0),
                  theme.a11y.trapFocus({
                    container: this.drawer,
                    namespace: "drawer_focus",
                  }),
                  document.dispatchEvent(new CustomEvent("drawerOpen")),
                  document.dispatchEvent(
                    new CustomEvent("drawerOpen." + this.config.id)
                  ),
                  this.bindEvents());
            },
            close: function (e) {
              if (this.isOpen) {
                if (e) {
                  if (e.target.closest(".js-drawer-close"));
                  else if (e.target.closest(".drawer")) return;
                }
                document.activeElement.blur(),
                  theme.utils.prepareTransition(
                    this.drawer,
                    function () {
                      this.drawer.classList.remove(this.config.activeDrawer);
                    }.bind(this)
                  ),
                  document.documentElement.classList.remove(
                    this.config.openClass
                  ),
                  document.documentElement.classList.add(
                    this.config.closingClass
                  ),
                  window.setTimeout(
                    function () {
                      document.documentElement.classList.remove(
                        this.config.closingClass
                      ),
                        this.activeSource &&
                          this.activeSource.getAttribute("aria-expanded") &&
                          (this.activeSource.setAttribute(
                            "aria-expanded",
                            "false"
                          ),
                          this.activeSource.focus());
                    }.bind(this),
                    500
                  ),
                  (this.isOpen = !1),
                  theme.a11y.removeTrapFocus({
                    container: this.drawer,
                    namespace: "drawer_focus",
                  }),
                  this.unbindEvents();
              }
            },
            bindEvents: function () {
              window.on(
                "click" + this.config.namespace,
                function (e) {
                  this.close(e);
                }.bind(this)
              ),
                window.on(
                  "keyup" + this.config.namespace,
                  function (e) {
                    27 === e.keyCode && this.close();
                  }.bind(this)
                ),
                theme.a11y.lockMobileScrolling(
                  this.config.namespace,
                  this.nodes.page
                );
            },
            unbindEvents: function () {
              window.off("click" + this.config.namespace),
                window.off("keyup" + this.config.namespace),
                theme.a11y.unlockMobileScrolling(
                  this.config.namespace,
                  this.nodes.page
                );
            },
          })),
          e
        );
      })()),
      (theme.Modals = (function () {
        function e(e, t, s) {
          if (
            ((this.id = e),
            (this.modal = document.getElementById(e)),
            !this.modal)
          )
            return !1;
          (this.modalContent = this.modal.querySelector(".modal__inner")),
            (this.config = Object.assign(
              {
                close: ".js-modal-close",
                open: ".js-modal-open-" + t,
                openClass: "modal--is-active",
                closingClass: "modal--is-closing",
                bodyOpenClass: ["modal-open"],
                bodyOpenSolidClass: "modal-open--solid",
                bodyClosingClass: "modal-closing",
                closeOffContentClick: !0,
              },
              s
            )),
            (this.modalIsOpen = !1),
            (this.focusOnOpen = this.config.focusIdOnOpen
              ? document.getElementById(this.config.focusIdOnOpen)
              : this.modal),
            (this.isSolid = this.config.solid),
            this.init();
        }
        return (
          (e.prototype.init = function () {
            document.querySelectorAll(this.config.open).forEach((e) => {
              e.setAttribute("aria-expanded", "false"),
                e.addEventListener("click", this.open.bind(this));
            }),
              this.modal.querySelectorAll(this.config.close).forEach((e) => {
                e.addEventListener("click", this.close.bind(this));
              }),
              document.addEventListener(
                "drawerOpen",
                function () {
                  this.close();
                }.bind(this)
              );
          }),
          (e.prototype.open = function (e) {
            var t = !1;
            !this.modalIsOpen &&
              (e ? e.preventDefault() : (t = !0),
              e &&
                e.stopPropagation &&
                (e.stopPropagation(),
                (this.activeSource = e.currentTarget.setAttribute(
                  "aria-expanded",
                  "true"
                ))),
              this.modalIsOpen && !t && this.close(),
              this.modal.classList.add(this.config.openClass),
              document.documentElement.classList.add(
                ...this.config.bodyOpenClass
              ),
              this.isSolid &&
                document.documentElement.classList.add(
                  this.config.bodyOpenSolidClass
                ),
              (this.modalIsOpen = !0),
              theme.a11y.trapFocus({
                container: this.modal,
                elementToFocus: this.focusOnOpen,
                namespace: "modal_focus",
              }),
              document.dispatchEvent(new CustomEvent("modalOpen")),
              document.dispatchEvent(new CustomEvent("modalOpen." + this.id)),
              this.bindEvents());
          }),
          (e.prototype.close = function (e) {
            if (this.modalIsOpen) {
              if (e) {
                if (e.target.closest(".js-modal-close"));
                else if (e.target.closest(".modal__inner")) return;
              }
              document.activeElement.blur(),
                this.modal.classList.remove(this.config.openClass),
                this.modal.classList.add(this.config.closingClass),
                document.documentElement.classList.remove(
                  ...this.config.bodyOpenClass
                ),
                document.documentElement.classList.add(
                  this.config.bodyClosingClass
                ),
                window.setTimeout(
                  function () {
                    document.documentElement.classList.remove(
                      this.config.bodyClosingClass
                    ),
                      this.modal.classList.remove(this.config.closingClass),
                      this.activeSource &&
                        this.activeSource.getAttribute("aria-expanded") &&
                        this.activeSource
                          .setAttribute("aria-expanded", "false")
                          .focus();
                  }.bind(this),
                  500
                ),
                this.isSolid &&
                  document.documentElement.classList.remove(
                    this.config.bodyOpenSolidClass
                  ),
                (this.modalIsOpen = !1),
                theme.a11y.removeTrapFocus({
                  container: this.modal,
                  namespace: "modal_focus",
                }),
                document.dispatchEvent(
                  new CustomEvent("modalClose." + this.id)
                ),
                this.unbindEvents();
            }
          }),
          (e.prototype.bindEvents = function () {
            window.on(
              "keyup.modal",
              function (e) {
                27 === e.keyCode && this.close();
              }.bind(this)
            ),
              this.config.closeOffContentClick &&
                this.modal.on("click.modal", this.close.bind(this));
          }),
          (e.prototype.unbindEvents = function () {
            document.documentElement.off(".modal"),
              this.config.closeOffContentClick && this.modal.off(".modal");
          }),
          e
        );
      })());
    class l extends HTMLElement {
      constructor() {
        super(),
          (this.parallaxImage = this.querySelector("[data-parallax-image]")),
          (this.windowInnerHeight = window.innerHeight),
          (this.isActive = !1),
          (this.timeout = null),
          (this.directionMap = { right: 0, top: 90, left: 180, bottom: 270 }),
          (this.directionMultipliers = {
            0: [1, 0],
            90: [0, -1],
            180: [-1, 0],
            270: [0, 1],
          }),
          this.init(),
          window.addEventListener("scroll", () => this.scrollHandler());
      }
      getParallaxInfo() {
        let {
            width: e,
            height: t,
            top: s,
          } = this.parallaxImage.getBoundingClientRect(),
          n = this.parallaxImage,
          a,
          { angle: o, movement: r } = n.dataset,
          c =
            "top" === o
              ? Math.ceil(t * (parseFloat(r) / 100))
              : Math.ceil(e * (parseFloat(r) / 100));
        (o = this.directionMap[o] ?? parseFloat(o)) != o && (o = 270),
          c != c && (c = 100),
          (o %= 360) < 0 && (o += 360);
        let l = o > 90 && o < 270,
          d = o < 180;
        if (
          ((n.style[l ? "left" : "right"] = 0),
          (n.style[d ? "top" : "bottom"] = 0),
          o % 90)
        ) {
          let h = (o * Math.PI) / 180;
          a = [Math.cos(h), -1 * Math.sin(h)];
        } else a = this.directionMultipliers[o];
        return (
          a[0] && (n.style.width = `calc(100% + ${c * Math.abs(a[0])}px)`),
          a[1] && (n.style.height = `calc(100% + ${c * Math.abs(a[1])}px)`),
          { element: n, movementPixels: c, multipliers: a, top: s, height: t }
        );
      }
      init() {
        let {
            element: e,
            movementPixels: t,
            multipliers: s,
            top: n,
            height: a,
          } = this.getParallaxInfo(),
          o = this.windowInnerHeight - n,
          r = this.windowInnerHeight + a,
          c = o / r;
        if (c > -0.1 && c < 1.1) {
          let l = Math.min(Math.max(c, 0), 1) * t;
          e.style.transform = `translate3d(${l * s[0]}px, ${l * s[1]}px, 0)`;
        }
        this.isActive && requestAnimationFrame(this.init.bind(this));
      }
      scrollHandler() {
        this.isActive
          ? clearTimeout(this.timeout)
          : ((this.isActive = !0), requestAnimationFrame(this.init.bind(this))),
          (this.timeout = setTimeout(() => (this.isActive = !1), 20));
      }
    }
    if (
      (!customElements.get("parallax-image") &&
        customElements.define("parallax-image", l),
      void 0 === window.noUiSlider)
    )
      throw Error(
        "theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js"
      );
    (theme.PriceRange = (function () {
      var e = {
        priceRange: ".price-range",
        priceRangeSlider: ".price-range__slider",
        priceRangeInputMin: ".price-range__input-min",
        priceRangeInputMax: ".price-range__input-max",
        priceRangeDisplayMin: ".price-range__display-min",
        priceRangeDisplayMax: ".price-range__display-max",
      };
      function t(e, { onChange: t, onUpdate: s, ...n } = {}) {
        return (
          (this.container = e),
          (this.onChange = t),
          (this.onUpdate = s),
          (this.sliderOptions = n || {}),
          this.init()
        );
      }
      return (
        (t.prototype = Object.assign({}, t.prototype, {
          init: function () {
            if (!this.container.classList.contains("price-range"))
              throw Error(
                "You must instantiate PriceRange with a valid container"
              );
            return (
              (this.formEl = this.container.closest("form")),
              (this.sliderEl = this.container.querySelector(
                e.priceRangeSlider
              )),
              (this.inputMinEl = this.container.querySelector(
                e.priceRangeInputMin
              )),
              (this.inputMaxEl = this.container.querySelector(
                e.priceRangeInputMax
              )),
              (this.displayMinEl = this.container.querySelector(
                e.priceRangeDisplayMin
              )),
              (this.displayMaxEl = this.container.querySelector(
                e.priceRangeDisplayMax
              )),
              (this.minRange = parseFloat(this.container.dataset.min) || 0),
              (this.minValue =
                parseFloat(this.container.dataset.minValue) || 0),
              (this.maxRange = parseFloat(this.container.dataset.max) || 100),
              (this.maxValue =
                parseFloat(this.container.dataset.maxValue) || this.maxRange),
              this.createPriceRange()
            );
          },
          createPriceRange: function () {
            this.sliderEl &&
              this.sliderEl.noUiSlider &&
              "function" == typeof this.sliderEl.noUiSlider.destroy &&
              this.sliderEl.noUiSlider.destroy();
            var e = noUiSlider.create(this.sliderEl, {
              connect: !0,
              step: 10,
              ...this.sliderOptions,
              start: [this.minValue, this.maxValue],
              range: { min: this.minRange, max: this.maxRange },
            });
            return (
              e.on("update", (e) => {
                (this.displayMinEl.innerHTML = theme.Currency.formatMoney(
                  e[0],
                  theme.settings.moneyFormat
                )),
                  (this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
                    e[1],
                    theme.settings.moneyFormat
                  )),
                  this.onUpdate && this.onUpdate(e);
              }),
              e.on("change", (e) => {
                if (
                  ((this.inputMinEl.value = e[0]),
                  (this.inputMaxEl.value = e[1]),
                  this.onChange)
                ) {
                  let t = new FormData(this.formEl);
                  this.onChange(t);
                }
              }),
              e
            );
          },
        })),
        t
      );
    })()),
      (theme.AjaxProduct = (function () {
        var e = { loading: !1 };
        function t(e, t, s) {
          (this.form = e),
            (this.args = s),
            this.form &&
              ((this.addToCart = e.querySelector(t || ".add-to-cart")),
              this.form.addEventListener(
                "submit",
                this.addItemFromForm.bind(this)
              ));
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            addItemFromForm: function (t, s) {
              if ((t.preventDefault(), !e.loading)) {
                this.addToCart.classList.add("btn--loading"), (e.loading = !0);
                var n = theme.utils.serialize(this.form);
                fetch(theme.routes.cartAdd, {
                  method: "POST",
                  body: n,
                  credentials: "same-origin",
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "X-Requested-With": "XMLHttpRequest",
                  },
                })
                  .then((e) => e.json())
                  .then(
                    function (t) {
                      422 === t.status ? this.error(t) : this.success(t),
                        (e.loading = !1),
                        this.addToCart.classList.remove("btn--loading"),
                        document.body.classList.contains("template-cart") &&
                          (window.scrollTo(0, 0), location.reload());
                    }.bind(this)
                  );
              }
            },
            success: function (e) {
              var t = this.form.querySelector(".errors");
              t && t.remove(),
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:added", {
                    detail: { product: e, addToCartBtn: this.addToCart },
                  })
                ),
                this.args &&
                  this.args.scopedEventId &&
                  document.dispatchEvent(
                    new CustomEvent(
                      "ajaxProduct:added:" + this.args.scopedEventId,
                      { detail: { product: e, addToCartBtn: this.addToCart } }
                    )
                  );
            },
            error: function (e) {
              if (!e.description) {
                console.warn(e);
                return;
              }
              var t = this.form.querySelector(".errors");
              t && t.remove();
              var s = document.createElement("div");
              s.classList.add("errors", "text-center"),
                (s.textContent = e.description),
                this.form.append(s),
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:error", {
                    detail: { errorMessage: e.description },
                  })
                ),
                this.args &&
                  this.args.scopedEventId &&
                  document.dispatchEvent(
                    new CustomEvent(
                      "ajaxProduct:error:" + this.args.scopedEventId,
                      { detail: { errorMessage: e.description } }
                    )
                  );
            },
          })),
          t
        );
      })()),
      (theme.ProductMedia = (function () {
        var e = {},
          t = {},
          s = {},
          n = {
            mediaGroup: "[data-product-single-media-group]",
            xrButton: "[data-shopify-xr]",
          };
        function a(e) {
          if (!e) {
            for (var s in t)
              if (t.hasOwnProperty(s)) {
                var n = t[s];
                !n.modelViewerUi &&
                  Shopify &&
                  (n.modelViewerUi = new Shopify.ModelViewerUI(n.element)),
                  o(n);
              }
          }
        }
        function o(e) {
          var t = s[e.sectionId];
          e.container.addEventListener("mediaVisible", function () {
            t.element.setAttribute("data-shopify-model3d-id", e.modelId),
              theme.config.isTouch || e.modelViewerUi.play();
          }),
            e.container.addEventListener("mediaHidden", function () {
              t.element.setAttribute("data-shopify-model3d-id", t.defaultId),
                e.modelViewerUi.pause();
            }),
            e.container.addEventListener("xrLaunch", function () {
              e.modelViewerUi.pause();
            });
        }
        return {
          init: function o(r, c) {
            (e[c] = { loaded: !1 }),
              r.forEach(function (e, a) {
                var o = e.dataset.mediaId,
                  r = e.querySelector("model-viewer"),
                  l = r.dataset.modelId;
                if (0 === a) {
                  var d = e.closest(n.mediaGroup).querySelector(n.xrButton);
                  s[c] = { element: d, defaultId: l };
                }
                t[o] = { modelId: l, sectionId: c, container: e, element: r };
              }),
              window.Shopify.loadFeatures([
                {
                  name: "shopify-xr",
                  version: "1.0",
                  onLoad: function t(s) {
                    if (!s) {
                      if (!window.ShopifyXR) {
                        document.addEventListener(
                          "shopify_xr_initialized",
                          function () {
                            t();
                          }
                        );
                        return;
                      }
                      for (var n in e)
                        if (e.hasOwnProperty(n)) {
                          var a = e[n];
                          if (a.loaded) continue;
                          var o = document.querySelector("#ModelJson-" + n);
                          window.ShopifyXR.addModels(JSON.parse(o.innerHTML)),
                            (a.loaded = !0);
                        }
                      window.ShopifyXR.setupXRElements();
                    }
                  },
                },
                { name: "model-viewer-ui", version: "1.0", onLoad: a },
              ]),
              theme.LibraryLoader.load("modelViewerUiStyles");
          },
          removeSectionModels: function s(n) {
            for (var a in t)
              t.hasOwnProperty(a) && t[a].sectionId === n && delete t[a];
            delete e[n];
          },
        };
      })()),
      (theme.QtySelector = (function () {
        var e = {
          input: ".js-qty__num",
          plus: ".js-qty__adjust--plus",
          minus: ".js-qty__adjust--minus",
        };
        function t(t, s) {
          (this.wrapper = t),
            (this.plus = t.querySelector(e.plus)),
            (this.minus = t.querySelector(e.minus)),
            (this.input = t.querySelector(e.input)),
            (this.minValue = this.input.getAttribute("min") || 1);
          var n = { namespace: null, isCart: !1, key: this.input.dataset.id };
          (this.options = Object.assign({}, n, s)), this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              this.plus.addEventListener(
                "click",
                function () {
    window.thissss = this;
    var e = $(".totaal-prices").attr("pro_price"),
        d = $('.product-block--price .totaal-prices').attr('prod_disc_price'),
        t = this._getQty();
        
        
    this._change(t + 1);
    if($('body').hasClass('ctm-new')){
      var e = $('.pdp-total .act-price').attr('data-cmpare-price');
       var c = $('.pdp-total .disc-price').attr('data-disc-price');
      if(c > 0){
        // $(".ctm-new .pdp-total-price span.disc-price").text(
        //     "€" + (c * (t + 1)).toFixed(0).toString().replace('.', ',') + ",-"
        // );
      }
      if(e){
         $(".ctm-new .pdp-total-price span.act-price").text(
          "€" + (e * (t + 1)).toFixed(0).toString().replace('.', ',') + ",-"
      );
      }
     
             var totalQuantity = 0;
            var pprce = 0;
              $.getJSON('/cart.js', function(cart) {
                  cart.items.forEach(function(item) {
                      if (item.product_type === '100 ml testers' || item.product_type === 'color cards') {
                          totalQuantity += item.quantity;
                          pprce += item.line_price/100;
                           if (pprce > 0){
                            $('.cb-note span').text(pprce+',-');
                            $('.cb-note').show();
                           }else{
                             $('.cb-note').hide();
                           }
                      }
                  });
                  var price = parseInt($('.pdp-total .act-price').attr('data-cmpare-price'), 10);
                  var qty = t+1;
                  var mainprce = price*qty;
                  var total = (Number(mainprce) + Number(pprce)); 
                      $('.cb-line .amt').text('€' + total + ',-');
                        if(qty >= 12){
                    $('.ctm-new .js-qty__adjust--plus').prop("disabled", true);
                  }  else{
                    $('.ctm-new .js-qty__adjust--plus').prop("disabled", false);
                  }   
                  });
          
    }else{
      $(".change-the-price .pdp-total-price span.act-price").text(
          "€" + (e * (t + 1)).toFixed(0).toString().replace('.', ',') + ",-"
      );
       var d = $('.product-block--price .totaal-prices').attr('pro_comp_price');
       if(d > 0){
        $(".change-the-price .pdp-total-price span.disc-price").text(                         
         "€" + (d * (t + 1)).toFixed(0).toString().replace('.', ',') + ",-"
      );
       }
       
    }
    
            
}.bind(this)


              ),
                this.minus.addEventListener(
                  "click",
                  function () {
                    var e = $(".totaal-prices").attr("pro_price"),
                        d = $('.product-block--price .totaal-prices').attr('prod_disc_price'),
                        c = $('.product-block--price .totaal-prices').attr('pro_comp_price'),
                        t = this._getQty();
                    if ((this._change(t - 1), 1 != t)) var s = t - 1;
                    if (1 == t) var s = 1;

                    if($('body').hasClass('ctm-new')){
                         var e = $('.pdp-total .act-price').attr('data-cmpare-price');                    
                        var c = $('.pdp-total .disc-price').attr('data-disc-price');
                          if(c > 0){
                        //  $(".ctm-new .pdp-total-price span.disc-price").text(
                        //       "€" + (c * (s)).toFixed(0).toString().replace('.', ',') + ",-"
                        //   );
                        } 
                         if(e){
                           $(".ctm-new .pdp-total-price span.act-price").text(
                            "€" + (e * (s)).toFixed(0).toString().replace('.', ',') + ",-"
                          );
                         }                      
                         
                        var totalQuantity = 0;
                        var pprce = 0;
                      $.getJSON('/cart.js', function(cart) {
                          cart.items.forEach(function(item) {
                              if (item.product_type === '100 ml testers' || item.product_type === 'color cards') {
                                  totalQuantity += item.quantity;
                                  pprce += item.line_price/100;
                                  if (pprce > 0){
                                    $('.cb-note span').text(pprce+',-');
                                    $('.cb-note').show();
                                  }else{
                                    $('.cb-note').hide();
                                  }
                              }
                          });
                          var price = parseInt($('.pdp-total .act-price').attr('data-cmpare-price'), 10);
                          var qty = s;
                          var mainprce = price*qty;
                          var total = (Number(mainprce) + Number(pprce));                       
                              $('.cb-line .amt').text('€' + total + ',-');  
                          if(qty >= 12){
                              $('.ctm-new .js-qty__adjust--plus').prop("disabled", true);
                            }  else{
                              $('.ctm-new .js-qty__adjust--plus').prop("disabled", false);
                            }                         
                          });
                      
                      }else{
                        if(e){
                          $(".change-the-price .pdp-total-price span.act-price").text(
                                              
                          "€" + (e * s).toFixed(0).toString().replace('.', ',') + ",-"
                        );
                        }
                        
                        if(c > 0){
                          $(".change-the-price .pdp-total-price span.disc-price").text(
                                              
                          "€" + (c * s).toFixed(0).toString().replace('.', ',') + ",-"
                        );
                        }
                        
                      }
                     
                  }.bind(this)


                ),
                this.input.addEventListener(
                  "change",
                  function (e) {
                    this._change(this._getQty());
                  }.bind(this)
                );
            },
            _getQty: function () {
              var e = this.input.value;
              return (
                (parseFloat(e) != parseInt(e) || isNaN(e)) && (e = 1),
                parseInt(e)
              );
            },
            _change: function (e) {
              e <= this.minValue && (e = this.minValue),
                (this.input.value = e),
                this.options.isCart &&
                  document.dispatchEvent(
                    new CustomEvent("cart:quantity" + this.options.namespace, {
                      detail: [this.options.key, e, this.wrapper],
                    })
                  );
            },
          })),
          t
        );
      })()),
      (theme.initQuickShop = function () {
        var e = document.querySelectorAll(".grid-product");
        function t(e) {
          var s = e.currentTarget;
          if (!theme.config.bpSmall) {
            if (
              (s.removeEventListener("mouseover", t),
              !s || !s.dataset.productId)
            )
              return;
            var n = s.dataset.productId,
              a = s.dataset.productHandle,
              o = s.querySelector(".quick-product__btn");
            theme.preloadProductModal(a, n, o);
          }
        }
        e.length &&
          theme.settings.quickView &&
          e.forEach((e) => {
            e.addEventListener("mouseover", t);
          });
      }),
      (theme.preloadProductModal = function (e, t, s) {
        var n = document.getElementById("QuickShopHolder-" + e),
          a = theme.routes.home + "/products/" + e + "?view=modal";
        fetch((a = a.replace("//", "/")))
          .then(function (e) {
            return e.text();
          })
          .then(function (a) {
            var o = new DOMParser()
              .parseFromString(a, "text/html")
              .querySelector(
                '.product-section[data-product-handle="' + e + '"]'
              );
            n &&
              ((n.innerHTML = ""),
              n.append(o),
              new theme.Modals("QuickShopModal-" + t, "quick-modal-" + t),
              theme.sections.register("product", theme.Product, n),
              theme.collapsibles.init(),
              theme.videoModal(),
              s && s.classList.remove("quick-product__btn--not-ready"));
          });
      }),
      (theme.Slideshow = (function () {
        var e = {
            animateOut: "animate-out",
            isPaused: "is-paused",
            isActive: "is-active",
          },
          t = {
            allSlides: ".slideshow__slide",
            currentSlide: ".is-selected",
            wrapper: ".slideshow-wrapper",
            pauseButton: ".slideshow__pause",
          },
          s = {
            thumb: ".product__thumb-item:not(.hide)",
            links: ".product__thumb-item:not(.hide) a",
            arrow: ".product__thumb-arrow",
          },
          n = {
            adaptiveHeight: !1,
            autoPlay: !1,
            avoidReflow: !1,
            childNav: null,
            childNavScroller: null,
            childVertical: !1,
            dragThreshold: 7,
            fade: !1,
            friction: 0.8,
            initialIndex: 0,
            pageDots: !1,
            pauseAutoPlayOnHover: !1,
            prevNextButtons: !1,
            rightToLeft: theme.config.rtl,
            selectedAttraction: 0.14,
            setGallerySize: !0,
            wrapAround: !0,
          };
        function a(e, a) {
          if (
            ((this.el = e),
            (this.args = Object.assign({}, n, a)),
            (this.args.on = {
              ready: this.init.bind(this),
              change: this.slideChange.bind(this),
              settle: this.afterChange.bind(this),
            }),
            this.args.childNav &&
              ((this.childNavEls = this.args.childNav.querySelectorAll(
                s.thumb
              )),
              (this.childNavLinks = this.args.childNav.querySelectorAll(
                s.links
              )),
              (this.arrows = this.args.childNav.querySelectorAll(s.arrow)),
              this.childNavLinks.length && this.initChildNav()),
            this.args.avoidReflow &&
              (function e(t) {
                if (t.id) {
                  for (var s = t.firstChild; null != s && 3 == s.nodeType; )
                    s = s.nextSibling;
                  var n = document.createElement("style");
                  (n.innerHTML = `#${t.id} .flickity-viewport{height:${s.offsetHeight}px}`),
                    document.head.appendChild(n);
                }
              })(e),
            (this.slideshow = new Flickity(e, this.args)),
            e.dataset.zoom &&
              "true" === e.dataset.zoom &&
              (this.slideshow.on("dragStart", () => {
                (this.slideshow.slider.style.pointerEvents = "none"),
                  this.slideshow.options.fade &&
                    (this.slideshow.slider.querySelector(
                      ".is-selected"
                    ).style.pointerEvents = "none");
              }),
              this.slideshow.on("dragEnd", () => {
                (this.slideshow.slider.style.pointerEvents = "auto"),
                  this.slideshow.options.fade &&
                    (this.slideshow.slider.querySelector(
                      ".is-selected"
                    ).style.pointerEvents = "auto");
              })),
            this.args.autoPlay)
          ) {
            var o = e.closest(t.wrapper);
            (this.pauseBtn = o.querySelector(t.pauseButton)),
              this.pauseBtn &&
                this.pauseBtn.addEventListener(
                  "click",
                  this._togglePause.bind(this)
                );
          }
          window.on(
            "resize",
            theme.utils.debounce(
              300,
              function () {
                this.resize();
              }.bind(this)
            )
          );
        }
        return (
          (a.prototype = Object.assign({}, a.prototype, {
            init: function (e) {
              (this.currentSlide = this.el.querySelector(t.currentSlide)),
                this.args.callbacks &&
                  this.args.callbacks.onInit &&
                  "function" == typeof this.args.callbacks.onInit &&
                  this.args.callbacks.onInit(this.currentSlide),
                window.AOS && AOS.refresh();
            },
            slideChange: function (t) {
              this.args.fade &&
                this.currentSlide &&
                (this.currentSlide.classList.add(e.animateOut),
                this.currentSlide.addEventListener(
                  "transitionend",
                  function () {
                    this.currentSlide.classList.remove(e.animateOut);
                  }.bind(this)
                )),
                this.args.childNav && this.childNavGoTo(t),
                this.args.callbacks &&
                  this.args.callbacks.onChange &&
                  "function" == typeof this.args.callbacks.onChange &&
                  this.args.callbacks.onChange(t),
                this.arrows &&
                  this.arrows.length &&
                  (this.arrows[0].classList.toggle("hide", 0 === t),
                  this.arrows[1].classList.toggle(
                    "hide",
                    t === this.childNavLinks.length - 1
                  ));
            },
            afterChange: function (s) {
              this.args.fade &&
                this.el.querySelectorAll(t.allSlides).forEach((t) => {
                  t.classList.remove(e.animateOut);
                }),
                (this.currentSlide = this.el.querySelector(t.currentSlide)),
                this.args.childNav &&
                  this.childNavGoTo(this.slideshow.selectedIndex);
            },
            destroy: function () {
              this.args.childNav &&
                this.childNavLinks.length &&
                this.childNavLinks.forEach((t) => {
                  t.classList.remove(e.isActive);
                }),
                this.slideshow.destroy();
            },
            reposition: function () {
              this.slideshow.reposition();
            },
            _togglePause: function () {
              this.pauseBtn.classList.contains(e.isPaused)
                ? (this.pauseBtn.classList.remove(e.isPaused),
                  this.slideshow.playPlayer())
                : (this.pauseBtn.classList.add(e.isPaused),
                  this.slideshow.pausePlayer());
            },
            resize: function () {
              this.slideshow.resize();
            },
            play: function () {
              this.slideshow.playPlayer();
            },
            pause: function () {
              this.slideshow.pausePlayer();
            },
            goToSlide: function (e) {
              this.slideshow.select(e);
            },
            setDraggable: function (e) {
              (this.slideshow.options.draggable = e),
                this.slideshow.updateDraggable();
            },
            initChildNav: function () {
              this.childNavLinks[this.args.initialIndex].classList.add(
                "is-active"
              ),
                this.childNavLinks.forEach((e, t) => {
                  e.setAttribute("data-index", t),
                    e.addEventListener(
                      "click",
                      function (e) {
                        e.preventDefault(),
                          this.goToSlide(this.getChildIndex(e.currentTarget));
                      }.bind(this)
                    ),
                    e.addEventListener(
                      "focus",
                      function (e) {
                        this.goToSlide(this.getChildIndex(e.currentTarget));
                      }.bind(this)
                    ),
                    e.addEventListener(
                      "keydown",
                      function (e) {
                        13 === e.keyCode &&
                          this.goToSlide(this.getChildIndex(e.currentTarget));
                      }.bind(this)
                    );
                }),
                this.arrows.length &&
                  this.arrows.forEach((e) => {
                    e.addEventListener("click", this.arrowClick.bind(this));
                  });
            },
            getChildIndex: function (e) {
              return parseInt(e.dataset.index);
            },
            childNavGoTo: function (t) {
              this.childNavLinks.forEach((t) => {
                t.blur(), t.classList.remove(e.isActive);
              });
              var s = this.childNavLinks[t];
              if ((s.classList.add(e.isActive), this.args.childNavScroller)) {
                if (this.args.childVertical) {
                  var n = s.offsetTop;
                  this.args.childNavScroller.scrollTop = n - 100;
                } else {
                  var a = s.offsetLeft;
                  this.args.childNavScroller.scrollLeft = a - 100;
                }
              }
            },
            arrowClick: function (e) {
              e.currentTarget.classList.contains("product__thumb-arrow--prev")
                ? this.slideshow.previous()
                : this.slideshow.next();
            },
          })),
          a
        );
      })()),
      (theme.VariantAvailability = (function () {
        var e = { disabled: "disabled" };
        function t(e) {
          (this.type = e.type),
            (this.variantsObject = e.variantsObject),
            (this.currentVariantObject = e.currentVariantObject),
            (this.container = e.container),
            (this.namespace = e.namespace),
            this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              this.container.on(
                "variantChange" + this.namespace,
                this.setAvailability.bind(this)
              ),
                this.setInitialAvailability();
            },
            createAvailableOptionsTree: (e, t) =>
              e.reduce(
                (e, s) => (
                  Object.keys(e).forEach((n) => {
                    if (null === s[n]) return;
                    let a = e[n].find((e) => e.value === s[n]);
                    void 0 === a &&
                      ((a = { value: s[n], soldOut: !0 }), e[n].push(a));
                    let o = t.find(({ value: e, index: t }) => "option1" === t),
                      r = t.find(({ value: e, index: t }) => "option2" === t);
                    switch (n) {
                      case "option1":
                        a.soldOut = (!a.soldOut || !s.available) && a.soldOut;
                        break;
                      case "option2":
                        o &&
                          s.option1 === o.value &&
                          (a.soldOut =
                            (!a.soldOut || !s.available) && a.soldOut);
                      case "option3":
                        o &&
                          s.option1 === o.value &&
                          r &&
                          s.option2 === r.value &&
                          (a.soldOut =
                            (!a.soldOut || !s.available) && a.soldOut);
                    }
                  }),
                  e
                ),
                { option1: [], option2: [], option3: [] }
              ),
            setInitialAvailability: function () {
              this.container
                .querySelectorAll(".variant-input-wrap")
                .forEach((e) => {
                  this.disableVariantGroup(e);
                });
              let e = this.currentVariantObject.options.map((e, t) => ({
                  value: e,
                  index: `option${t + 1}`,
                })),
                t = this.createAvailableOptionsTree(
                  this.variantsObject,
                  e,
                  this.currentVariantObject
                );
              for (var [s, n] of Object.entries(t))
                this.manageOptionState(s, n);
            },
            setAvailability: function (e) {
              let {
                  value: t,
                  index: s,
                  currentlySelectedValues: n,
                  variant: a,
                } = e.detail,
                o = this.createAvailableOptionsTree(
                  this.variantsObject,
                  n,
                  a,
                  s,
                  t
                );
              for (var [r, c] of Object.entries(o))
                this.manageOptionState(r, c, t);
            },
            manageOptionState: function (e, t) {
              var s = this.container.querySelector(
                '.variant-input-wrap[data-index="' + e + '"]'
              );
              t.forEach((e) => {
                this.enableVariantOption(s, e);
              });
            },
            enableVariantOption: function (t, s) {
              var n = s.value.replace(
                /([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,
                "\\$1"
              );
              if ("dropdown" === this.type)
                s.soldOut
                  ? (t.querySelector('option[value="' + n + '"]').disabled = !0)
                  : (t.querySelector('option[value="' + n + '"]').disabled =
                      !1);
              else {
                var a = t.querySelector(
                    '.variant-input[data-value="' + n + '"]'
                  ),
                  o = a.querySelector("input"),
                  r = a.querySelector("label");
                o.classList.remove(e.disabled),
                  r.classList.remove(e.disabled),
                  s.soldOut &&
                    (o.classList.add(e.disabled), r.classList.add(e.disabled));
              }
            },
            disableVariantGroup: function (t) {
              "dropdown" === this.type
                ? t.querySelectorAll("option").forEach((e) => {
                    e.disabled = !0;
                  })
                : (t.querySelectorAll("input").forEach((t) => {
                    t.classList.add(e.disabled);
                  }),
                  t.querySelectorAll("label").forEach((t) => {
                    t.classList.add(e.disabled);
                  }));
            },
          })),
          t
        );
      })()),
      (theme.videoModal = function () {
        var e,
          t,
          s = "VideoHolder",
          n = {
            youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
            vimeo: 'a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]',
            mp4Trigger: ".product-video-trigger--mp4",
            mp4Player: ".product-video-mp4-sound",
          },
          a = document.querySelectorAll(n.youtube),
          o = document.querySelectorAll(n.vimeo),
          r = document.querySelectorAll(n.mp4Trigger);
        if (a.length || o.length || r.length) {
          var c = document.getElementById(s);
          a.length && theme.LibraryLoader.load("youtubeSdk"),
            o.length && theme.LibraryLoader.load("vimeo", window.vimeoApiReady);
          var l = new theme.Modals("VideoModal", "video-modal", {
            closeOffContentClick: !0,
            bodyOpenClass: ["modal-open", "video-modal-open"],
            solid: !0,
          });
          a.forEach((e) => {
            e.addEventListener("click", d);
          }),
            o.forEach((e) => {
              e.addEventListener("click", h);
            }),
            r.forEach((e) => {
              e.addEventListener("click", u);
            }),
            document.addEventListener("modalClose.VideoModal", function s() {
              e && "function" == typeof e.destroy
                ? e.destroy()
                : t && "function" == typeof t.destroy
                ? t.destroy()
                : m();
            });
        }
        function d(t) {
          if (theme.config.youTubeReady) {
            t.preventDefault(), m(), l.open(t);
            var n,
              a,
              o =
                ((n = t.currentTarget.getAttribute("href")),
                (a = n.match(
                  /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
                )),
                !!a && 11 == a[7].length && a[7]);
            e = new theme.YouTube(s, {
              videoId: o,
              style: "sound",
              events: { onReady: p },
            });
          }
        }
        function h(e) {
          if (theme.config.vimeoReady) {
            e.preventDefault(), m(), l.open(e);
            var n = e.currentTarget.dataset.videoId,
              a = e.currentTarget.dataset.videoLoop;
            t = new theme.VimeoPlayer(s, n, { style: "sound", loop: a });
          }
        }
        function u(e) {
          m();
          var t = e.currentTarget.parentNode
            .querySelector(n.mp4Player)
            .cloneNode(!0);
          t.classList.remove("hide"),
            c.append(t),
            l.open(e),
            c.querySelector("video").play();
        }
        function p(e) {
          e.target.unMute(), e.target.playVideo();
        }
        function m() {
          c.innerHTML = "";
        }
      });
    class d extends HTMLElement {
      constructor() {
        super(),
          (this.el = this),
          (this.inner = this.querySelector("[data-tool-tip-inner]")),
          (this.closeButton = this.querySelector("[data-tool-tip-close]")),
          (this.toolTipContent = this.querySelector("[data-tool-tip-content]")),
          (this.toolTipTitle = this.querySelector("[data-tool-tip-title]")),
          (this.triggers = document.querySelectorAll(
            "[data-tool-tip-trigger]"
          )),
          document.addEventListener("tooltip:open", (e) => {
            this._open(e.detail.context, e.detail.content);
          });
      }
      _open(e, t) {
        (this.toolTipContent.innerHTML = t),
          "store-availability" != e && this.toolTipTitle.remove(),
          this._lockScrolling(),
          this.closeButton &&
            this.closeButton.on("click.tooltip-close", () => {
              this._close();
            }),
          document.documentElement.on("click.tooltip-outerclick", (e) => {
            "true" !== this.el.dataset.toolTipOpen ||
              this.inner.contains(e.target) ||
              this._close();
          }),
          document.documentElement.on("keydown.tooltip-esc", (e) => {
            "Escape" === e.code && this._close();
          }),
          (this.el.dataset.toolTipOpen = !0),
          (this.el.dataset.toolTip = e);
      }
      _close() {
        (this.toolTipContent.innerHTML = ""),
          (this.el.dataset.toolTipOpen = "false"),
          (this.el.dataset.toolTip = ""),
          this._unlockScrolling(),
          this.closeButton.off("click.tooltip-close"),
          document.documentElement.off("click.tooltip-outerclick"),
          document.documentElement.off("keydown.tooltip-esc");
      }
      _lockScrolling() {
        theme.a11y.trapFocus({
          container: this.el,
          namespace: "tooltip_focus",
        }),
          theme.a11y.lockMobileScrolling(),
          document.documentElement.classList.add("modal-open");
      }
      _unlockScrolling() {
        theme.a11y.removeTrapFocus({
          container: this.el,
          namespace: "tooltip_focus",
        }),
          theme.a11y.unlockMobileScrolling(),
          document.documentElement.classList.remove("modal-open");
      }
    }
    if (!customElements.get("tool-tip")) {
      customElements.define("tool-tip", d);
    }
    class h extends HTMLElement {
      constructor() {
        super(),
          (this.el = this),
          (this.toolTipContent = this.querySelector("[data-tool-tip-content]")),
          this.init();
      }
      init() {
        let e = new CustomEvent("tooltip:open", {
          detail: {
            context: this.dataset.toolTip,
            content: this.toolTipContent.innerHTML,
          },
          bubbles: !0,
        });
        this.el.addEventListener("click", (t) => {
          t.stopPropagation(), this.dispatchEvent(e);
        });
      }
    }
    if (!customElements.get("tool-tip-trigger")) {
      customElements.define("tool-tip-trigger", h);
    }

    class u extends HTMLElement {
      constructor() {
        super(),
          (this.closeBtn = this.querySelector("[data-close-button]")),
          (this.popupTrigger = this.querySelector("[data-message]")),
          (this.id = this.dataset.sectionId),
          (this.newsletterId = `NewsletterPopup-${this.id}`),
          (this.cookie = Cookies.get(`newsletter-${this.id}`)),
          (this.cookieName = `newsletter-${this.id}`),
          (this.secondsBeforeShow = this.dataset.delaySeconds),
          (this.expiry = parseInt(this.dataset.delayDays)),
          (this.modal = new theme.Modals(
            `NewsletterPopup-${this.newsletterId}`,
            "newsletter-popup-modal"
          )),
          this.init();
      }
      init() {
        document.addEventListener("shopify:block:select", (e) => {
          e.detail.sectionId === this.id && this.show(0, !0);
        }),
          document.addEventListener("shopify:block:deselect", (e) => {
            e.detail.sectionId === this.id && this.hide();
          }),
          document.addEventListener(`modalOpen.${this.newsletterId}`, () =>
            this.hide()
          ),
          document.addEventListener(`modalClose.${this.newsletterId}`, () =>
            this.show()
          ),
          document.addEventListener("newsletter:openReminder", () =>
            this.show(0)
          ),
          this.closeBtn.addEventListener("click", () => {
            this.hide(),
              Cookies.set(this.cookieName, "opened", {
                path: "/",
                expires: this.expiry,
              });
          }),
          this.popupTrigger.addEventListener("click", () => {
            let e = new CustomEvent("reminder:openNewsletter", { bubbles: !0 });
            this.dispatchEvent(e), this.hide();
          });
      }
      show(e = this.secondsBeforeShow, t = !1) {
        let s = "true" === sessionStorage.getItem("reminderAppeared");
        s ||
          setTimeout(() => {
            (this.dataset.enabled = "true"),
              sessionStorage.setItem("reminderAppeared", !0);
          }, 1e3 * e);
      }
      hide() {
        this.dataset.enabled = "false";
      }
    }
    if (!customElements.get("newsletter-reminder")) {
      customElements.define("newsletter-reminder", u);
    }
    (theme.announcementBar = (function () {
      var e,
        t,
        s = {
          autoPlay: 3e3,
          avoidReflow: !0,
          cellAlign: theme.config.rtl ? "right" : "left",
        };
      function n() {
        t = new theme.Slideshow(e, s);
      }
      function a() {
        t && "function" == typeof t.destroy && t.destroy();
      }
      return {
        init: function t() {
          if ((e = document.getElementById("AnnouncementSlider")))
            a(),
              1 !== e.dataset.blockCount &&
                ((theme.config.bpSmall || "true" === e.dataset.compact) && n(),
                document.addEventListener("matchSmall", function () {
                  a(), n();
                }),
                document.addEventListener("unmatchSmall", function () {
                  a(), "true" === e.dataset.compact && n();
                }));
        },
        onBlockSelect: function s(n) {
          var a = parseInt(
            e.querySelector("#AnnouncementSlide-" + n).dataset.index
          );
          t && "function" == typeof t.pause && (t.goToSlide(a), t.pause());
        },
        onBlockDeselect: function e() {
          t && "function" == typeof t.play && t.play();
        },
        unload: a,
      };
    })()),
      (theme.customerTemplates = function () {
        var e, t, s, n;
        function a() {
          document
            .getElementById("RecoverPasswordForm")
            .classList.toggle("hide"),
            document
              .getElementById("CustomerLoginForm")
              .classList.toggle("hide");
        }
        "#recover" === window.location.hash && a(),
          (e = document.getElementById("RecoverPassword")) &&
            e.addEventListener("click", function (e) {
              e.preventDefault(), a();
            }),
          (t = document.getElementById("HideRecoverPasswordLink")) &&
            t.addEventListener("click", function (e) {
              e.preventDefault(), a();
            }),
          document.querySelector(".reset-password-success") &&
            document.getElementById("ResetSuccess").classList.remove("hide"),
          (s = document.getElementById("AddressNewForm")),
          (n = document.querySelectorAll(".js-address-form")),
          s &&
            n.length &&
            (setTimeout(function () {
              document.querySelectorAll(".js-address-country").forEach((e) => {
                var t = e.dataset.countryId,
                  s = e.dataset.provinceId,
                  n = e.dataset.provinceContainerId;
                new Shopify.CountryProvinceSelector(t, s, { hideElement: n });
              });
            }, 1e3),
            document.querySelectorAll(".address-new-toggle").forEach((e) => {
              e.addEventListener("click", function () {
                s.classList.toggle("hide");
              });
            }),
            document.querySelectorAll(".address-edit-toggle").forEach((e) => {
              e.addEventListener("click", function (e) {
                var t = e.currentTarget.dataset.formId;
                document
                  .getElementById("EditAddress_" + t)
                  .classList.toggle("hide");
              });
            }),
            document.querySelectorAll(".address-delete").forEach((e) => {
              e.addEventListener("click", function (e) {
                var t = e.currentTarget.dataset.formId;
                confirm(
                  e.currentTarget.dataset.confirmMessage ||
                    "Are you sure you wish to delete this address?"
                ) &&
                  Shopify &&
                  Shopify.postLink("/account/addresses/" + t, {
                    parameters: { _method: "delete" },
                  });
              });
            }));
      }),
      (theme.CartDrawer = (function () {
        var e = { drawer: "#CartDrawer", form: "#CartDrawerForm" };
        function t() {
          (this.form = document.querySelector(e.form)),
            (this.drawer = new theme.Drawers("CartDrawer", "cart")),
            this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              (this.cartForm = new theme.CartForm(this.form)),
                this.cartForm.buildCart(),
                document.addEventListener(
                  "ajaxProduct:added",
                  function (e) {
                    this.cartForm.buildCart(), this.open();
                  }.bind(this)
                ),
                document.addEventListener("cart:open", this.open.bind(this)),
                document.addEventListener("cart:close", this.close.bind(this));
            },
            open: function () {
              this.drawer.open();
            },
            close: function () {
              this.drawer.close();
            },
          })),
          t
        );
      })()),
      (theme.headerNav = (function () {
        var e,
          t,
          s = {
            wrapper: "#HeaderWrapper",
            siteHeader: "#SiteHeader",
            searchBtn: ".js-search-header",
            closeSearch: "#SearchClose",
            searchContainer: ".site-header__search-container",
            logo: "#LogoContainer img",
            megamenu: ".megamenu",
            navItems: ".site-nav__item",
            navLinks: ".site-nav__link",
            navLinksWithDropdown: ".site-nav__link--has-dropdown",
            navDropdownLinks: ".site-nav__dropdown-link--second-level",
          },
          n = {
            hasDropdownClass: "site-nav--has-dropdown",
            hasSubDropdownClass: "site-nav__deep-dropdown-trigger",
            dropdownActive: "is-focused",
          },
          a = {
            namespace: ".siteNav",
            wrapperOverlayed: !1,
            overlayedClass: "is-light",
            overlayEnabledClass: "header-wrapper--sticky",
            stickyEnabled: !1,
            stickyActive: !1,
            stickyClass: "site-header--stuck",
            stickyHeaderWrapper: "StickyHeaderWrap",
            openTransitionClass: "site-header--opening",
            lastScroll: 0,
          };
        function o() {
          if (a.stickyEnabled) {
            var e = t.offsetHeight;
            t.classList.contains("site-header--stuck") &&
              !theme.config.bpSmall &&
              (e +=
                2 *
                parseFloat(
                  window
                    .getComputedStyle(t, null)
                    .getPropertyValue("padding-top")
                )),
              (document.querySelector(
                "#" + a.stickyHeaderWrapper
              ).style.height = e + "px");
          }
        }
        function r() {
          a.stickyEnabled &&
            !a.forceStopSticky &&
            (requestAnimationFrame(c), (a.lastScroll = window.scrollY));
        }
        function c() {
          if (window.scrollY > 250)
            !a.stickyActive &&
              ((a.stickyActive = !0),
              t.classList.add(a.stickyClass),
              a.wrapperOverlayed && e.classList.remove(a.overlayedClass),
              setTimeout(function () {
                t.classList.add(a.openTransitionClass);
              }, 100));
          else {
            if (!a.stickyActive) return;
            (a.stickyActive = !1),
              t.classList.remove(a.openTransitionClass),
              t.classList.remove(a.stickyClass),
              a.wrapperOverlayed && e.classList.add(a.overlayedClass);
          }
        }
        function l(e) {
          e.preventDefault(), e.stopImmediatePropagation();
          var t = document.querySelector(s.searchContainer);
          theme.utils.prepareTransition(
            t,
            function () {
              t.classList.add("is-active");
            }.bind(this)
          ),
            document.documentElement.classList.add(
              "js-drawer-open",
              "js-drawer-open--search"
            ),
            setTimeout(function () {
              theme.a11y.trapFocus({
                container: t,
                namespace: "header_search",
                elementToFocus: t.querySelector(".site-header__search-input"),
              });
            }, 100),
            theme.config.bpSmall &&
              a.stickyEnabled &&
              a.lastScroll < 300 &&
              window.scrollTo(0, 0),
            theme.a11y.lockMobileScrolling(a.namespace),
            (function e() {
              window.on(
                "keyup" + a.namespace,
                function (e) {
                  27 === e.keyCode && d();
                }.bind(this)
              ),
                document.documentElement.on(
                  "click" + a.namespace,
                  function (e) {
                    d(e);
                  }.bind(this)
                );
            })();
        }
        function d(e) {
          if (e) {
            for (
              var t = e.path || (e.composedPath && e.composedPath()), n = 0;
              n < t.length;
              n++
            )
              if (t[n].classList) {
                if (t[n].classList.contains("site-header__search-btn")) break;
                if (t[n].classList.contains("site-header__search-container"))
                  return;
              }
          }
          document.activeElement.blur(),
            document.documentElement.classList.add("js-drawer-closing"),
            document.documentElement.classList.remove(
              "js-drawer-open",
              "js-drawer-open--search"
            ),
            window.setTimeout(
              function () {
                document.documentElement.classList.remove("js-drawer-closing");
              }.bind(this),
              500
            );
          var o = document.querySelector(s.searchContainer);
          theme.utils.prepareTransition(
            o,
            function () {
              o.classList.remove("is-active");
            }.bind(this)
          ),
            theme.a11y.removeTrapFocus({
              container: o,
              namespace: "header_search",
            }),
            theme.a11y.unlockMobileScrolling(a.namespace),
            window.off("keyup" + a.namespace),
            document.documentElement.off("click" + a.namespace);
        }
        return {
          init: function c() {
            var h, u;
            (e = document.querySelector(s.wrapper)),
              (t = document.querySelector(s.siteHeader)),
              (a.stickyEnabled = "true" === t.dataset.sticky),
              a.stickyEnabled &&
                ((a.wrapperOverlayed = e.classList.contains(a.overlayedClass)),
                (theme.config.stickyHeader =
                  ((h = 0),
                  t.querySelectorAll(s.megamenu).forEach((e) => {
                    var t = e.offsetHeight;
                    t > h && (h = t);
                  }),
                  !(window.innerHeight < h + 120))),
                theme.config.stickyHeader
                  ? ((a.forceStopSticky = !1),
                    (a.lastScroll = 0),
                    ((u = document.createElement("div")).id =
                      a.stickyHeaderWrapper),
                    theme.utils.wrap(t, u),
                    (function e(t) {
                      let n = t.closest(".shopify-section-group-header-group"),
                        a = n.nextElementSibling;
                      if (
                        a &&
                        a.classList.contains(
                          "shopify-section-group-header-group"
                        )
                      ) {
                        let o = a.offsetHeight;
                        document.querySelector(s.wrapper).style.top = o + "px";
                      }
                    })(t),
                    o(),
                    window.on(
                      "resize" + a.namespace,
                      theme.utils.debounce(50, o)
                    ),
                    window.on(
                      "scroll" + a.namespace,
                      theme.utils.throttle(20, r)
                    ),
                    Shopify &&
                      Shopify.designMode &&
                      setTimeout(function () {
                        o();
                      }, 250))
                  : (a.forceStopSticky = !0)),
              (theme.settings.overlayHeader = "true" === t.dataset.overlay),
              theme.settings.overlayHeader &&
                Shopify &&
                Shopify.designMode &&
                document.body.classList.contains("template-collection") &&
                !document.querySelector(".collection-hero") &&
                this.disableOverlayHeader(),
              (function e() {
                var o = !1,
                  r = !1,
                  c = !1;
                function l(e) {
                  o && p(), r && m(), d(e.currentTarget);
                }
                function d(e) {
                  var t = e.parentNode;
                  if (
                    (t.classList.contains(n.hasDropdownClass) &&
                      (t.classList.add(n.dropdownActive), (o = !0)),
                    !theme.config.isTouch && !c)
                  ) {
                    var s = theme.config.isTouch ? "touchend" : "click";
                    (c = !0),
                      document.documentElement.on(
                        s + a.namespace,
                        function () {
                          u(),
                            document.documentElement.off(s + a.namespace),
                            (c = !1);
                        }.bind(this)
                      );
                  }
                }
                function h(e, t) {
                  var s = e.parentNode;
                  (s.classList.contains(n.hasSubDropdownClass) || t) &&
                    (s.classList.add(n.dropdownActive), (r = !0));
                }
                function u() {
                  p(), m();
                }
                function p() {
                  document.querySelectorAll(s.navItems).forEach((e) => {
                    e.classList.remove(n.dropdownActive);
                  });
                }
                function m() {
                  document.querySelectorAll(s.navDropdownLinks).forEach((e) => {
                    e.parentNode.classList.remove(n.dropdownActive);
                  });
                }
                theme.config.isTouch &&
                  document
                    .querySelectorAll(s.navLinksWithDropdown)
                    .forEach((e) => {
                      e.on("touchend" + a.namespace, function (e) {
                        e.currentTarget.parentNode.classList.contains(
                          n.dropdownActive
                        )
                          ? window.location.replace(
                              e.currentTarget.getAttribute("href")
                            )
                          : (e.preventDefault(), u(), d(e.currentTarget));
                      });
                    }),
                  document.querySelectorAll(s.navLinks).forEach((e) => {
                    e.on("focusin" + a.namespace, l),
                      e.on("mouseover" + a.namespace, l),
                      e.on("mouseleave" + a.namespace, u);
                  }),
                  document.querySelectorAll(s.navDropdownLinks).forEach((e) => {
                    theme.config.isTouch &&
                      e.on("touchend" + a.namespace, function (e) {
                        var t = e.currentTarget.parentNode;
                        t.classList.contains(n.hasSubDropdownClass)
                          ? t.classList.contains(n.dropdownActive)
                            ? window.location.replace(
                                e.currentTarget.getAttribute("href")
                              )
                            : (e.preventDefault(), m(), h(e.currentTarget))
                          : window.location.replace(
                              e.currentTarget.getAttribute("href")
                            );
                      }),
                      e.on("focusin" + a.namespace, function (e) {
                        m(), h(e.currentTarget, !0);
                      });
                  }),
                  theme.config.isTouch &&
                    (document.body.on("touchend" + a.namespace, function () {
                      u();
                    }),
                    t.querySelectorAll(s.megamenu).forEach((e) => {
                      e.on("touchend" + a.namespace, function (e) {
                        e.stopImmediatePropagation();
                      });
                    }));
              })(),
              document.querySelectorAll(s.searchBtn).forEach((e) => {
                e.addEventListener("click", l);
              }),
              document
                .querySelector(s.closeSearch)
                .addEventListener("click", d);
          },
          disableOverlayHeader: function t() {
            e.classList.remove(a.overlayEnabledClass, a.overlayedClass),
              (a.wrapperOverlayed = !1),
              (theme.settings.overlayHeader = !1);
          },
        };
      })()),
      (window.onpageshow = function (e) {
        e.persisted &&
          (document.body.classList.remove("unloading"),
          document.querySelectorAll(".cart__checkout").forEach((e) => {
            e.classList.remove("btn--loading");
          }));
      }),
      (theme.predictiveSearch = (function () {
        var e,
          t = "",
          s = !1,
          n = ".predictive",
          a = {
            form: "#HeaderSearchForm",
            input: 'input[type="search"]',
            wrapper: "#PredictiveWrapper",
            resultDiv: "#PredictiveResults",
            searchButton: "[data-predictive-search-button]",
          },
          o = {},
          r = { imageSize: "square" },
          c = { up_arrow: 38, down_arrow: 40, tab: 9 };
        function l() {
          o.wrapper.classList.add("hide"),
            (o.results.innerHTML = ""),
            clearTimeout(e);
        }
        function d() {
          o.form.submit();
        }
        function h(e) {
          e.preventDefault ? e.preventDefault() : (e.returnValue = !1);
          var t = {},
            s = new FormData(e.target);
          for (var n of s.keys()) t[n] = s.get(n);
          t.q && (t.q += "*");
          var a = p(t);
          return (window.location.href = `${theme.routes.search}?${a}`), !1;
        }
        function u(n) {
          n.keyCode !== c.up_arrow &&
            n.keyCode !== c.down_arrow &&
            n.keyCode !== c.tab &&
            (function n() {
              var a = o.input.value;
              if ("" === a) {
                l();
                return;
              }
              var r,
                c =
                  ((r = a),
                  "string" != typeof r
                    ? null
                    : r.trim().replace(/\ /g, "-").toLowerCase());
              clearTimeout(e),
                (e = setTimeout(
                  function () {
                    (function e(n) {
                      if (!s && t !== n) {
                        (t = n), (s = !0);
                        var a,
                          o = {
                            q: n,
                            "resources[type]":
                              theme.settings.predictiveSearchType,
                            "resources[limit]": 4,
                            "resources[options][unavailable_products]": "last",
                            "resources[options][fields]":
                              "title,product_type,variants.title,vendor",
                          },
                          r = p(o),
                          c = document.getElementById("PredictiveResults"),
                          d = document.getElementById("PredictiveWrapper");
                        fetch(
                          `${theme.routes.predictive_url}?${r}&section_id=predictive-search`
                        )
                          .then((e) => ((s = !1), (a = e), e.text()))
                          .then((e) => {
                            if (!a.ok) throw Error(`${a.status}: ${e}`);
                            let t = new DOMParser()
                                .parseFromString(e, "text/html")
                                .querySelector(
                                  "#shopify-section-predictive-search"
                                ).innerHTML,
                              s = t.replace(/\s+/g, "");
                            if ("" == s) {
                              l();
                              return;
                            }
                            (c.innerHTML = t), d.classList.remove("hide");
                          })
                          .catch((e) => {
                            console.error(e);
                          });
                      }
                    })(c);
                  }.bind(this),
                  500
                ));
            })();
        }
        function p(e) {
          return Object.keys(e)
            .map(function (t) {
              return t + "=" + encodeURIComponent(e[t]);
            })
            .join("&");
        }
        return {
          init: function e() {
            if (
              !document.getElementById("shopify-features") ||
              JSON.parse(document.getElementById("shopify-features").innerHTML)
                .predictiveSearch
            )
              (o.wrapper = document.querySelector(a.wrapper)),
                o.wrapper &&
                  ((r.imageSize = o.wrapper.dataset.imageSize),
                  (o.form = document.querySelector(a.form)),
                  o.form.setAttribute("autocomplete", "off"),
                  o.form.on("submit" + n, h),
                  (o.input = o.form.querySelector(a.input)),
                  o.input.on("keyup" + n, u),
                  (o.submit = o.wrapper.querySelector(a.searchButton)),
                  o.submit.on("click" + n, d),
                  (o.results = document.querySelector(a.resultDiv)));
          },
        };
      })()),
      (theme.buildProductGridItem = function (e, t, s, n) {
        var a = "";
        return (
          e.forEach((e) => {
            var o = theme.buildProductImage(e, n);
            let r = "",
              c = "";
            theme.settings.predictiveSearchPrice &&
              (r = `<div class="grid-product__price">${
                theme.strings.productFrom
              }${theme.Currency.formatMoney(
                e.price_min,
                theme.moneyFormat
              )}</div>`),
              theme.settings.predictiveSearchVendor &&
                (c = `<div class="grid-product__vendor">${e.vendor}</div>`),
              (a += `
        <div class="grid__item grid-product ${t} aos-animate" data-aos="row-of-${s}">
          <div class="grid-product__content">
            <a href="${e.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${o}
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__title">${e.title}</div>
                ${r}
                ${c}
              </div>
            </a>
          </div>
        </div>
      `);
          }),
          a
        );
      }),
      (theme.buildProductImage = function (e, t) {
        var s = theme.settings.productImageSize,
          n = "";
        if ("natural" === s) {
          let a = document.getElementById("naturalImageMarkup"),
            o = a.content.cloneNode(!0),
            r = o.querySelector("img"),
            c = o.querySelector(".image-wrap");
          (c.style.paddingBottom = `${e.image_aspect_ratio}%`), f(r, t);
          let l = document.createElement("div");
          l.appendChild(o), (n = l.innerHTML);
        } else {
          let d = document.getElementById("fixedRatioImageMarkup"),
            h = d.content.cloneNode(!0),
            u = h.querySelector("img"),
            p = h.querySelector(".grid__image-ratio");
          p.classList.add(`grid__image-ratio--${s}`),
            theme.settings.productImageCover ||
              u.classList.add("grid__image-contain"),
            f(u, t);
          let m = document.createElement("div");
          m.appendChild(h), (n = m.innerHTML);
        }
        function f(t, s) {
          (t.src = e.image_responsive_url),
            (t.srcset = e.image_responsive_urls.toString()),
            (t.alt = e.title),
            (t.sizes = s);
        }
        return n;
      }),
      (theme.buildCollectionItem = function (e) {
        var t = "";
        return (
          e.forEach((e) => {
            t += `
        <li>
          <a href="${e.url}">
            ${e.title}
          </a>
        </li>
      `;
          }),
          t
        );
      }),
      (theme.buildPageItem = function (e) {
        var t = "";
        return (
          e.forEach((e) => {
            t += `
        <li>
          <a href="${e.url}">
            ${e.title}
          </a>
        </li>
      `;
          }),
          t
        );
      }),
      (theme.buildArticleItem = function (e, t) {
        var s = "";
        return (
          e.forEach((e) => {
            s += `
        <div class="grid__item grid-product small--one-half medium-up--one-quarter" data-aos="row-of-4">
          <a href="${
            e.url
          }" class="grid-product__link grid-product__link--inline">
            <div class="grid-product__image-mask">
              <div
                class="grid__image-ratio grid__image-ratio--object grid__image-ratio--${t}">
                <div class="predictive__image-wrap">
                  ${theme.buildPredictiveImage(e)} 
                </div>
              </div>
            </div>
            <div class="grid-product__meta">
              ${e.title}
            </div>
          </a>
        </div>
      `;
          }),
          s
        );
      }),
      (theme.buildPredictiveImage = function (e) {
        var t = "";
        if (e.image) {
          let s = document.getElementById("articleImageMarkup"),
            n = s.content.cloneNode(!0),
            a = n.querySelector("img");
          a.src = e.image;
          let o = document.createElement("div");
          o.appendChild(n), (t = o.innerHTML);
        }
        return t;
      });
    class p extends HTMLElement {
      constructor() {
        if (
          (super(),
          (this.cookieName = this.id),
          (this.cookie = Cookies.get(this.cookieName)),
          (this.classes = {
            activeContent: "age-verification-popup__content--active",
            inactiveContent: "age-verification-popup__content--inactive",
            inactiveDeclineContent:
              "age-verification-popup__decline-content--inactive",
            activeDeclineContent:
              "age-verification-popup__decline-content--active",
          }),
          (this.declineButton = this.querySelector(
            "[data-age-verification-popup-decline-button]"
          )),
          (this.declineContent = this.querySelector(
            "[data-age-verification-popup-decline-content]"
          )),
          (this.content = this.querySelector(
            "[data-age-verification-popup-content]"
          )),
          (this.returnButton = this.querySelector(
            "[data-age-verification-popup-return-button]"
          )),
          (this.exitButton = this.querySelector(
            "[data-age-verification-popup-exit-button]"
          )),
          (this.backgroundImage = this.querySelector(
            "[data-background-image]"
          )),
          (this.mobileBackgroundImage = this.querySelector(
            "[data-mobile-background-image]"
          )),
          Shopify.designMode &&
            (document.addEventListener("shopify:section:select", (e) => {
              e.detail.sectionId === this.dataset.sectionId && this.init();
            }),
            document.addEventListener("shopify:section:load", (e) => {
              if (e.detail.sectionId === this.dataset.sectionId) {
                this.init(),
                  "true" === this.dataset.testMode &&
                    this.cookie &&
                    Cookies.remove(this.cookieName);
                let t = sessionStorage.getItem(this.id);
                t && this.showDeclineContent();
              }
            }),
            document.addEventListener("shopify:section:unload", (e) => {
              e.detail.sectionId === this.dataset.sectionId &&
                this.modal.close();
            })),
          this.cookie && "false" === this.dataset.testMode)
        )
          return;
        this.init();
      }
      init() {
        (this.modal = new theme.Modals(
          this.id,
          "age-verification-popup-modal",
          { closeOffContentClick: !1 }
        )),
          this.backgroundImage &&
            (this.backgroundImage.style.display = "block"),
          theme.config.bpSmall &&
            this.mobileBackgroundImage &&
            (this.mobileBackgroundImage.style.display = "block"),
          this.modal.open(),
          theme.a11y.lockMobileScrolling(
            `#${this.id}`,
            document.querySelector("#MainContent")
          ),
          this.declineButton &&
            this.declineButton.addEventListener("click", (e) => {
              e.preventDefault(),
                this.showDeclineContent(),
                Shopify.designMode &&
                  sessionStorage.setItem(this.id, "second-view");
            }),
          this.returnButton &&
            this.returnButton.addEventListener("click", (e) => {
              e.preventDefault(), this.hideDeclineContent();
              let t = sessionStorage.getItem(this.id);
              Shopify.designMode && t && sessionStorage.removeItem(this.id);
            }),
          this.exitButton &&
            this.exitButton.addEventListener("click", (e) => {
              e.preventDefault(),
                "false" === this.dataset.testMode &&
                  Cookies.set(this.cookieName, "entered", { expires: 30 }),
                this.backgroundImage &&
                  (this.backgroundImage.style.display = "none"),
                theme.config.bpSmall &&
                  this.mobileBackgroundImage &&
                  (this.mobileBackgroundImage.style.display = "none"),
                this.modal.close(),
                theme.a11y.unlockMobileScrolling(
                  `#${this.id}`,
                  document.querySelector("#MainContent")
                );
            });
      }
      showDeclineContent() {
        this.declineContent.classList.remove(
          this.classes.inactiveDeclineContent
        ),
          this.declineContent.classList.add(this.classes.activeDeclineContent),
          this.content.classList.add(this.classes.inactiveContent),
          this.content.classList.remove(this.classes.activeContent);
      }
      hideDeclineContent() {
        this.declineContent.classList.add(this.classes.inactiveDeclineContent),
          this.declineContent.classList.remove(
            this.classes.activeDeclineContent
          ),
          this.content.classList.remove(this.classes.inactiveContent),
          this.content.classList.add(this.classes.activeContent);
      }
    }
    if (!customElements.get("age-verification-popup")) {
      customElements.define("age-verification-popup", p);
    }

    (theme.Maps = (function () {
      var e = { zoom: 14 },
        t = null,
        s = [],
        n = {},
        a = {
          section: '[data-section-type="map"]',
          map: "[data-map]",
          mapOverlay: ".map-section__overlay",
        };
      function o(e) {
        (this.container = e),
          (this.sectionId = this.container.getAttribute("data-section-id")),
          (this.namespace = ".map-" + this.sectionId),
          (this.map = e.querySelector(a.map)),
          (this.key = this.map.dataset.apiKey),
          (n = {
            addressNoResults: theme.strings.addressNoResults,
            addressQueryLimit: theme.strings.addressQueryLimit,
            addressError: theme.strings.addressError,
            authError: theme.strings.authError,
          }),
          this.key &&
            theme.initWhenVisible({
              element: this.container,
              callback: this.prepMapApi.bind(this),
              threshold: 20,
            });
      }
      return (
        (window.gm_authFailure = function () {
          Shopify.designMode &&
            (document.querySelectorAll(a.section).forEach((e) => {
              e.classList.add("map-section--load-error");
            }),
            document.querySelectorAll(a.map).forEach((e) => {
              e.parentNode.removeChild(e);
            }),
            window.mapError(theme.strings.authError));
        }),
        (window.mapError = function (e) {
          var t = document.createElement("div");
          t.classList.add("map-section__error", "errors", "text-center"),
            (t.innerHTML = e),
            document.querySelectorAll(a.mapOverlay).forEach((e) => {
              e.parentNode.prepend(t);
            }),
            document.querySelectorAll(".map-section__link").forEach((e) => {
              e.classList.add("hide");
            });
        }),
        (o.prototype = Object.assign({}, o.prototype, {
          prepMapApi: function () {
            if ("loaded" === t) this.createMap();
            else if (
              (s.push(this),
              "loading" !== t &&
                ((t = "loading"),
                void 0 === window.google || void 0 === window.google.maps))
            ) {
              var e = document.createElement("script");
              (e.onload = function () {
                (t = "loaded"),
                  s.forEach((e) => {
                    e.createMap();
                  });
              }),
                (e.src =
                  "https://maps.googleapis.com/maps/api/js?key=" + this.key),
                document.head.appendChild(e);
            }
          },
          createMap: function () {
            var t = this.map;
            return (function e(t) {
              var s = new google.maps.Geocoder();
              if (t) {
                var n = t.dataset.addressSetting;
                return new Promise((e, t) => {
                  s.geocode({ address: n }, function (s, n) {
                    n !== google.maps.GeocoderStatus.OK && t(n), e(s);
                  });
                });
              }
            })(t)
              .then(
                function (s) {
                  var n = {
                      zoom: e.zoom,
                      backgroundColor: "none",
                      center: s[0].geometry.location,
                      draggable: !1,
                      clickableIcons: !1,
                      scrollwheel: !1,
                      disableDoubleClickZoom: !0,
                      disableDefaultUI: !0,
                    },
                    a = (this.map = new google.maps.Map(t, n)),
                    o = (this.center = a.getCenter());
                  new google.maps.Marker({ map: a, position: a.getCenter() }),
                    google.maps.event.addDomListener(
                      window,
                      "resize",
                      theme.utils.debounce(250, function () {
                        google.maps.event.trigger(a, "resize"),
                          a.setCenter(o),
                          t.removeAttribute("style");
                      })
                    ),
                    Shopify.designMode && window.AOS && AOS.refreshHard();
                }.bind(this)
              )
              .catch(function (e) {
                var t;
                switch (e) {
                  case "ZERO_RESULTS":
                    t = n.addressNoResults;
                    break;
                  case "OVER_QUERY_LIMIT":
                    t = n.addressQueryLimit;
                    break;
                  case "REQUEST_DENIED":
                    t = n.authError;
                    break;
                  default:
                    t = n.addressError;
                }
                Shopify.designMode && window.mapError(t);
              });
          },
          onUnload: function () {
            0 !== this.map.length &&
              google &&
              google.maps &&
              google.maps.event &&
              google.maps.event.clearListeners(this.map, "resize");
          },
        })),
        o
      );
    })()),
      (theme.NewsletterPopup = (function () {
        function e(e) {
          this.container = e;
          var t = this.container.getAttribute("data-section-id");
          if (
            ((this.cookieName = "newsletter-" + t),
            (this.cookie = Cookies.get(this.cookieName)),
            e &&
              "/challenge" !== window.location.pathname &&
              "/password" !== window.location.pathname)
          ) {
            (this.data = {
              secondsBeforeShow: e.dataset.delaySeconds,
              daysBeforeReappear: e.dataset.delayDays,
              hasReminder: e.dataset.hasReminder,
              testMode: e.dataset.testMode,
            }),
              (this.modal = new theme.Modals(
                "NewsletterPopup-" + t,
                "newsletter-popup-modal"
              ));
            var s = e.querySelector(".popup-cta a");
            if (
              (s &&
                s.addEventListener(
                  "click",
                  function () {
                    this.closePopup(!0);
                  }.bind(this)
                ),
              (e.querySelector(".errors") ||
                e.querySelector(".note--success")) &&
                this.modal.open(),
              e.querySelector(".note--success"))
            ) {
              this.closePopup(!0);
              return;
            }
            document.addEventListener(
              "modalClose." + e.id,
              this.closePopup.bind(this)
            ),
              this.cookie || this.initPopupDelay(),
              document.addEventListener("reminder:openNewsletter", () => {
                this.modal.open();
              });
          }
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            initPopupDelay: function () {
              "true" !== this.data.testMode &&
                setTimeout(
                  function () {
                    let e =
                      "true" === sessionStorage.getItem("newsletterAppeared");
                    if (e) {
                      let t = new CustomEvent("newsletter:openReminder", {
                        bubbles: !0,
                      });
                      this.container.dispatchEvent(t);
                    } else
                      this.modal.open(),
                        sessionStorage.setItem("newsletterAppeared", !0);
                  }.bind(this),
                  1e3 * this.data.secondsBeforeShow
                );
            },
            closePopup: function (e) {
              if ("true" === this.data.testMode) {
                Cookies.remove(this.cookieName, { path: "/" });
                return;
              }
              var t = e ? 200 : this.data.daysBeforeReappear,
                s = "true" === this.data.hasReminder,
                n = "true" === sessionStorage.getItem("reminderAppeared");
              s && n
                ? Cookies.set(this.cookieName, "opened", {
                    path: "/",
                    expires: t,
                  })
                : s ||
                  Cookies.set(this.cookieName, "opened", {
                    path: "/",
                    expires: t,
                  });
            },
            onLoad: function () {
              this.modal.open();
            },
            onSelect: function () {
              this.modal.open();
            },
            onDeselect: function () {
              this.modal.close();
            },
            onBlockSelect: function () {
              this.modal.close();
            },
            onBlockDeselect: function () {
              this.modal.open();
            },
            onUnload: function () {
              this.modal.close();
            },
          })),
          e
        );
      })()),
      (theme.PasswordHeader = (function () {
        function e() {
          this.init();
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            init: function () {
              if (document.querySelector("#LoginModal")) {
                var e = new theme.Modals("LoginModal", "login-modal", {
                  focusIdOnOpen: "password",
                  solid: !0,
                });
                document.querySelectorAll(".errors").length && e.open();
              }
            },
          })),
          e
        );
      })()),
      (theme.Photoswipe = (function () {
        var e = {
          trigger: ".js-photoswipe__zoom",
          images: ".photoswipe__image",
          slideshowTrack: ".flickity-viewport ",
          activeImage: ".is-selected",
        };
        function t(e, t) {
          (this.container = e),
            (this.sectionId = t),
            (this.namespace = ".photoswipe-" + this.sectionId),
            this.gallery,
            this.images,
            this.items,
            (this.inSlideshow = !1),
            e && "false" !== e.dataset.zoom && this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              this.container.querySelectorAll(e.trigger).forEach((e) => {
                e.on("click" + this.namespace, this.triggerClick.bind(this));
              });
            },
            triggerClick: function (t) {
              this.container.dataset &&
              "true" === this.container.dataset.hasSlideshow
                ? (this.inSlideshow = !0)
                : (this.inSlideshow = !1),
                (this.items = this.getImageData());
              var s = this.inSlideshow
                  ? this.container.querySelector(e.activeImage)
                  : t.currentTarget,
                n = this.inSlideshow ? this.getChildIndex(s) : s.dataset.index;
              this.initGallery(this.items, n);
            },
            getChildIndex: function (e) {
              for (var t = 0; null != (e = e.previousSibling); ) t++;
              return t + 1;
            },
            getImageData: function () {
              this.images = this.inSlideshow
                ? this.container.querySelectorAll(e.slideshowTrack + e.images)
                : this.container.querySelectorAll(e.images);
              var t = [];
              return (
                this.images.forEach((e) => {
                  var s = {
                    msrc: e.currentSrc || e.src,
                    src: e.getAttribute("data-photoswipe-src"),
                    w: e.getAttribute("data-photoswipe-width"),
                    h: e.getAttribute("data-photoswipe-height"),
                    el: e,
                    initialZoomLevel: 0.5,
                  };
                  t.push(s);
                }),
                t
              );
            },
            initGallery: function (e, t) {
              var s = document.querySelectorAll(".pswp")[0];
              (this.gallery = new PhotoSwipe(s, PhotoSwipeUI_Default, e, {
                allowPanToNext: !1,
                captionEl: !1,
                closeOnScroll: !1,
                counterEl: !1,
                history: !1,
                index: t - 1,
                pinchToClose: !1,
                preloaderEl: !1,
                scaleMode: "zoom",
                shareEl: !1,
                tapToToggleControls: !1,
                getThumbBoundsFn: function (t) {
                  var s =
                      window.pageYOffset || document.documentElement.scrollTop,
                    n = e[t].el.getBoundingClientRect();
                  return { x: n.left, y: n.top + s, w: n.width };
                },
              })),
                this.gallery.listen("afterChange", this.afterChange.bind(this)),
                this.gallery.init(),
                this.preventiOS15Scrolling();
            },
            afterChange: function () {
              var e = this.gallery.getCurrentIndex();
              this.container.dispatchEvent(
                new CustomEvent("photoswipe:afterChange", {
                  detail: { index: e },
                })
              );
            },
            syncHeight: function () {
              document.documentElement.style.setProperty(
                "--window-inner-height",
                `${window.innerHeight}px`
              );
            },
            preventiOS15Scrolling: function () {
              let e;
              /iPhone|iPad|iPod/i.test(window.navigator.userAgent) &&
                (this.syncHeight(),
                (e = window.scrollY),
                document.documentElement.classList.add("pswp-open-in-ios"),
                window.addEventListener("resize", this.syncHeight),
                this.gallery.listen("destroy", () => {
                  document.documentElement.classList.remove("pswp-open-in-ios"),
                    window.scrollTo(0, e);
                }));
            },
          })),
          t
        );
      })());
    class m extends HTMLElement {
      constructor() {
        super(),
          (this.el = this),
          (this.url = this.dataset.url),
          (this.intent = this.dataset.intent),
          (this.placeholder = this.querySelector(
            ".product-recommendations-placeholder"
          )),
          (this.productResults = this.querySelector(".grid-product")),
          (this.sectionId = this.dataset.sectionId),
          (this.blockId = this.dataset.blockId),
          this.init(),
          document.addEventListener("shopify:section:load", (e) => {
            e.detail.sectionId === this.sectionId && this.init();
          }),
          document.addEventListener("shopify:block:deselect", (e) => {
            e.detail.blockId === this.blockId && this.init();
          }),
          document.addEventListener("recommendations:loaded", (e) => {
            (this.colorImages = this.el.querySelectorAll(
              ".grid-product__color-image"
            )),
              this.colorImages.length &&
                ((this.swatches = this.el.querySelectorAll(
                  ".color-swatch--with-image"
                )),
                this.colorSwatchHovering());
          });
      }
      init() {
        fetch(this.url)
          .then(function (e) {
            return e.text();
          })
          .then(
            function (e) {
              let t = new DOMParser(),
                s = t.parseFromString(e, "text/html"),
                n = s.querySelector(".product-recommendations");
              if (!n) {
                this.el.classList.add("hide"), AOS && AOS.refreshHard();
                return;
              }
              (this.placeholder.innerHTML = ""),
                this.placeholder.appendChild(n);
              let a =
                this.placeholder.querySelector(
                  ".grid-product__image-wrap img"
                ) ||
                this.placeholder.querySelector(".grid-product__image-wrap svg");
              a &&
                0 === a.naturalWidth &&
                0 === a.naturalHeight &&
                this.placeholder
                  .querySelectorAll("img")
                  .forEach((e) => (e.outerHTML = e.outerHTML)),
                theme.reinitProductGridItem(this.el),
                (this.slideshow = this.querySelector("[data-slideshow]")),
                this.slideshow && this.setupSlider(),
                document.dispatchEvent(
                  new CustomEvent("recommendations:loaded", {
                    detail: { section: this.el, intent: this.intent },
                  })
                );
            }.bind(this)
          );
      }
      setupSlider() {
        let e = this.slideshow.dataset.controls,
          t = parseFloat(this.slideshow.dataset.perSlide),
          s = parseFloat(this.slideshow.dataset.count),
          n = !1,
          a = !0;
        "arrows" === e && ((a = !1), (n = !0)),
          t < s &&
            (this.flickity = new theme.Slideshow(this.slideshow, {
              prevNextButtons: n,
              pageDots: a,
              adaptiveHeight: !0,
              wrapAround: !1,
            }));
      }
      colorSwatchHovering() {
        this.swatches.forEach((e) => {
          e.addEventListener(
            "mouseenter",
            function () {
              this.setActiveColorImage(e);
            }.bind(this)
          ),
            e.addEventListener(
              "touchstart",
              function (t) {
                t.preventDefault(), this.setActiveColorImage(e);
              }.bind(this),
              { passive: !0 }
            ),
            e.addEventListener(
              "mouseleave",
              function () {
                this.removeActiveColorImage(e);
              }.bind(this)
            );
        });
      }
      setActiveColorImage(e) {
        let t = e.dataset.variantId,
          s = e.dataset.variantImage;
        this.colorImages.forEach((e) => {
          e.classList.remove("is-active");
        }),
          this.swatches.forEach((e) => {
            e.classList.remove("is-active");
          });
        let n = this.el.querySelector(`.grid-product__color-image--${t}`);
        (n.style.backgroundImage = "url(" + s + ")"),
          n.classList.add("is-active"),
          e.classList.add("is-active");
        let a = e.dataset.url,
          o = e.closest(".grid-item__link");
        o.setAttribute("href", a);
      }
      removeActiveColorImage(e) {
        let t = e.dataset.variantId;
        this.el
          .querySelector(`.grid-product__color-image--${t}`)
          .classList.remove("is-active");
      }
    }
    if (!customElements.get("product-recommendations")) {
      customElements.define("product-recommendations", m);
    }
    (theme.SlideshowSection = (function () {
      function e(e) {
        this.container = e;
        var t = e.getAttribute("data-section-id");
        if (
          ((this.slideshow = e.querySelector("#Slideshow-" + t)),
          (this.namespace = "." + t),
          (this.initialIndex = 0),
          this.slideshow)
        ) {
          var s = e.parentElement;
          0 === [].indexOf.call(s.parentElement.children, s)
            ? this.init()
            : theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
              });
        }
      }
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          init: function () {
            var e = this.slideshow.querySelectorAll(".slideshow__slide");
            if (
              (this.slideshow.classList.remove("loading", "loading--delayed"),
              this.slideshow.classList.add("loaded"),
              e.length > 1)
            ) {
              var t = {
                prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
                pageDots: this.slideshow.hasAttribute("data-dots"),
                fade: !0,
                setGallerySize: !1,
                initialIndex: this.initialIndex,
                autoPlay:
                  "true" === this.slideshow.dataset.autoplay &&
                  parseInt(this.slideshow.dataset.speed),
              };
              this.flickity = new theme.Slideshow(this.slideshow, t);
            } else e[0].classList.add("is-selected");
          },
          forceReload: function () {
            this.onUnload(), this.init();
          },
          onUnload: function () {
            this.flickity &&
              "function" == typeof this.flickity.destroy &&
              this.flickity.destroy();
          },
          onDeselect: function () {
            this.flickity &&
              "function" == typeof this.flickity.play &&
              this.flickity.play();
          },
          onBlockSelect: function (e) {
            var t = parseInt(
              this.slideshow.querySelector(
                ".slideshow__slide--" + e.detail.blockId
              ).dataset.index
            );
            this.flickity && "function" == typeof this.flickity.pause
              ? (this.flickity.goToSlide(t), this.flickity.pause())
              : ((this.initialIndex = t),
                setTimeout(
                  function () {
                    this.flickity &&
                      "function" == typeof this.flickity.pause &&
                      this.flickity.pause();
                  }.bind(this),
                  1e3
                ));
          },
          onBlockDeselect: function () {
            this.flickity &&
              "function" == typeof this.flickity.play &&
              this.flickity.args.autoPlay &&
              this.flickity.play();
          },
        })),
        e
      );
    })()),
      (theme.StoreAvailability = (function () {
        var e = {
          drawerOpenBtn: ".js-drawer-open-availability",
          modalOpenBtn: ".js-modal-open-availability",
          productTitle: "[data-availability-product-title]",
        };
        function t(e) {
          (this.container = e),
            (this.baseUrl = e.dataset.baseUrl),
            (this.productTitle = e.dataset.productName);
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            updateContent: function (t) {
              var s =
                  this.baseUrl +
                  "/variants/" +
                  t +
                  "/?section_id=store-availability",
                n = this;
              fetch(s)
                .then(function (e) {
                  return e.text();
                })
                .then(function (t) {
                  if ("" === t.trim()) {
                    this.container.innerHTML = "";
                    return;
                  }
                  (n.container.innerHTML = t),
                    (n.container.innerHTML =
                      n.container.firstElementChild.innerHTML),
                    n.container.querySelector(e.drawerOpenBtn) &&
                      (n.drawer = new theme.Drawers(
                        "StoreAvailabilityDrawer",
                        "availability"
                      )),
                    n.container.querySelector(e.modalOpenBtn) &&
                      (n.modal = new theme.Modals(
                        "StoreAvailabilityModal",
                        "availability"
                      ));
                  var s = n.container.querySelector(e.productTitle);
                  s && (s.textContent = n.productTitle);
                });
            },
          })),
          t
        );
      })()),
      (theme.VideoSection = (function () {
        var e = { videoParent: ".video-parent-section" };
        function t(e) {
          (this.container = e),
            (this.sectionId = e.getAttribute("data-section-id")),
            (this.namespace = ".video-" + this.sectionId),
            this.videoObject,
            theme.initWhenVisible({
              element: this.container,
              callback: this.init.bind(this),
              threshold: 500,
            });
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var e = this.container.querySelector(".video-div");
              if (e) {
                var t = e.dataset.type;
                switch (t) {
                  case "youtube":
                    var s = e.dataset.videoId;
                    this.initYoutubeVideo(s);
                    break;
                  case "vimeo":
                    var s = e.dataset.videoId;
                    this.initVimeoVideo(s);
                    break;
                  case "mp4":
                    this.initMp4Video();
                }
              }
            },
            initYoutubeVideo: function (t) {
              this.videoObject = new theme.YouTube(
                "YouTubeVideo-" + this.sectionId,
                { videoId: t, videoParent: e.videoParent }
              );
            },
            initVimeoVideo: function (t) {
              this.videoObject = new theme.VimeoPlayer(
                "Vimeo-" + this.sectionId,
                t,
                { videoParent: e.videoParent }
              );
            },
            initMp4Video: function () {
              var t = "Mp4Video-" + this.sectionId,
                s = document.getElementById(t),
                n = s.closest(e.videoParent);
              if (s) {
                n.classList.add("loaded");
                var a = document.querySelector("#" + t).play();
                void 0 !== a &&
                  a
                    .then(function () {})
                    .catch(function () {
                      s.setAttribute("controls", ""),
                        n.classList.add("video-interactable");
                    });
              }
            },
            onUnload: function (e) {
              e.target.id.replace("shopify-section-", ""),
                this.videoObject &&
                  "function" == typeof this.videoObject.destroy &&
                  this.videoObject.destroy();
            },
          })),
          t
        );
      })());
    class f extends HTMLElement {
      constructor() {
        super(),
          (this.el = this),
          (this.display = this.querySelector("[data-time-display]")),
          (this.block = this.closest(".countdown__block--timer")),
          (this.year = this.el.dataset.year),
          (this.month = this.el.dataset.month),
          (this.day = this.el.dataset.day),
          (this.hour = this.el.dataset.hour),
          (this.minute = this.el.dataset.minute),
          (this.daysPlaceholder = this.querySelector(
            "[date-days-placeholder]"
          )),
          (this.hoursPlaceholder = this.querySelector(
            "[date-hours-placeholder]"
          )),
          (this.minutesPlaceholder = this.querySelector(
            "[date-minutes-placeholder]"
          )),
          (this.secondsPlaceholder = this.querySelector(
            "[date-seconds-placeholder]"
          )),
          (this.messagePlaceholder = this.querySelector(
            "[data-message-placeholder]"
          )),
          (this.hideTimerOnComplete = this.el.dataset.hideTimer),
          (this.completeMessage = this.el.dataset.completeMessage),
          (this.timerComplete = !1),
          this.init();
      }
      init() {
        setInterval(() => {
          this.timerComplete || this._calculate();
        }, 1e3);
      }
      _calculate() {
        let e =
          +new Date(
            `${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`
          ).getTime() - +new Date().getTime();
        if (e > 0) {
          let t = {
            days: Math.floor(e / 864e5),
            hours: Math.floor((e / 36e5) % 24),
            minutes: Math.floor((e / 1e3 / 60) % 60),
            seconds: Math.floor((e / 1e3) % 60),
          };
          (this.daysPlaceholder.innerHTML = t.days),
            (this.hoursPlaceholder.innerHTML = t.hours),
            (this.minutesPlaceholder.innerHTML = t.minutes),
            (this.secondsPlaceholder.innerHTML = t.seconds);
        } else
          this.completeMessage &&
            this.messagePlaceholder &&
            this.messagePlaceholder.classList.add(
              "countdown__timer-message--visible"
            ),
            "true" === this.hideTimerOnComplete &&
              (this.display.classList.remove("countdown__display--visible"),
              this.display.classList.add("countdown__display--hidden")),
            this.completeMessage ||
              "true" !== this.hideTimerOnComplete ||
              this.block.classList.add("countdown__block--hidden"),
            (this.timerComplete = !0);
      }
    }
    if (!customElements.get("countdown-timer")) {
      customElements.define("countdown-timer", f);
    }
    class g extends HTMLElement {
      constructor() {
        super(),
          (this.el = this),
          (this.buttons = this.querySelectorAll("[data-button]")),
          (this.hotspotBlocks = this.querySelectorAll("[data-hotspot-block]")),
          (this.blockContainer = this.querySelector("[data-block-container]")),
          (this.colorImages = this.querySelectorAll(
            ".grid-product__color-image"
          )),
          (this.colorSwatches = this.querySelectorAll(
            ".color-swatch--with-image"
          )),
          this._bindEvents(),
          this._setupQuickShop(),
          this.colorImages.length && this._colorSwatchHovering();
      }
      _colorSwatchHovering() {
        this.colorSwatches.forEach((e) => {
          e.addEventListener(
            "mouseenter",
            function () {
              this._setActiveColorImage(e);
            }.bind(this)
          ),
            e.addEventListener(
              "touchstart",
              function (t) {
                t.preventDefault(), this._setActiveColorImage(e);
              }.bind(this),
              { passive: !0 }
            ),
            e.addEventListener(
              "mouseleave",
              function () {
                this._removeActiveColorImage(e);
              }.bind(this)
            );
        });
      }
      _setActiveColorImage(e) {
        var t = e.dataset.variantId,
          s = e.dataset.variantImage;
        this.colorImages.forEach((e) => {
          e.classList.remove("is-active");
        }),
          this.colorSwatches.forEach((e) => {
            e.classList.remove("is-active");
          });
        var n = this.el.querySelector(".grid-product__color-image--" + t);
        (n.style.backgroundImage = "url(" + s + ")"),
          n.classList.add("is-active"),
          e.classList.add("is-active");
        var a = e.dataset.url,
          o = e.closest(".grid-item__link");
        o && o.setAttribute("href", a);
      }
      _removeActiveColorImage(e) {
        let t = e.dataset.variantId;
        this.querySelector(`.grid-product__color-image--${t}`).classList.remove(
          "is-active"
        );
      }
      _bindEvents() {
        this.buttons.forEach((e) => {
          let t = e.dataset.button;
          e.on("click", (e) => {
            e.preventDefault(), e.stopPropagation(), this._showContent(t);
          });
        }),
          document.addEventListener("shopify:block:select", (e) => {
            let t = e.detail.blockId;
            this._showContent(`${t}`), this._setupQuickShop();
          });
      }
      _showContent(e) {
        this.hotspotBlocks.forEach((t) => {
          t.dataset.hotspotBlock === e
            ? t.classList.add("is-active")
            : t.classList.remove("is-active");
        });
      }
      _setupQuickShop() {
        this.querySelectorAll('[data-block-type="product"]').length > 0 &&
          ("function" == typeof theme.QuickShop
            ? new theme.QuickShop(this.blockContainer)
            : "function" == typeof theme.initQuickShop && theme.initQuickShop(),
          "function" == typeof theme.QuickAdd &&
            new theme.QuickAdd(this.blockContainer));
      }
    }
    if (!customElements.get("hot-spots")) {
      customElements.define("hot-spots", g);
    }
    class v extends HTMLElement {
      constructor() {
        super(),
          (this.el = this),
          (this.sectionId = this.dataset.sectionId),
          (this.button = this.querySelector("[data-button]")),
          (this.draggableContainer = this.querySelector("[data-draggable]")),
          (this.primaryImage = this.querySelector("[data-primary-image]")),
          (this.secondaryImage = this.querySelector("[data-secondary-image]")),
          this.calculateSizes(),
          (this.active = !1),
          (this.currentX = 0),
          (this.initialX = 0),
          (this.xOffset = 0),
          (this.buttonOffset = this.button.offsetWidth / 2),
          this.el.addEventListener("touchstart", this.dragStart, !1),
          this.el.addEventListener("touchend", this.dragEnd, !1),
          this.el.addEventListener("touchmove", this.drag, !1),
          this.el.addEventListener("mousedown", this.dragStart, !1),
          this.el.addEventListener("mouseup", this.dragEnd, !1),
          this.el.addEventListener("mousemove", this.drag, !1),
          window.on(
            "resize",
            theme.utils.debounce(250, () => {
              this.calculateSizes(!0);
            })
          ),
          document.addEventListener("shopify:section:load", (e) => {
            e.detail.sectionId === this.sectionId &&
              null !== this.primaryImage &&
              this.calculateSizes();
          });
      }
      calculateSizes(e = !1) {
        (this.active = !1),
          (this.currentX = 0),
          (this.initialX = 0),
          (this.xOffset = 0),
          (this.buttonOffset = this.button.offsetWidth / 2),
          (this.elWidth = this.el.offsetWidth),
          (this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`),
          (this.primaryImage.style.width = `${this.elWidth}px`),
          e && (this.draggableContainer.style.width = `${this.elWidth / 2}px`);
      }
      dragStart(e) {
        "touchstart" === e.type
          ? (this.initialX = e.touches[0].clientX - this.xOffset)
          : (this.initialX = e.clientX - this.xOffset),
          e.target === this.button && (this.active = !0);
      }
      dragEnd(e) {
        (this.initialX = this.currentX), (this.active = !1);
      }
      drag(e) {
        this.active &&
          (e.preventDefault(),
          "touchmove" === e.type
            ? (this.currentX = e.touches[0].clientX - this.initialX)
            : (this.currentX = e.clientX - this.initialX),
          (this.xOffset = this.currentX),
          this.setTranslate(this.currentX, this.button));
      }
      setTranslate(e, t) {
        let s = e - this.buttonOffset,
          n = this.elWidth / 2 + e,
          a = -((this.elWidth / 2 + this.buttonOffset) * 1),
          o = this.elWidth / 2 - this.buttonOffset;
        s < a + 50
          ? ((s = a + 50), (n = 50))
          : s > o - 50 && ((s = o - 50), (n = this.elWidth - 50)),
          (t.style.transform = `translate(${s}px, -50%)`),
          (this.draggableContainer.style.width = `${n}px`);
      }
    }
    if (!customElements.get("image-compare")) {
      customElements.define("image-compare", v);
    }
    (theme.Blog = (function () {
      function e(e) {
        this.tagFilters();
      }
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          tagFilters: function () {
            var e = document.getElementById("BlogTagFilter");
            e &&
              e.addEventListener("change", function () {
                location.href = e.value;
              });
          },
        })),
        e
      );
    })()),
      (theme.CollectionHeader = (function () {
        var e = !1;
        function t(t) {
          this.namespace = ".collection-header";
          var s = t.querySelector(".collection-hero");
          s
            ? (e && this.checkIfNeedReload(),
              s.classList.remove("loading", "loading--delayed"),
              s.classList.add("loaded"))
            : theme.settings.overlayHeader &&
              theme.headerNav.disableOverlayHeader(),
            (e = !0);
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            checkIfNeedReload: function () {
              Shopify.designMode &&
                theme.settings.overlayHeader &&
                (document
                  .querySelector(".header-wrapper")
                  .classList.contains("header-wrapper--overlay") ||
                  location.reload());
            },
          })),
          t
        );
      })()),
      (theme.CollectionSidebar = (function () {
        var e = !1,
          t = { sidebar: "#CollectionSidebar" };
        function s(e) {
          this.container = e.querySelector(t.sidebar);
        }
        return (
          (s.prototype = Object.assign({}, s.prototype, {
            init: function () {
              this.container &&
                (this.onUnload(),
                (e = "drawer" === this.container.dataset.style),
                (theme.FilterDrawer = new theme.Drawers(
                  "FilterDrawer",
                  "collection-filters",
                  !0
                )));
            },
            forceReload: function () {
              this.init();
            },
            onSelect: function () {
              if (theme.FilterDrawer) {
                if (!e) {
                  theme.FilterDrawer.close();
                  return;
                }
                (e || theme.config.bpSmall) && theme.FilterDrawer.open();
              }
            },
            onDeselect: function () {
              theme.FilterDrawer && theme.FilterDrawer.close();
            },
            onUnload: function () {
              theme.FilterDrawer && theme.FilterDrawer.close();
            },
          })),
          s
        );
      })()),
      (theme.Collection = (function () {
        var e = !1,
          t = {
            sortSelect: "#SortBy",
            colorSwatchImage: ".grid-product__color-image",
            colorSwatch: ".color-swatch--with-image",
            collectionGrid: ".collection-grid__wrapper",
            trigger: ".collapsible-trigger",
            sidebar: "#CollectionSidebar",
            filterSidebar: ".collapsible-content--sidebar",
            activeTagList: ".tag-list--active-tags",
            tags: ".tag-list input",
            activeTags: ".tag-list a",
            tagsForm: ".filter-form",
            filters: ".collection-filter",
            priceRange: ".price-range",
          },
          s = {
            activeTag: "tag--active",
            removeTagParent: "tag--remove",
            filterSidebar: "collapsible-content--sidebar",
            isOpen: "is-open",
          };
        function n(e) {
          (this.container = e),
            (this.sectionId = e.getAttribute("data-section-id")),
            (this.namespace = ".collection-" + this.sectionId),
            (this.sidebar = new theme.CollectionSidebar(e)),
            (this.context = e.getAttribute("data-context")),
            (this.ajaxRenderer = new theme.AjaxRenderer({
              sections: [
                { sectionId: this.sectionId, nodeId: "CollectionAjaxContent" },
              ],
              onReplace: this.onReplaceAjaxContent.bind(this),
            })),
            this.init();
        }
        return (
          (n.prototype = Object.assign({}, n.prototype, {
            init: function () {
              this.context && "featured-collection" === this.context
                ? this.colorSwatchHovering()
                : (this.initSort(),
                  this.colorSwatchHovering(),
                  this.initFilters(),
                  this.initPriceRange(),
                  this.sidebar.init());
            },
            initSort: function () {
              (this.sortSelect = document.querySelector(t.sortSelect)),
                this.sortSelect &&
                  ((this.defaultSort = this.getDefaultSortValue()),
                  this.sortSelect.on(
                    "change" + this.namespace,
                    this.onSortChange.bind(this)
                  ));
            },
            getSortValue: function () {
              return this.sortSelect.value || this.defaultSort;
            },
            getDefaultSortValue: function () {
              return this.sortSelect.getAttribute("data-default-sortby");
            },
            onSortChange: function () {
              (this.queryParams = new URLSearchParams(window.location.search)),
                this.queryParams.set("sort_by", this.getSortValue()),
                this.queryParams.delete("page"),
                (window.location.search = this.queryParams.toString());
            },
            colorSwatchHovering: function () {
              this.container.querySelectorAll(t.colorSwatchImage).length &&
                this.container.querySelectorAll(t.colorSwatch).forEach((e) => {
                  e.addEventListener("mouseenter", () => {
                    var t = e.dataset.variantId,
                      s = e.dataset.variantImage,
                      n = this.container.querySelector(
                        ".grid-product__color-image--" + t
                      );
                    (n.style.backgroundImage = "url(" + s + ")"),
                      n.classList.add("is-active");
                  }),
                    e.addEventListener("mouseleave", () => {
                      var t = e.dataset.variantId;
                      this.container
                        .querySelector(".grid-product__color-image--" + t)
                        .classList.remove("is-active");
                    });
                });
            },
            initFilters: function () {
              document.querySelectorAll(t.tags).length &&
                (this.bindBackButton(),
                theme.config.stickyHeader &&
                  (this.setFilterStickyPosition(),
                  window.on(
                    "resize",
                    theme.utils.debounce(500, this.setFilterStickyPosition)
                  )),
                document.querySelectorAll(t.activeTags).forEach((e) => {
                  e.addEventListener("click", this.tagClick.bind(this));
                }),
                document.querySelectorAll(t.tagsForm).forEach((e) => {
                  e.addEventListener("input", this.onFormSubmit.bind(this));
                }));
            },
            initPriceRange: function () {
              let e = document.querySelectorAll(t.priceRange);
              e.forEach(
                (e) =>
                  new theme.PriceRange(e, {
                    onChange: this.renderFromFormData.bind(this),
                  })
              );
            },
            tagClick: function (t) {
              var s = t.currentTarget;
              var tt = s.innerText.trim();
                     
              if (s.getAttribute("filtername") === "Kleuren") {
                 $('.new_design_collection_breadcrumbs span.page_titles').text('');
              }
               if (s.getAttribute("filtername") === "All_testers") {
                  $('.new_design_collection_breadcrumbs span[aria-hidden="true"].filter_testers').text('');             
               }
               if (s.getAttribute("filtername") === "Allwithbestseller") {
                  $('.new_design_collection_breadcrumbs span[aria-hidden="true"].filter_all_best').text('');
               }
               if (s.getAttribute("filtername") === "All_tester2") {
                  $('.new_design_collection_breadcrumbs span[aria-hidden="true"].filter_testers').text('');
               }
                const checkedRadio = $('input[name="filter.p.m.custom.producten"]:checked');
                const radioValue = checkedRadio.val(); 
              console.log('radioValue '+radioValue);
                if (checkedRadio.length) {
                    if(radioValue == 'Muurverf'){
                       setTimeout(function(){
                    $('.tst.grid__item').addClass('Essential');
                         $('li.Essential').addClass('active');
                         },1500)  
                    }else{
                     $('.tst.grid__item').removeClass('Essential'); 
                     $('.tst.grid__item').removeClass('Classic'); 
                     $('.tst.grid__item').removeClass('Superior'); 
                    }
                    if(radioValue == 'Lakverf'){
                      setTimeout(function(){
                    $('.tst.grid__item').addClass('Mat');
                        $('li.Mat').addClass('active');
                        },1500) 
                    }
                    if(radioValue != 'Lakverf' && radioValue != 'Muurverf' ){
                        setTimeout(function(){
                    $('.tst.grid__item').addClass('show_opt');
                          },1500) 
                    }
                }
              setTimeout(function(){
                 var inptlen = document.querySelectorAll('.tag input.tag__input:checked').length;
                if (inptlen === 0) {  
                let radioInput = document.querySelector('input.tag__input[name="filter.p.m.custom.all_with_bestseller"][value="Alle kleuren"]');
                if (radioInput) {
                radioInput.click();  
                  setTimeout(function(){
                  $('.new_design_of_colors .collection-filter__item--count span').text(radioInput);
                     },500)
                }
                }
            
              },1000)

                
                
             
              if (
                (theme.FilterDrawer && theme.FilterDrawer.close(),
                s.classList.contains("no-ajax") || (t.preventDefault(), e))
              )
                return;
              e = !0;
              let n = s.parentNode,
                a = new URL(s.href);
              
              this.renderActiveTag(n, s),
                this.updateScroll(!0),
                this.startLoading(),
                this.renderCollectionPage(a.searchParams);
            },
            onFormSubmit: function (t) {
             var s = t.target;
               console.log('sssss',s)
              
                            
              if (
                (theme.FilterDrawer && theme.FilterDrawer.close(),
                s.classList.contains("no-ajax") || (t.preventDefault(), e))
              )
                return;
              e = !0;
              let n = s.closest("li"),
                a = s.closest("form"),
                o = new FormData(a);
              console.log('nn',n);
              
              this.renderActiveTag(n, s),
                this.updateScroll(!0),
                this.startLoading(),
                this.renderFromFormData(o);
            },
            fetchOpenCollasibleFilters: function () {
              return Array.from(
                document.querySelectorAll(
                  `${t.sidebar} ${t.trigger}.${s.isOpen}`
                )
              ).map((e) => e.dataset.collapsibleId);
            },
            renderActiveTag: function (e, n) {
              let a = e.querySelector(".tag__text");
              e.classList.contains(s.activeTag)
                ? e.classList.remove(s.activeTag)
                : (e.classList.add(s.activeTag),
                  n.closest("li").classList.contains(s.removeTagParent)
                    ? e.remove()
                    : document
                        .querySelectorAll(t.activeTagList)
                        .forEach((e) => {
                          let t = document.createElement("li"),
                            s = document.createElement("a");
                          t.classList.add("tag", "tag--remove"),
                            s.classList.add("btn", "btn--small"),
                            (s.innerText = a.innerText),
                            t.appendChild(s),
                            e.appendChild(t);
                          var selected_radio = $('input.tag__input[name="filter.p.m.custom.producten"]:checked').val();
   
                          console.log('vale here '+selected_radio);
                        
                                
                          function updateTextAfterAjax(targetSelector, newText, clicked_obj) {
                          var targetNode = document.querySelector(targetSelector);
                          
                          if (targetNode) {
                            if(clicked_obj == 'producten'){
                              $('span.filter_producten').show();
                              if(newText == 'Muurverf'){
                               setTimeout(function(){
                                $('.tst.grid__item').addClass('Essential');
                                 $('li.Essential').addClass('active');
                                  },1200);
                                }
                                if(newText == 'Lakverf'){
                                  console.log('textss')
                                  setTimeout(function(){
                                $('.tst.grid__item').addClass('Mat');
                                    $('li.Mat').addClass('active');
                                    },1200);
                                }
                                if(newText != 'Lakverf' && newText != 'Muurverf'){
                                  setTimeout(function(){
                                      $('.tst.grid__item').addClass('show_opt');
                                  },1200);
                                }
                              $('.filter_producten').html('&nbsp;&rsaquo;&nbsp; '+newText);
                            }else{
                              let storedColor = localStorage.getItem("selectedMuurverf");
                              console.log("Retrieved LocalStorage Value:", storedColor);
                              $('.new_design_of_colors .muurverf-vrntss_filter li').removeClass('active');
                              setTimeout(function(){
                              if(storedColor == 'Classic'){                           
                                  $('li.Classic').trigger('click'); 
                                  $('li.Classic').addClass('active')
                              }else if(storedColor == 'Essential'){
                                 $('li.Essential').trigger('click'); 
                                $('li.Essential').addClass('active')
                              }else if(storedColor == 'Superior'){
                                 $('li.Superior').trigger('click'); 
                                $('li.Superior').addClass('active')
                              }
                              },1800)
                            }
                          var observer = new MutationObserver(function (mutationsList, observer) {
                          document.querySelector(targetSelector).textContent = newText;
                          observer.disconnect(); // Stop observing after update
                          });
                          
                          observer.observe(targetNode, { childList: true, subtree: true });
                          
                          // Fallback timeout in case MutationObserver doesn't trigger
                          setTimeout(function () {
                          document.querySelector(targetSelector).textContent = newText;     
                                                  }, 2500);
                          }
                          }

                          if (n.getAttribute("filtername") === "Kleuren") {
                            var colorname = n.getAttribute("value");
                          
                            if (colorname === 'beige') {
                              colorname = '8 Original Shades';
                            } else {
                              colorname =  '8 Shades of ' +colorname;
                            }
                          
                            setTimeout(function () {
                                $('input.tag__input[name="filter.p.m.custom.all_with_bestseller"]:checked').trigger('click');
                            }, 1200);
                            $('.new_design_collection_breadcrumbs span.page_titles').text(colorname);
                            updateTextAfterAjax('.new_design_of_colors .collection-filter__item--count span', colorname);
                          }
                          
                          if (n.getAttribute("filtername") === "All_testers") {
                            var colorname = n.getAttribute("value");
                            $('.new_design_collection_breadcrumbs span[aria-hidden="true"].filter_testers').text(colorname + ' › ');
                          
                            setTimeout(function () {
                                $('input.tag__input[name="filter.p.m.custom.producten"]:checked').trigger('click');
                            }, 1200);
                          
                            updateTextAfterAjax('.new_design_of_colors .collection-filter__item--count span', colorname);
                          }
                          
                          if (n.getAttribute("filtername") === "producten") {
                            var colorname = n.getAttribute("value");
                            console.log('colorname', colorname);
                       
                            setTimeout(function () {
                            let tester2 = $('.tag-list.tag-list--active-tags [filtername="All_tester2"]');
                            let testers = $('.tag-list.tag-list--active-tags [filtername="All_testers"]');
                            
                            if (tester2.length > 0) {
                            console.log('inside tag all2');
                            tester2[0].click();
                            
                            // Wait for data to load before clicking the second button
                            setTimeout(function () {
                            testers = $('.tag-list.tag-list--active-tags [filtername="All_testers"]');
                            if (testers.length > 0) {
                            console.log('inside tag all');
                            testers[0].click();
                            }
                            }, 1500); // Adjust timing as needed
                            } else if (testers.length > 0) {
                            console.log('inside tag all');
                            testers[0].click();
                            
                            // Wait for data to load before clicking the second button
                            setTimeout(function () {
                            tester2 = $('.tag-list.tag-list--active-tags [filtername="All_tester2"]');
                            if (tester2.length > 0) {
                            console.log('inside tag all2');
                            tester2[0].click();
                            }
                            }, 1500); // Adjust timing as needed
                            }
                            }, 1200);
                  
                            updateTextAfterAjax('.new_design_of_colors .collection-filter__item--count span', colorname, 'producten');
                          }
                          if (n.getAttribute("filtername") === "All_tester") {
                            var colorname = n.getAttribute("value");
                            console.log('colorname', colorname);
                       
                            setTimeout(function () {
                            let tester2 = $('.tag-list.tag-list--active-tags [filtername="All_tester2"]');
                            let testers = $('.tag-list.tag-list--active-tags [filtername="All_testers"]');
                            
                            if (tester2.length > 0) {
                            console.log('inside tag all2');
                            tester2[0].click();
                            
                            // Wait for data to load before clicking the second button
                            setTimeout(function () {
                            testers = $('.tag-list.tag-list--active-tags [filtername="All_testers"]');
                            if (testers.length > 0) {
                            console.log('inside tag all');
                            testers[0].click();
                            }
                            }, 1500); // Adjust timing as needed
                            } else if (testers.length > 0) {
                            console.log('inside tag all');
                            testers[0].click();
                            
                            // Wait for data to load before clicking the second button
                            setTimeout(function () {
                            tester2 = $('.tag-list.tag-list--active-tags [filtername="All_tester2"]');
                            if (tester2.length > 0) {
                            console.log('inside tag all2');
                            tester2[0].click();
                            }
                            }, 1500); // Adjust timing as needed
                            }
                            }, 1200);
                  
                            updateTextAfterAjax('.new_design_of_colors .collection-filter__item--count span', colorname, 'producten');
                          }
                          
                          if (n.getAttribute("filtername") === "Allwithbestseller") {
                            var colorname = n.getAttribute("value");
                            $('.new_design_collection_breadcrumbs span[aria-hidden="true"].filter_all_best').text(colorname);
                          
                            setTimeout(function () {
                                $('input.tag__input[name="filter.p.m.custom.kleuren"]:checked').trigger('click');
                            }, 1200);
                          
                            updateTextAfterAjax('.new_design_of_colors .collection-filter__item--count span', colorname);
                          }
                          
                          if (n.getAttribute("filtername") === "All_tester2") {
                            var colorname = n.getAttribute("value");
                            $('.new_design_collection_breadcrumbs span[aria-hidden="true"].filter_testers').text(colorname + ' › ');
                          
                            updateTextAfterAjax('.new_design_of_colors .collection-filter__item--count span', colorname);
                          }
   }));
            },
       

            renderFromFormData: function (e) {
              let t = new URLSearchParams(e);
              this.renderCollectionPage(t);
            },
            onReplaceAjaxContent: function (e, t) {
              let s = this.fetchOpenCollasibleFilters();
              s.forEach((t) => {
                e.querySelectorAll(`[data-collapsible-id=${t}]`).forEach(
                  this.openCollapsible
                );
              });
              var n = e.getElementById(t.nodeId);
              n && (document.getElementById(t.nodeId).innerHTML = n.innerHTML);
            },
            openCollapsible: function (e) {
              e.classList.contains(s.filterSidebar) &&
                (e.style.height = "auto"),
                e.classList.add(s.isOpen);
            },
            renderCollectionPage: function (t, s = !0) {
              this.ajaxRenderer
                .renderPage(window.location.pathname, t, s)
                .then(() => {
                  theme.sections.reinit("collection-grid"),
                    this.updateScroll(!1),
                    this.initPriceRange(),
                    theme.reinitProductGridItem(),
                    document.dispatchEvent(
                      new CustomEvent("collection:reloaded")
                    ),
                    (e = !1);
                });
            },
            bindBackButton: function () {
              window.off("popstate" + this.namespace),
                window.on(
                  "popstate" + this.namespace,
                  function (e) {
                    if (e) {
                      let t = new URL(window.location.href);
                      this.renderCollectionPage(t.searchParams, !1);
                    }
                  }.bind(this)
                );
            },
            updateScroll: function (e) {
              var t = document.querySelector("[data-scroll-to]"),
                s = t && t.offsetTop;
              theme.config.bpSmall || (s -= 15),
                theme.config.stickyHeader &&
                  (s -= document.querySelector(".site-header").offsetHeight),
                e
                  ? window.scrollTo({ top: s, behavior: "smooth" })
                  : window.scrollTo({ top: s });
            },
            setFilterStickyPosition: function () {
              var e = document.querySelector(".site-header").offsetHeight;
              document.querySelector(t.filters).style.top = e + 10 + "px";
              var s = document.querySelector(".grid__item--sidebar");
              s && (s.style.top = e + 10 + "px");
            },
            forceReload: function () {
              this.init();
            },
            startLoading: function () {
              document.querySelector(t.collectionGrid).classList.add("unload");
            },
          })),
          n
        );
      })()),
      (theme.FooterSection = (function () {
        var e = {
          locale: "[data-disclosure-locale]",
          currency: "[data-disclosure-currency]",
        };
        function t(e) {
          (this.container = e),
            (this.localeDisclosure = null),
            (this.currencyDisclosure = null),
            this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var t = this.container.querySelector(e.locale),
                s = this.container.querySelector(e.currency);
              t && (this.localeDisclosure = new theme.Disclosure(t)),
                s && (this.currencyDisclosure = new theme.Disclosure(s));
              var n = document.querySelector(".footer__newsletter-input");
              n &&
                n.addEventListener("keyup", function () {
                  n.classList.add("footer__newsletter-input--active");
                }),
                theme.collapsibles.init(this.container);
            },
            onUnload: function () {
              this.localeDisclosure && this.localeDisclosure.destroy(),
                this.currencyDisclosure && this.currencyDisclosure.destroy();
            },
          })),
          t
        );
      })()),
      (theme.HeaderSection = (function () {
        var e = {
          locale: "[data-disclosure-locale]",
          currency: "[data-disclosure-currency]",
        };
        function t(e) {
          (this.container = e),
            (this.sectionId = this.container.getAttribute("data-section-id")),
            this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              Shopify &&
                Shopify.designMode &&
                (theme.sections.reinit("slideshow-section"),
                setTimeout(function () {
                  window.dispatchEvent(new Event("resize"));
                }, 500)),
                this.initDrawers(),
                this.initDisclosures(),
                theme.headerNav.init(),
                theme.announcementBar.init();
            },
            initDisclosures: function () {
              var t = this.container.querySelector(e.locale),
                s = this.container.querySelector(e.currency);
              t && (this.localeDisclosure = new theme.Disclosure(t)),
                s && (this.currencyDisclosure = new theme.Disclosure(s));
            },
            initDrawers: function () {
              (theme.NavDrawer = new theme.Drawers("NavDrawer", "nav")),
                "drawer" !== theme.settings.cartType ||
                  document.body.classList.contains("template-cart") ||
                  new theme.CartDrawer(),
                theme.collapsibles.init(document.getElementById("NavDrawer"));
            },
            onBlockSelect: function (e) {
              theme.announcementBar.onBlockSelect(e.detail.blockId);
            },
            onBlockDeselect: function () {
              theme.announcementBar.onBlockDeselect();
            },
            onUnload: function () {
              theme.NavDrawer.close(),
                theme.announcementBar.unload(),
                this.localeDisclosure && this.localeDisclosure.destroy(),
                this.currencyDisclosure && this.currencyDisclosure.destroy();
            },
          })),
          t
        );
      })()),
      (theme.Product = (function () {
        var e = {},
          t = {
            onSale: "on-sale",
            disabled: "disabled",
            isModal: "is-modal",
            loading: "loading",
            loaded: "loaded",
            hidden: "hide",
            interactable: "video-interactable",
            visuallyHide: "visually-invisible",
          },
          s = {
            productVideo: ".product__video",
            videoParent: ".product__video-wrapper",
            slide: ".product-main-slide",
            currentSlide: ".is-selected",
            startingSlide: ".starting-slide",
            variantType: ".variant-wrapper",
            blocks: "[data-product-blocks]",
            blocksHolder: "[data-blocks-holder]",
            dynamicVariantsEnabled: "[data-dynamic-variants-enabled]",
          };
        function n(e) {
          this.container = e;
          var t = (this.sectionId = e.getAttribute("data-section-id")),
            s = (this.productId = e.getAttribute("data-product-id"));
          (this.inModal = "true" === e.dataset.modal),
            this.modal,
            (this.settings = {
              enableHistoryState: e.dataset.history || !1,
              namespace: ".product-" + t,
              inventory: !1,
              inventoryThreshold: 10,
              modalInit: !1,
              hasImages: !0,
              imageSetName: null,
              imageSetIndex: null,
              currentImageSet: null,
              imageSize: "620x",
              currentSlideIndex: 0,
              videoLooping: e.dataset.videoLooping,
            }),
            this.inModal &&
              ((this.settings.enableHistoryState = !1),
              (this.settings.namespace = ".product-" + t + "-modal"),
              (this.modal = document.getElementById("QuickShopModal-" + s))),
            (this.selectors = {
              variantsJson: "[data-variant-json]",
              currentVariantJson: "[data-current-variant-json]",
              form: ".product-single__form",
              media: "[data-product-media-type-model]",
              closeMedia: ".product-single__close-media",
              photoThumbs: "[data-product-thumb]",
              thumbSlider: "[data-product-thumbs]",
              thumbScroller: ".product__thumbs--scroller",
              mainSlider: "[data-product-photos]",
              imageContainer: "[data-product-images]",
              productImageMain: "[data-product-image-main]",
              priceWrapper: "[data-product-price-wrap]",
              price: "[data-product-price]",
              comparePrice: "[data-compare-price]",
              savePrice: "[data-save-price]",
              priceA11y: "[data-a11y-price]",
              comparePriceA11y: "[data-compare-price-a11y]",
              unitWrapper: "[data-unit-price-wrapper]",
              unitPrice: "[data-unit-price]",
              unitPriceBaseUnit: "[data-unit-base]",
              sku: "[data-sku]",
              inventory: "[data-product-inventory]",
              incomingInventory: "[data-incoming-inventory]",
              colorLabel: "[data-variant-color-label]",
              addToCart: "[data-add-to-cart]",
              addToCartText: "[data-add-to-cart-text]",
              originalSelectorId: "[data-product-select]",
              singleOptionSelector: "[data-variant-input]",
              variantColorSwatch: ".variant__input--color-swatch",
              dynamicVariantsEnabled: "[data-dynamic-variants-enabled]",
              availabilityContainer: "[data-store-availability-holder]",
            }),
            this.cacheElements(),
            (this.firstProductImage =
              this.cache.mainSlider.querySelector("img")),
            this.firstProductImage || (this.settings.hasImages = !1);
          var n = this.cache.mainSlider.querySelector("[data-set-name]");
          n && (this.settings.imageSetName = n.dataset.setName), this.init();
        }
        return (
          (n.prototype = Object.assign({}, n.prototype, {
            init: function () {
              this.inModal &&
                (this.container.classList.add(t.isModal),
                document.addEventListener(
                  "modalOpen.QuickShopModal-" + this.productId,
                  this.openModalProduct.bind(this)
                ),
                document.addEventListener(
                  "modalClose.QuickShopModal-" + this.productId,
                  this.closeModalProduct.bind(this)
                )),
                this.inModal ||
                  (this.formSetup(),
                  this.productSetup(),
                  this.videoSetup(),
                  this.initProductSlider(),
                  this.customMediaListners(),
                  this.addIdToRecentlyViewed());
            },
            cacheElements: function () {
              this.cache = {
                form: this.container.querySelector(this.selectors.form),
                mainSlider: this.container.querySelector(
                  this.selectors.mainSlider
                ),
                thumbSlider: this.container.querySelector(
                  this.selectors.thumbSlider
                ),
                thumbScroller: this.container.querySelector(
                  this.selectors.thumbScroller
                ),
                productImageMain: this.container.querySelector(
                  this.selectors.productImageMain
                ),
                priceWrapper: this.container.querySelector(
                  this.selectors.priceWrapper
                ),
                comparePriceA11y: this.container.querySelector(
                  this.selectors.comparePriceA11y
                ),
                comparePrice: this.container.querySelector(
                  this.selectors.comparePrice
                ),
                price: this.container.querySelector(this.selectors.price),
                savePrice: this.container.querySelector(
                  this.selectors.savePrice
                ),
                priceA11y: this.container.querySelector(
                  this.selectors.priceA11y
                ),
              };
            },
            formSetup: function () {
              this.initQtySelector(),
                this.initAjaxProductForm(),
                this.availabilitySetup(),
                this.initVariants(),
                this.settings.imageSetName && this.updateImageSet();
            },
            availabilitySetup: function () {
              var e = this.container.querySelector(
                this.selectors.availabilityContainer
              );
              e && (this.storeAvailability = new theme.StoreAvailability(e));
            },
            productSetup: function () {
              this.setImageSizes(),
                this.initImageZoom(),
                this.initModelViewerLibraries(),
                this.initShopifyXrLaunch(),
                window.SPR && (SPR.initDomEls(), SPR.loadBadges());
            },
            setImageSizes: function () {
              if (this.settings.hasImages) {
                var e = this.firstProductImage.currentSrc;
                e && (this.settings.imageSize = theme.Images.imageSize(e));
              }
            },
            addIdToRecentlyViewed: function () {
              var e = this.container.getAttribute("data-product-handle"),
                t = this.container.getAttribute("data-product-url"),
                s = this.container.getAttribute("data-aspect-ratio"),
                n = this.container.getAttribute("data-img-url");
              theme.recentlyViewed.recent.hasOwnProperty(e) &&
                delete theme.recentlyViewed.recent[e],
                (theme.recentlyViewed.recent[e] = {
                  url: t,
                  aspectRatio: s,
                  featuredImage: n,
                }),
                theme.config.hasLocalStorage &&
                  window.localStorage.setItem(
                    "theme-recent",
                    JSON.stringify(theme.recentlyViewed.recent)
                  );
            },
            initVariants: function () {
              var e = this.container.querySelector(this.selectors.variantsJson);
              if (e) {
                this.variantsObject = JSON.parse(e.innerHTML);
                var t = !!this.container.querySelector(
                    s.dynamicVariantsEnabled
                  ),
                  n = {
                    container: this.container,
                    enableHistoryState: this.settings.enableHistoryState,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    variants: this.variantsObject,
                    dynamicVariantsEnabled: t,
                  },
                  a = this.container.querySelectorAll(
                    this.selectors.variantColorSwatch
                  );
                if (
                  (a.length &&
                    a.forEach((e) => {
                      e.addEventListener(
                        "change",
                        function (t) {
                          var s = e.dataset.colorName,
                            n = e.dataset.colorIndex;
                          this.updateColorName(s, n);
                        }.bind(this)
                      );
                    }),
                  (this.variants = new theme.Variants(n)),
                  this.storeAvailability)
                ) {
                  var o = this.variants.currentVariant
                    ? this.variants.currentVariant.id
                    : this.variants.variants[0].id;
                  this.storeAvailability.updateContent(o),
                    this.container.on(
                      "variantChange" + this.settings.namespace,
                      this.updateAvailability.bind(this)
                    );
                }
                this.container.on(
                  "variantChange" + this.settings.namespace,
                  this.updateCartButton.bind(this)
                ),
                  this.container.on(
                    "variantImageChange" + this.settings.namespace,
                    this.updateVariantImage.bind(this)
                  ),
                  this.container.on(
                    "variantPriceChange" + this.settings.namespace,
                    this.updatePrice.bind(this)
                  ),
                  this.container.on(
                    "variantUnitPriceChange" + this.settings.namespace,
                    this.updateUnitPrice.bind(this)
                  ),
                  this.container.querySelector(this.selectors.sku) &&
                    this.container.on(
                      "variantSKUChange" + this.settings.namespace,
                      this.updateSku.bind(this)
                    );
                var r = this.container.querySelector(this.selectors.inventory);
                if (
                  (r &&
                    ((this.settings.inventory = !0),
                    (this.settings.inventoryThreshold = r.dataset.threshold),
                    this.container.on(
                      "variantChange" + this.settings.namespace,
                      this.updateInventory.bind(this)
                    )),
                  t)
                ) {
                  var c = this.container.querySelector(
                    this.selectors.currentVariantJson
                  );
                  if (c) {
                    var l = this.container.querySelector(s.variantType);
                    l &&
                      new theme.VariantAvailability({
                        container: this.container,
                        namespace: this.settings.namespace,
                        type: l.dataset.type,
                        variantsObject: this.variantsObject,
                        currentVariantObject: JSON.parse(c.innerHTML),
                      });
                  }
                }
                if (this.settings.imageSetName) {
                  var d = this.container.querySelector(
                    '.variant-input-wrap[data-handle="' +
                      this.settings.imageSetName +
                      '"]'
                  );
                  d
                    ? ((this.settings.imageSetIndex = d.dataset.index),
                      this.container.on(
                        "variantChange" + this.settings.namespace,
                        this.updateImageSet.bind(this)
                      ))
                    : (this.settings.imageSetName = null);
                }
              }
            },
            initQtySelector: function () {
              console.log(this);
              window.this_t = this;
              this.container
                .querySelectorAll(".js-qty__wrapper")
                .forEach((e) => {
                  console.log("here");
                  
                  new theme.QtySelector(e, { namespace: ".product" });
                });
            },
            initAjaxProductForm: function () {
              "drawer" === theme.settings.cartType &&
                new theme.AjaxProduct(this.cache.form);
            },
            updateColorName: function (e, t) {
              this.container.querySelector(
                this.selectors.colorLabel + `[data-index="${t}"`
              ).textContent = e;
            },
            updateCartButton: function (e) {


            // start image crosal images
              let checkedImage = ''
               if($('body').hasClass('lakverf')){
                 var checkval = $('body.muurverf-page.new-products.lakverf .variant-wrapper.variant-wrapper--custom--button.js[data-option=Afwerking] input:checked+label.variant__button-label').attr('checkc')
                 checkedImage = $(`body.muurverf-page .variant-wrapper .variant-input-wrap:not([name=Kleur]) input:checked+label img[varissecond="${checkval}"]`).attr('src')
               }else{
                 checkedImage = $('body.muurverf-page .variant-wrapper .variant-input-wrap:not([name=Kleur]) input:checked+label img').attr('src')
               }
            
            const newImage = {
              url: checkedImage
            };
            const images = window.currentvariant?.images?.nodes;
            const variants = window.currentvariant?.variants?.nodes;
            const variantUrls = new Set( variants .map(v => v.image && v.image.url) .filter(Boolean) );
            const filteredImages = images.filter(image => !variantUrls.has(image.url));
            filteredImages.push(newImage); 
            $('.pro_featured_images').empty();
            filteredImages.forEach((image, index) => {
                      const newColorDiv = `
                        <div class="pro_thumb" match="" data-product>
                          <img width="" height="" loading="lazy" alt="" src="${image?.url}">
                        </div>`;
                      $('.pro_featured_images').append(newColorDiv);
            });  
            // endcode
              var s = e.detail.variant,
                n = this.container.querySelector(this.selectors.addToCart),
                a = this.container.querySelector(this.selectors.addToCartText);
              if (n) {
                if (s) {
                  if (s.available) {
                    n.classList.remove(t.disabled), (n.disabled = !1);
                    var o = a.dataset.defaultText;
                    if(window.datahide == 'true'){
                      console.log('window.hidee_pricee',window.datahide)
                      a.textContent = o.replace('-', '');
                    }else{
                       console.log('window.hidee_priceeelse',window.datahide)
                      a.textContent = o;
                    }
                    
                  } else
                    n.classList.add(t.disabled),
                      (n.disabled = !0),
                      (a.textContent = theme.strings.soldOut);
                } else
                  n.classList.add(t.disabled),
                    (n.disabled = !0),
                    (a.textContent = theme.strings.unavailable);
              }
            },
            updatePrice: function (e) {
              var s = e.detail.variant;
              if (s) {
                if (
                  ((this.cache.price.innerHTML = theme.Currency.formatMoney(
                    s.price,
                    theme.settings.moneyFormat
                  )),
                  s.compare_at_price > s.price)
                ) {
                  (this.cache.comparePrice.innerHTML =
                    theme.Currency.formatMoney(
                      s.compare_at_price,
                      theme.settings.moneyFormat
                    )),
                    this.cache.priceWrapper.classList.remove(t.hidden),
                    this.cache.price.classList.add(t.onSale),
                    this.cache.comparePriceA11y.setAttribute(
                      "aria-hidden",
                      "false"
                    ),
                    this.cache.priceA11y.setAttribute("aria-hidden", "false");
                  var n = s.compare_at_price - s.price;
                  (n =
                    "percent" == theme.settings.saveType
                      ? Math.round((100 * n) / s.compare_at_price) + "%"
                      : theme.Currency.formatMoney(
                          n,
                          theme.settings.moneyFormat
                        )),
                    this.cache.savePrice.classList.remove(t.hidden),
                    (this.cache.savePrice.innerHTML =
                      theme.strings.savePrice.replace("[saved_amount]", n));
                } else
                  this.cache.priceWrapper &&
                    this.cache.priceWrapper.classList.add(t.hidden),
                    this.cache.savePrice.classList.add(t.hidden),
                    this.cache.price.classList.remove(t.onSale),
                    this.cache.comparePriceA11y &&
                      this.cache.comparePriceA11y.setAttribute(
                        "aria-hidden",
                        "true"
                      ),
                    this.cache.priceA11y.setAttribute("aria-hidden", "true");
              }
            },
            updateUnitPrice: function (e) {
              var s = e.detail.variant;
              s && s.unit_price
                ? ((this.container.querySelector(
                    this.selectors.unitPrice
                  ).innerHTML = theme.Currency.formatMoney(
                    s.unit_price,
                    theme.settings.moneyFormat
                  )),
                  (this.container.querySelector(
                    this.selectors.unitPriceBaseUnit
                  ).innerHTML = theme.Currency.getBaseUnit(s)),
                  this.container
                    .querySelector(this.selectors.unitWrapper)
                    .classList.remove(t.hidden))
                : this.container
                    .querySelector(this.selectors.unitWrapper)
                    .classList.add(t.hidden);
            },
            imageSetArguments: function (e) {
              var e =
                e || (this.variants ? this.variants.currentVariant : null);
              if (e) {
                var t = (this.settings.currentImageSet = this.getImageSetName(
                    e[this.settings.imageSetIndex]
                  )),
                  s = this.settings.imageSetName + "_" + t;
                return (
                  (this.settings.currentSlideIndex = 0),
                  {
                    cellSelector: '[data-group="' + s + '"]',
                    imageSet: s,
                    initialIndex: this.settings.currentSlideIndex,
                  }
                );
              }
            },
            updateImageSet: function (e) {
              var t = e
                ? e.detail.variant
                : this.variants
                ? this.variants.currentVariant
                : null;
              if (t) {
                var s = this.getImageSetName(t[this.settings.imageSetIndex]);
                this.settings.currentImageSet !== s &&
                  this.initProductSlider(t);
              }
            },
            updateImageSetThumbs: function (e) {
              this.cache.thumbSlider
                .querySelectorAll(".product__thumb-item")
                .forEach((s) => {
                  s.classList.toggle(t.hidden, s.dataset.group !== e);
                });
            },
            getImageSetName: function (e) {
              return e
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-$/, "")
                .replace(/^-/, "");
            },
            updateSku: function (e) {
              var t = e.detail.variant,
                s = "";
              t &&
                (t.sku && (s = t.sku),
                (this.container.querySelector(this.selectors.sku).textContent =
                  s));
            },
            updateInventory: function (e) {
              var t = e.detail.variant;
              if (
                !t ||
                !t.inventory_management ||
                "continue" === t.inventory_policy
              ) {
                this.toggleInventoryQuantity(t, !1),
                  this.toggleIncomingInventory(!1);
                return;
              }
              if (
                "shopify" === t.inventory_management &&
                window.inventories &&
                window.inventories[this.productId]
              ) {
                var s = window.inventories[this.productId][t.id],
                  n = s.quantity,
                  a = !0,
                  o = !1;
                (n <= 0 ||
                  n > this.settings.inventoryThreshold ||
                  "continue" === s.policy) &&
                  (a = !1),
                  this.toggleInventoryQuantity(t, s),
                  a &&
                    "true" === s.incoming &&
                    n <= this.settings.inventoryThreshold &&
                    (o = !0),
                  this.toggleIncomingInventory(
                    o,
                    t.available,
                    s.next_incoming_date
                  );
              }
            },
            updateAvailability: function (e) {
              var t = e.detail.variant;
              t && this.storeAvailability.updateContent(t.id);
            },
            toggleInventoryQuantity: function (e, s) {
              let { quantity: n, policy: a } = s || {};
              if (this.settings.inventory) {
                var o = this.container.querySelector(this.selectors.inventory),
                  r = o.closest(".product-block");
                parseInt(n) <= parseInt(this.settings.inventoryThreshold) &&
                "continue" !== a
                  ? (o.parentNode.classList.add("inventory--low"),
                    n > 1
                      ? (o.textContent = theme.strings.otherStockLabel.replace(
                          "[count]",
                          n
                        ))
                      : (o.textContent = theme.strings.oneStockLabel.replace(
                          "[count]",
                          n
                        )))
                  : (o.parentNode.classList.remove("inventory--low"),
                    (o.textContent = theme.strings.inStockLabel)),
                  e && e.available
                    ? (o.parentNode.classList.remove(t.hidden),
                      r && r.classList.remove(t.hidden))
                    : (o.parentNode.classList.add(t.hidden),
                      r && r.classList.add(t.hidden));
              }
            },
            toggleIncomingInventory: function (e, s, n) {
              var a = this.container.querySelector(
                this.selectors.incomingInventory
              );
              if (a) {
                var o = a.closest(".product-block"),
                  r = a.querySelector(".js-incoming-text");
                if (e) {
                  var c = s
                    ? theme.strings.willNotShipUntil.replace("[date]", n)
                    : theme.strings.willBeInStockAfter.replace("[date]", n);
                  n || (c = theme.strings.waitingForStock),
                    a.classList.remove(t.hidden),
                    o && o.classList.remove(t.hidden),
                    (r.textContent = c);
                } else a.classList.add(t.hidden);
              }
            },
            videoSetup: function () {
              var e = this.cache.mainSlider.querySelectorAll(s.productVideo);
              if (!e.length) return !1;
              e.forEach((e) => {
                var t = e.dataset.videoType;
                "youtube" === t
                  ? this.initYoutubeVideo(e)
                  : "vimeo" === t
                  ? this.initVimeoVideo(e)
                  : "mp4" === t && this.initMp4Video(e);
              });
            },
            initYoutubeVideo: function (t) {
              e[t.id] = new theme.YouTube(t.id, {
                videoId: t.dataset.videoId,
                videoParent: s.videoParent,
                autoplay: !1,
                style: t.dataset.videoStyle,
                loop: t.dataset.videoLoop,
                events: {
                  onReady: this.youtubePlayerReady.bind(this),
                  onStateChange: this.youtubePlayerStateChange.bind(this),
                },
              });
            },
            initVimeoVideo: function (t) {
              e[t.id] = new theme.VimeoPlayer(t.id, t.dataset.videoId, {
                videoParent: s.videoParent,
                autoplay: !1,
                style: t.dataset.videoStyle,
                loop: t.dataset.videoLoop,
              });
            },
            youtubePlayerReady: function (t) {
              var s = t.target.getIframe().id;
              if (e[s]) {
                var n = e[s],
                  a = n.videoPlayer;
                "sound" !== n.options.style && a.mute(),
                  n.parent.classList.remove("loading"),
                  n.parent.classList.add("loaded"),
                  n.parent.classList.add("video-interactable"),
                  this._isFirstSlide(s) &&
                    "sound" !== n.options.style &&
                    a.playVideo();
              }
            },
            _isFirstSlide: function (e) {
              return this.cache.mainSlider.querySelector(
                s.startingSlide + " #" + e
              );
            },
            youtubePlayerStateChange: function (t) {
              var s = e[t.target.getIframe().id];
              switch (t.data) {
                case -1:
                  s.attemptedToPlay &&
                    s.parent.classList.add("video-interactable");
                  break;
                case 0:
                  s && "true" === s.options.loop && s.videoPlayer.playVideo();
                  break;
                case 3:
                  s.attemptedToPlay = !0;
              }
            },
            initMp4Video: function (t) {
              (e[t.id] = { id: t.id, type: "mp4" }),
                this._isFirstSlide(t.id) && this.playMp4Video(t.id);
            },
            stopVideos: function () {
              for (var [t, s] of Object.entries(e))
                s.videoPlayer
                  ? "function" == typeof s.videoPlayer.stopVideo &&
                    s.videoPlayer.stopVideo()
                  : "mp4" === s.type && this.stopMp4Video(s.id);
            },
            _getVideoType: function (e) {
              return e.getAttribute("data-video-type");
            },
            _getVideoDivId: function (e) {
              return e.id;
            },
            playMp4Video: function (e) {
              var t = this.container.querySelector("#" + e),
                n = t.play();
              void 0 !== n &&
                n
                  .then(function () {})
                  .catch(function (e) {
                    t.setAttribute("controls", ""),
                      t
                        .closest(s.videoParent)
                        .setAttribute("data-video-style", "unmuted");
                  });
            },
            stopMp4Video: function (e) {
              var t = this.container.querySelector("#" + e);
              t && "function" == typeof t.pause && t.pause();
            },
            initImageZoom: function () {
              var e = this.container.querySelector(
                this.selectors.imageContainer
              );
              e &&
                (new theme.Photoswipe(e, this.sectionId),
                e.addEventListener(
                  "photoswipe:afterChange",
                  function (e) {
                    this.flickity && this.flickity.goToSlide(e.detail.index);
                  }.bind(this)
                ));
            },
            getThumbIndex: function (e) {
              return e.dataset.index;
            },
            updateVariantImage: function (e) {
              var t = e.detail.variant;
              theme.Images.getSizedImageUrl(
                t.featured_media.preview_image.src,
                this.settings.imageSize
              );
              var s = this.container.querySelector(
                  '.product__thumb[data-id="' + t.featured_media.id + '"]'
                ),
                n = this.getThumbIndex(s);
              void 0 !== n && this.flickity && this.flickity.goToSlide(n);
            },
            initProductSlider: function (e) {
              if (this.cache.mainSlider.querySelectorAll(s.slide).length <= 1) {
                var t = this.cache.mainSlider.querySelector(s.slide);
                t && t.classList.add("is-selected");
                return;
              }
              if (
                (this.flickity &&
                  "function" == typeof this.flickity.destroy &&
                  this.flickity.destroy(),
                !e)
              ) {
                var n = this.cache.mainSlider.querySelector(s.startingSlide);
                this.settings.currentSlideIndex = this._slideIndex(n);
              }
              var a = {
                dragThreshold: 25,
                adaptiveHeight: !0,
                avoidReflow: !0,
                initialIndex: this.settings.currentSlideIndex,
                childNav: this.cache.thumbSlider,
                childNavScroller: this.cache.thumbScroller,
                childVertical:
                  "beside" === this.cache.thumbSlider.dataset.position,
                pageDots: !0,
                wrapAround: !0,
                callbacks: {
                  onInit: this.onSliderInit.bind(this),
                  onChange: this.onSlideChange.bind(this),
                },
              };
              this.settings.imageSetName &&
                ((a = Object.assign({}, a, this.imageSetArguments(e))),
                this.updateImageSetThumbs(a.imageSet)),
                (this.flickity = new theme.Slideshow(this.cache.mainSlider, a));
            },
            onSliderInit: function (e) {
              this.settings.imageSetName && this.prepMediaOnSlide(e);
            },
            onSlideChange: function (e) {
              if (this.flickity) {
                var t = this.cache.mainSlider.querySelector(
                    '.product-main-slide[data-index="' +
                      this.settings.currentSlideIndex +
                      '"]'
                  ),
                  s = this.settings.imageSetName
                    ? this.cache.mainSlider.querySelectorAll(
                        ".flickity-slider .product-main-slide"
                      )[e]
                    : this.cache.mainSlider.querySelector(
                        '.product-main-slide[data-index="' + e + '"]'
                      );
                t.setAttribute("tabindex", "-1"),
                  s.setAttribute("tabindex", 0),
                  this.stopMediaOnSlide(t),
                  this.prepMediaOnSlide(s),
                  (this.settings.currentSlideIndex = e);
              }
            },
            stopMediaOnSlide(t) {
              var n = t.querySelector(s.productVideo);
              if (n) {
                var a = this._getVideoType(n),
                  o = this._getVideoDivId(n);
                if ("youtube" === a) {
                  if (e[o].videoPlayer) {
                    e[o].videoPlayer.stopVideo();
                    return;
                  }
                } else if ("mp4" === a) {
                  this.stopMp4Video(o);
                  return;
                }
              }
              var r = t.querySelector(this.selectors.media);
              r &&
                r.dispatchEvent(
                  new CustomEvent("mediaHidden", {
                    bubbles: !0,
                    cancelable: !0,
                  })
                );
            },
            prepMediaOnSlide(t) {
              var n = t.querySelector(s.productVideo);
              if (n) {
                this.flickity.reposition();
                var a = this._getVideoType(n),
                  o = this._getVideoDivId(n);
                if ("youtube" === a) {
                  if (e[o].videoPlayer && "sound" !== e[o].options.style) {
                    e[o].videoPlayer.playVideo();
                    return;
                  }
                } else "mp4" === a && this.playMp4Video(o);
              }
              var r = t.querySelector(this.selectors.media);
              r &&
                (r.dispatchEvent(
                  new CustomEvent("mediaVisible", {
                    bubbles: !0,
                    cancelable: !0,
                  })
                ),
                t
                  .querySelector(".shopify-model-viewer-ui__button")
                  .setAttribute("tabindex", 0),
                t
                  .querySelector(".product-single__close-media")
                  .setAttribute("tabindex", 0));
            },
            _slideIndex: function (e) {
              return e.getAttribute("data-index");
            },
            openModalProduct: function () {
              var e = !1;
              this.settings.modalInit
                ? (e = !0)
                : ((this.blocksHolder = this.container.querySelector(
                    s.blocksHolder
                  )),
                  fetch(this.blocksHolder.dataset.url)
                    .then(function (e) {
                      return e.text();
                    })
                    .then(
                      function (e) {
                        var t = new DOMParser()
                          .parseFromString(e, "text/html")
                          .querySelector(s.blocks);
                        t.querySelectorAll("[id]").forEach((e) => {
                          var s = e.getAttribute("id");
                          e.setAttribute("id", s + "-modal");
                          var n = t.querySelector(`[for="${s}"]`);
                          n && n.setAttribute("for", s + "-modal");
                          var a = t.querySelector(`[aria-controls="${s}"]`);
                          a && a.setAttribute("aria-controls", s + "-modal");
                        });
                        var n = t.querySelector(this.selectors.form);
                        if (n) {
                          var a = n.getAttribute("id");
                          t.querySelectorAll("[form]").forEach((e) => {
                            e.setAttribute("form", a);
                          });
                        }
                        (this.blocksHolder.innerHTML = ""),
                          this.blocksHolder.append(t),
                          this.blocksHolder.classList.add(
                            "product-form-holder--loaded"
                          ),
                          this.cacheElements(),
                          this.formSetup(),
                          this.updateModalProductInventory(),
                          Shopify &&
                            Shopify.PaymentButton &&
                            Shopify.PaymentButton.init(),
                          theme.collapsibles.init(this.container),
                          document.dispatchEvent(
                            new CustomEvent("quickview:loaded", {
                              detail: { productId: this.productId },
                            })
                          );
                      }.bind(this)
                    ),
                  this.productSetup(),
                  this.videoSetup(),
                  this.settings.imageSetName
                    ? this.variants
                      ? this.initProductSlider()
                      : document.addEventListener(
                          "quickview:loaded",
                          function (e) {
                            e.detail.productId === this.productId &&
                              this.initProductSlider();
                          }.bind(this)
                        )
                    : this.initProductSlider(),
                  this.customMediaListners(),
                  this.addIdToRecentlyViewed(),
                  (this.settings.modalInit = !0)),
                AOS.refreshHard(),
                document.dispatchEvent(
                  new CustomEvent("quickview:open", {
                    detail: { initialized: e, productId: this.productId },
                  })
                );
            },
            updateModalProductInventory: function () {
              (window.inventories = window.inventories || {}),
                this.container
                  .querySelectorAll(".js-product-inventory-data")
                  .forEach((e) => {
                    var t = e.dataset.productId;
                    (window.inventories[t] = {}),
                      e
                        .querySelectorAll(".js-variant-inventory-data")
                        .forEach((e) => {
                          window.inventories[t][e.dataset.id] = {
                            quantity: e.dataset.quantity,
                            policy: e.dataset.policy,
                            incoming: e.dataset.incoming,
                            next_incoming_date: e.dataset.date,
                          };
                        });
                  });
            },
            closeModalProduct: function () {
              this.stopVideos();
            },
            initModelViewerLibraries: function () {
              var e = this.container.querySelectorAll(this.selectors.media);
              e.length < 1 || theme.ProductMedia.init(e, this.sectionId);
            },
            initShopifyXrLaunch: function () {
              document.addEventListener(
                "shopify_xr_launch",
                function () {
                  this.container
                    .querySelector(
                      this.selectors.productMediaWrapper +
                        ":not(." +
                        self.classes.hidden +
                        ")"
                    )
                    .dispatchEvent(
                      new CustomEvent("xrLaunch", {
                        bubbles: !0,
                        cancelable: !0,
                      })
                    );
                }.bind(this)
              );
            },
            customMediaListners: function () {
              document
                .querySelectorAll(this.selectors.closeMedia)
                .forEach((e) => {
                  e.addEventListener(
                    "click",
                    function () {
                      var e = this.cache.mainSlider
                        .querySelector(s.currentSlide)
                        .querySelector(this.selectors.media);
                      e &&
                        e.dispatchEvent(
                          new CustomEvent("mediaHidden", {
                            bubbles: !0,
                            cancelable: !0,
                          })
                        );
                    }.bind(this)
                  );
                });
              var e = this.container.querySelectorAll("model-viewer");
              e.length &&
                e.forEach((e) => {
                  e.addEventListener(
                    "shopify_model_viewer_ui_toggle_play",
                    function (e) {
                      this.mediaLoaded(e);
                    }.bind(this)
                  ),
                    e.addEventListener(
                      "shopify_model_viewer_ui_toggle_pause",
                      function (e) {
                        this.mediaUnloaded(e);
                      }.bind(this)
                    );
                });
            },
            mediaLoaded: function (e) {
              this.container
                .querySelectorAll(this.selectors.closeMedia)
                .forEach((e) => {
                  e.classList.remove(t.hidden);
                }),
                this.flickity && this.flickity.setDraggable(!1);
            },
            mediaUnloaded: function (e) {
              this.container
                .querySelectorAll(this.selectors.closeMedia)
                .forEach((e) => {
                  e.classList.add(t.hidden);
                }),
                this.flickity && this.flickity.setDraggable(!0);
            },
            onUnload: function () {
              theme.ProductMedia.removeSectionModels(this.sectionId),
                this.flickity &&
                  "function" == typeof this.flickity.destroy &&
                  this.flickity.destroy();
            },
          })),
          n
        );
      })()),
      (theme.RecentlyViewed = (function () {
        var e = !1;
        function t(e) {
          e &&
            ((this.container = e),
            (this.sectionId = this.container.getAttribute("data-section-id")),
            (this.namespace = ".recently-viewed" + this.sectionId),
            (this.gridItemWidth = this.container.getAttribute(
              "data-grid-item-class"
            )),
            (this.rowOf = this.container.getAttribute("data-row-of")),
            (this.imageSizes = this.container.getAttribute("data-image-sizes")),
            theme.initWhenVisible({
              element: this.container,
              callback: this.init.bind(this),
              threshold: 600,
            }));
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              if (!e) {
                if (
                  ((e = !0),
                  0 === Object.keys(theme.recentlyViewed.recent).length &&
                    theme.recentlyViewed.recent.constructor === Object)
                ) {
                  this.container.classList.add("hide");
                  return;
                }
                (this.outputContainer = document.getElementById(
                  "RecentlyViewed-" + this.sectionId
                )),
                  (this.handle = this.container.getAttribute(
                    "data-product-handle"
                  ));
                var t = [];
                Object.keys(theme.recentlyViewed.recent).forEach(
                  function (e) {
                    "undefined" !== e && t.push(this.getProductInfo(e));
                  }.bind(this)
                ),
                  Promise.all(t).then(
                    function (e) {
                      this.setupOutput(e), this.captureProductDetails(e);
                    }.bind(this)
                  );
              }
            },
            getProductInfo: function (e) {
              return new Promise(function (t, s) {
                theme.recentlyViewed.productInfo.hasOwnProperty(e)
                  ? t(theme.recentlyViewed.productInfo[e])
                  : fetch("/products/" + e + ".js")
                      .then(function (e) {
                        return e.text();
                      })
                      .then(function (e) {
                        t(e);
                      });
              });
            },
            setupOutput: function (e) {
              var t = [],
                s = this.container.getAttribute("data-recent-count"),
                n = 0;
              if (
                (Object.keys(e).forEach(
                  function (s) {
                    if (e[s]) {
                      var a = JSON.parse(e[s]);
                      if (a.handle !== this.handle && void 0 !== a.handle) {
                        n++,
                          (a.url = theme.recentlyViewed.recent[a.handle]
                            ? theme.recentlyViewed.recent[a.handle].url
                            : a.url),
                          (a.image_responsive_url = theme.Images.buildImagePath(
                            a.featured_image
                          )),
                          (a.image_responsive_urls =
                            theme.Images.buildImagePath(
                              a.featured_image,
                              [180, 360, 540, 720, 900]
                            )),
                          (a.image_aspect_ratio =
                            theme.recentlyViewed.recent[a.handle].aspectRatio);
                        var o = a.variants[0];
                        if (o && o.unit_price) {
                          var r = "";
                          o.unit_price_measurement &&
                            (1 != o.unit_price_measurement.reference_value &&
                              (r +=
                                o.unit_price_measurement.reference_value + " "),
                            (r += o.unit_price_measurement.reference_unit)),
                            (a.unit_price = theme.Currency.formatMoney(
                              o.unit_price
                            )),
                            "" != r && (a.unit_price += "/" + r);
                        }
                        t.unshift(a);
                      }
                    }
                  }.bind(this)
                ),
                0 === t.length)
              ) {
                this.container.classList.add("hide");
                return;
              }
              var a = theme.buildProductGridItem(
                t.slice(0, s),
                this.gridItemWidth,
                this.rowOf,
                this.imageSizes
              );
              (this.outputContainer.innerHTML = a), AOS && AOS.refreshHard();
            },
            captureProductDetails: function (e) {
              for (var t = 0; t < e.length; t++) {
                var s = e[t];
                theme.recentlyViewed.productInfo[s.handle] = s;
              }
              theme.config.hasSessionStorage &&
                sessionStorage.setItem(
                  "recent-products",
                  JSON.stringify(theme.recentlyViewed.productInfo)
                );
            },
            onUnload: function () {
              e = !1;
            },
          })),
          t
        );
      })()),
      (theme.Testimonials = (function () {
        var e = {
          adaptiveHeight: !0,
          avoidReflow: !0,
          pageDots: !0,
          prevNextButtons: !1,
        };
        function t(e) {
          (this.container = e), this.timeout;
          var t = e.getAttribute("data-section-id");
          (this.slideshow = e.querySelector("#Testimonials-" + t)),
            (this.namespace = ".testimonial-" + t),
            this.slideshow &&
              theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
                threshold: 600,
              });
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              this.slideshow.dataset.count <= 3 && (e.wrapAround = !1),
                (this.flickity = new theme.Slideshow(this.slideshow, e)),
                this.slideshow.dataset.count > 2 &&
                  (this.timeout = setTimeout(
                    function () {
                      this.flickity.goToSlide(1);
                    }.bind(this),
                    1e3
                  ));
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
            onBlockSelect: function (e) {
              var t = parseInt(
                this.slideshow.querySelector(
                  ".testimonials-slide--" + e.detail.blockId
                ).dataset.index
              );
              clearTimeout(this.timeout),
                this.flickity &&
                  "function" == typeof this.flickity.pause &&
                  (this.flickity.goToSlide(t), this.flickity.pause());
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
          })),
          t
        );
      })()),
      (theme.isStorageSupported = function (e) {
        if (window.self !== window.top) return !1;
        var t,
          s = "test";
        "session" === e && (t = window.sessionStorage),
          "local" === e && (t = window.localStorage);
        try {
          return t.setItem(s, "1"), t.removeItem(s), !0;
        } catch (n) {
          return !1;
        }
      }),
      (theme.reinitProductGridItem = function (e) {
        AOS && AOS.refreshHard(),
          theme.initQuickShop(),
          window.SPR && (SPR.initDomEls(), SPR.loadBadges()),
          theme.collapsibles.init();
      }),
      (theme.config.hasSessionStorage = theme.isStorageSupported("session")),
      (theme.config.hasLocalStorage = theme.isStorageSupported("local")),
      AOS.init({
        easing: "ease-out-quad",
        once: !0,
        offset: 60,
        disableMutationObserver: !0,
      }),
      theme.config.hasLocalStorage &&
        ((theme.recentlyViewed.localStorage =
          window.localStorage.getItem("theme-recent")),
        theme.recentlyViewed.localStorage &&
          (theme.recentlyViewed.recent = JSON.parse(
            theme.recentlyViewed.localStorage
          ))),
      (theme.recentlyViewed.productInfo =
        theme.config.hasSessionStorage && sessionStorage["recent-products"]
          ? JSON.parse(sessionStorage["recent-products"])
          : {}),
      (theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches),
      matchMedia(theme.config.mediaQuerySmall).addListener(function (e) {
        e.matches
          ? ((theme.config.bpSmall = !0),
            document.dispatchEvent(new CustomEvent("matchSmall")))
          : ((theme.config.bpSmall = !1),
            document.dispatchEvent(new CustomEvent("unmatchSmall")));
      }),
      (theme.initGlobals = function () {
        theme.collapsibles.init(), theme.videoModal();
      }),
      (c = function () {
        if (
          ((theme.sections = new theme.Sections()),
          theme.sections.register("slideshow-section", theme.SlideshowSection),
          theme.sections.register("header", theme.HeaderSection),
          theme.sections.register("product", theme.Product),
          theme.sections.register("blog", theme.Blog),
          theme.sections.register("password-header", theme.PasswordHeader),
          theme.sections.register("photoswipe", theme.Photoswipe),
          theme.sections.register("background-image", theme.BackgroundImage),
          theme.sections.register("testimonials", theme.Testimonials),
          theme.sections.register("video-section", theme.VideoSection),
          theme.sections.register("map", theme.Maps),
          theme.sections.register("footer-section", theme.FooterSection),
          theme.sections.register(
            "store-availability",
            theme.StoreAvailability
          ),
          theme.sections.register("recently-viewed", theme.RecentlyViewed),
          theme.sections.register("newsletter-popup", theme.NewsletterPopup),
          theme.sections.register("collection-header", theme.CollectionHeader),
          theme.sections.register("collection-grid", theme.Collection),
          theme.initGlobals(),
          theme.initQuickShop(),
          theme.rteInit(),
          document.body.classList.contains("template-cart"))
        ) {
          var e = document.getElementById("CartPageForm");
          e && new theme.CartForm(e);
        }
        theme.settings.predictiveSearch && theme.predictiveSearch.init(),
          theme.settings.isCustomerTemplate && theme.customerTemplates(),
          document.dispatchEvent(new CustomEvent("page:loaded"));
      }),
      "loading" != document.readyState
        ? c()
        : document.addEventListener("DOMContentLoaded", c);
  })();
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++)
  links[i].hostname !== window.location.hostname &&
    ((links[i].target = "_self"), (links[i].rel = "noreferrer noopener"));

document.querySelectorAll('.download-datasheet').forEach(function(el) {
  el.setAttribute('target', '_blank');
});
$(".Color_Details_Card .qtybox .btnqty").on("click", function () {
  var e = parseInt($(this).parent(".qtybox").find(".quantity-input").val());
  $(this).hasClass("qtyplus") ? e++ : e > 1 && e--,
    (e = isNaN(e) ? 1 : e),
    $(this).parent(".qtybox").find(".quantity-input").val(e);
}),
  $(document).ready(function () {
    // $('.js-qty__num').val('1');
    $(".template-product [data-product-blocks] .product-block").each(
      function () {
        1 ==
          $(
            ".template-product [data-product-blocks] .product-block .variant-wrapper.variant-wrapper--custom--button"
          ).length &&
          $(".variant-wrapper.variant-wrapper--custom--button")
            .parent(".product-block")
            .next(".product-block")
            .addClass("single_option");
      }
    )
  });


